/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(129);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	var _domready = __webpack_require__(4);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _subscribePopup = __webpack_require__(5);
	
	var _subscribePopup2 = _interopRequireDefault(_subscribePopup);
	
	var _globalHeader = __webpack_require__(8);
	
	var _globalHeader2 = _interopRequireDefault(_globalHeader);
	
	var _scrollBtn = __webpack_require__(30);
	
	var _scrollBtn2 = _interopRequireDefault(_scrollBtn);
	
	var _accordion = __webpack_require__(32);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _pageHero = __webpack_require__(33);
	
	var _pageHero2 = _interopRequireDefault(_pageHero);
	
	var _slider = __webpack_require__(34);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _inView = __webpack_require__(126);
	
	var _inView2 = _interopRequireDefault(_inView);
	
	var _terrenSelect = __webpack_require__(128);
	
	var _terrenSelect2 = _interopRequireDefault(_terrenSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	
	(0, _domready2.default)(function () {
	
	  if (touchDevice) {
	    document.body.classList.add('touch');
	  }
	
	  document.queryAll('.in-view').forEach(function (element) {
	    new _inView2.default({
	      element: element
	    });
	  });
	
	  document.queryAll('[data-component="scroll-btn"]').forEach(function (element) {
	    new _scrollBtn2.default({
	      element: element
	    });
	  });
	
	  document.queryAll('[data-component="subscribe-popup"]').forEach(function (element) {
	    new _subscribePopup2.default({
	      element: element
	    });
	  });
	
	  document.queryAll('[data-component="global-header"]').forEach(function (element) {
	    new _globalHeader2.default({
	      element: element
	    });
	  });
	
	  document.queryAll('[data-component="accordion"]').forEach(function (element) {
	    new _accordion2.default({
	      element: element
	    });
	  });
	
	  document.queryAll('[data-component="page-hero"]').forEach(function (element) {
	    new _pageHero2.default({
	      element: element
	    });
	  });
	
	  document.queryAll('[data-component="slider"]').forEach(function (element) {
	    new _slider2.default({
	      element: element
	    });
	  });
	
	  document.queryAll('[data-component="terren-select"]').forEach(function (element) {
	    new _terrenSelect2.default({
	      element: element
	    });
	  });
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*!
	Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	*/
	(function(window){'use strict';
	  /* jshint loopfunc: true, noempty: false*/
	  // http://www.w3.org/TR/dom/#element
	
	  function createDocumentFragment() {
	    return document.createDocumentFragment();
	  }
	
	  function createElement(nodeName) {
	    return document.createElement(nodeName);
	  }
	
	  function enoughArguments(length, name) {
	    if (!length) throw new Error(
	      'Failed to construct ' +
	        name +
	      ': 1 argument required, but only 0 present.'
	    );
	  }
	
	  function mutationMacro(nodes) {
	    if (nodes.length === 1) {
	      return textNodeIfString(nodes[0]);
	    }
	    for (var
	      fragment = createDocumentFragment(),
	      list = slice.call(nodes),
	      i = 0; i < nodes.length; i++
	    ) {
	      fragment.appendChild(textNodeIfString(list[i]));
	    }
	    return fragment;
	  }
	
	  function textNodeIfString(node) {
	    return typeof node === 'string' ? document.createTextNode(node) : node;
	  }
	
	  for(var
	    head,
	    property,
	    TemporaryPrototype,
	    TemporaryTokenList,
	    wrapVerifyToken,
	    document = window.document,
	    hOP = Object.prototype.hasOwnProperty,
	    defineProperty = Object.defineProperty || function (object, property, descriptor) {
	      if (hOP.call(descriptor, 'value')) {
	        object[property] = descriptor.value;
	      } else {
	        if (hOP.call(descriptor, 'get'))
	          object.__defineGetter__(property, descriptor.get);
	        if (hOP.call(descriptor, 'set'))
	          object.__defineSetter__(property, descriptor.set);
	      }
	      return object;
	    },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    // http://www.w3.org/TR/domcore/#domtokenlist
	    verifyToken = function (token) {
	      if (!token) {
	        throw 'SyntaxError';
	      } else if (spaces.test(token)) {
	        throw 'InvalidCharacterError';
	      }
	      return token;
	    },
	    DOMTokenList = function (node) {
	      var
	        noClassName = typeof node.className === 'undefined',
	        className = noClassName ?
	          (node.getAttribute('class') || '') : node.className,
	        isSVG = noClassName || typeof className === 'object',
	        value = (isSVG ?
	          (noClassName ? className : className.baseVal) :
	          className
	        ).replace(trim, '')
	      ;
	      if (value.length) {
	        properties.push.apply(
	          this,
	          value.split(spaces)
	        );
	      }
	      this._isSVG = isSVG;
	      this._ = node;
	    },
	    classListDescriptor = {
	      get: function get() {
	        return new DOMTokenList(this);
	      },
	      set: function(){}
	    },
	    uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.','-'),
	    trim = /^\s+|\s+$/g,
	    spaces = /\s+/,
	    SPACE = '\x20',
	    CLASS_LIST = 'classList',
	    toggle = function toggle(token, force) {
	      if (this.contains(token)) {
	        if (!force) {
	          // force is not true (either false or omitted)
	          this.remove(token);
	        }
	      } else if(force === undefined || force) {
	        force = true;
	        this.add(token);
	      }
	      return !!force;
	    },
	    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
	    Node = window.Node,
	    NodePrototype = (Node || Element).prototype,
	    CharacterData = window.CharacterData || Node,
	    CharacterDataPrototype = CharacterData && CharacterData.prototype,
	    DocumentType = window.DocumentType,
	    DocumentTypePrototype = DocumentType && DocumentType.prototype,
	    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
	    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
	    selectRemove = HTMLSelectElement.prototype.remove,
	    ShadowRoot = window.ShadowRoot,
	    SVGElement = window.SVGElement,
	    // normalizes multiple ids as CSS query
	    idSpaceFinder = / /g,
	    idSpaceReplacer = '\\ ',
	    createQueryMethod = function (methodName) {
	      var createArray = methodName === 'querySelectorAll';
	      return function (css) {
	        var a, i, id, query, nl, selectors, node = this.parentNode;
	        if (node) {
	          for (
	            id = this.getAttribute('id') || uid,
	            query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer),
	            selectors = css.split(','),
	            i = 0; i < selectors.length; i++
	          ) {
	            selectors[i] = '#' + query + ' ' + selectors[i];
	          }
	          css = selectors.join(',');
	        }
	        if (id === uid) this.setAttribute('id', id);
	        nl = (node || this)[methodName](css);
	        if (id === uid) this.removeAttribute('id');
	        // return a list
	        if (createArray) {
	          i = nl.length;
	          a = new Array(i);
	          while (i--) a[i] = nl[i];
	        }
	        // return node or null
	        else {
	          a = nl;
	        }
	        return a;
	      };
	    },
	    addQueryAndAll = function (where) {
	      if (!('query' in where)) {
	        where.query = ElementPrototype.query;
	      }
	      if (!('queryAll' in where)) {
	        where.queryAll = ElementPrototype.queryAll;
	      }
	    },
	    properties = [
	      'matches', (
	        ElementPrototype.matchesSelector ||
	        ElementPrototype.webkitMatchesSelector ||
	        ElementPrototype.khtmlMatchesSelector ||
	        ElementPrototype.mozMatchesSelector ||
	        ElementPrototype.msMatchesSelector ||
	        ElementPrototype.oMatchesSelector ||
	        function matches(selector) {
	          var parentNode = this.parentNode;
	          return !!parentNode && -1 < indexOf.call(
	            parentNode.querySelectorAll(selector),
	            this
	          );
	        }
	      ),
	      'closest', function closest(selector) {
	        var parentNode = this, matches;
	        while (
	          // document has no .matches
	          (matches = parentNode && parentNode.matches) &&
	          !parentNode.matches(selector)
	        ) {
	          parentNode = parentNode.parentNode;
	        }
	        return matches ? parentNode : null;
	      },
	      'prepend', function prepend() {
	        var firstChild = this.firstChild,
	            node = mutationMacro(arguments);
	        if (firstChild) {
	          this.insertBefore(node, firstChild);
	        } else {
	          this.appendChild(node);
	        }
	      },
	      'append', function append() {
	        this.appendChild(mutationMacro(arguments));
	      },
	      'before', function before() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.insertBefore(
	            mutationMacro(arguments), this
	          );
	        }
	      },
	      'after', function after() {
	        var parentNode = this.parentNode,
	            nextSibling = this.nextSibling,
	            node = mutationMacro(arguments);
	        if (parentNode) {
	          if (nextSibling) {
	            parentNode.insertBefore(node, nextSibling);
	          } else {
	            parentNode.appendChild(node);
	          }
	        }
	      },
	      // WARNING - DEPRECATED - use .replaceWith() instead
	      'replace', function replace() {
	        this.replaceWith.apply(this, arguments);
	      },
	      'replaceWith', function replaceWith() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.replaceChild(
	            mutationMacro(arguments),
	            this
	          );
	        }
	      },
	      'remove', function remove() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.removeChild(this);
	        }
	      },
	      'query', createQueryMethod('querySelector'),
	      'queryAll', createQueryMethod('querySelectorAll')
	    ],
	    slice = properties.slice,
	    i = properties.length; i; i -= 2
	  ) {
	    property = properties[i - 2];
	    if (!(property in ElementPrototype)) {
	      ElementPrototype[property] = properties[i - 1];
	    }
	    if (property === 'remove') {
	      // see https://github.com/WebReflection/dom4/issues/19
	      HTMLSelectElement.prototype[property] = function () {
	        return 0 < arguments.length ?
	          selectRemove.apply(this, arguments) :
	          ElementPrototype.remove.call(this);
	      };
	    }
	    // see https://github.com/WebReflection/dom4/issues/18
	    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
	      if (CharacterData && !(property in CharacterDataPrototype)) {
	        CharacterDataPrototype[property] = properties[i - 1];
	      }
	      if (DocumentType && !(property in DocumentTypePrototype)) {
	        DocumentTypePrototype[property] = properties[i - 1];
	      }
	    }
	    // see https://github.com/WebReflection/dom4/pull/26
	    if (/^(?:append|prepend)$/.test(property)) {
	      if (DocumentFragmentPrototype) {
	        if (!(property in DocumentFragmentPrototype)) {
	          DocumentFragmentPrototype[property] = properties[i - 1];
	        }
	      } else {
	        try {
	          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
	        } catch(o_O) {}
	      }
	    }
	  }
	
	  // bring query and queryAll to the document too
	  addQueryAndAll(document);
	
	  // brings query and queryAll to fragments as well
	  if (DocumentFragmentPrototype) {
	    addQueryAndAll(DocumentFragmentPrototype);
	  } else {
	    try {
	      addQueryAndAll(createDocumentFragment().constructor.prototype);
	    } catch(o_O) {}
	  }
	
	  // bring query and queryAll to the ShadowRoot too
	  if (ShadowRoot) {
	    addQueryAndAll(ShadowRoot.prototype);
	  }
	
	  // most likely an IE9 only issue
	  // see https://github.com/WebReflection/dom4/issues/6
	  if (!createElement('a').matches('a')) {
	    ElementPrototype[property] = function(matches){
	      return function (selector) {
	        return matches.call(
	          this.parentNode ?
	            this :
	            createDocumentFragment().appendChild(this),
	          selector
	        );
	      };
	    }(ElementPrototype[property]);
	  }
	
	  // used to fix both old webkit and SVG
	  DOMTokenList.prototype = {
	    length: 0,
	    add: function add() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(!this.contains(token)) {
	          properties.push.call(this, property);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    contains: (function(indexOf){
	      return function contains(token) {
	        i = indexOf.call(this, property = verifyToken(token));
	        return -1 < i;
	      };
	    }([].indexOf || function (token) {
	      i = this.length;
	      while(i-- && this[i] !== token){}
	      return i;
	    })),
	    item: function item(i) {
	      return this[i] || null;
	    },
	    remove: function remove() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(this.contains(token)) {
	          properties.splice.call(this, i, 1);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    toggle: toggle,
	    toString: function toString() {
	      return properties.join.call(this, SPACE);
	    }
	  };
	
	  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
	    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
	  }
	
	  // http://www.w3.org/TR/dom/#domtokenlist
	  // iOS 5.1 has completely screwed this property
	  // classList in ElementPrototype is false
	  // but it's actually there as getter
	  if (!(CLASS_LIST in document.documentElement)) {
	    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
	  } else {
	    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
	    // trying to detect and fix that in here
	    TemporaryTokenList = createElement('div')[CLASS_LIST];
	    TemporaryTokenList.add('a', 'b', 'a');
	    if ('a\x20b' != TemporaryTokenList) {
	      // no other way to reach original methods in iOS 5.1
	      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
	      if (!('add' in TemporaryPrototype)) {
	        // ASHA double fails in here
	        TemporaryPrototype = window.TemporaryTokenList.prototype;
	      }
	      wrapVerifyToken = function (original) {
	        return function () {
	          var i = 0;
	          while (i < arguments.length) {
	            original.call(this, arguments[i++]);
	          }
	        };
	      };
	      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
	      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
	      // toggle is broken too ^_^ ... let's fix it
	      TemporaryPrototype.toggle = toggle;
	    }
	  }
	
	  if (!('contains' in NodePrototype)) {
	    defineProperty(NodePrototype, 'contains', {
	      value: function (el) {
	        while (el && el !== this) el = el.parentNode;
	        return this === el;
	      }
	    });
	  }
	
	  if (!('head' in document)) {
	    defineProperty(document, 'head', {
	      get: function () {
	        return head || (
	          head = document.getElementsByTagName('head')[0]
	        );
	      }
	    });
	  }
	
	  // requestAnimationFrame partial polyfill
	  (function () {
	    for (var
	      raf,
	      rAF = window.requestAnimationFrame,
	      cAF = window.cancelAnimationFrame,
	      prefixes = ['o', 'ms', 'moz', 'webkit'],
	      i = prefixes.length;
	      !cAF && i--;
	    ) {
	      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
	      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
	            window[prefixes[i] + 'CancelRequestAnimationFrame'];
	    }
	    if (!cAF) {
	      // some FF apparently implemented rAF but no cAF 
	      if (rAF) {
	        raf = rAF;
	        rAF = function (callback) {
	          var goOn = true;
	          raf(function () {
	            if (goOn) callback.apply(this, arguments);
	          });
	          return function () {
	            goOn = false;
	          };
	        };
	        cAF = function (id) {
	          id();
	        };
	      } else {
	        rAF = function (callback) {
	          return setTimeout(callback, 15, 15);
	        };
	        cAF = function (id) {
	          clearTimeout(id);
	        };
	      }
	    }
	    window.requestAnimationFrame = rAF;
	    window.cancelAnimationFrame = cAF;
	  }());
	
	  // http://www.w3.org/TR/dom/#customevent
	  try{new window.CustomEvent('?');}catch(o_O){
	    window.CustomEvent = function(
	      eventName,
	      defaultInitDict
	    ){
	
	      // the infamous substitute
	      function CustomEvent(type, eventInitDict) {
	        /*jshint eqnull:true */
	        var event = document.createEvent(eventName);
	        if (typeof type != 'string') {
	          throw new Error('An event name must be provided');
	        }
	        if (eventName == 'Event') {
	          event.initCustomEvent = initCustomEvent;
	        }
	        if (eventInitDict == null) {
	          eventInitDict = defaultInitDict;
	        }
	        event.initCustomEvent(
	          type,
	          eventInitDict.bubbles,
	          eventInitDict.cancelable,
	          eventInitDict.detail
	        );
	        return event;
	      }
	
	      // attached at runtime
	      function initCustomEvent(
	        type, bubbles, cancelable, detail
	      ) {
	        /*jshint validthis:true*/
	        this.initEvent(type, bubbles, cancelable);
	        this.detail = detail;
	      }
	
	      // that's it
	      return CustomEvent;
	    }(
	      // is this IE9 or IE10 ?
	      // where CustomEvent is there
	      // but not usable as construtor ?
	      window.CustomEvent ?
	        // use the CustomEvent interface in such case
	        'CustomEvent' : 'Event',
	        // otherwise the common compatible one
	      {
	        bubbles: false,
	        cancelable: false,
	        detail: null
	      }
	    );
	  }
	
	  // window.Event as constructor
	  try { new Event('_'); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($Event) {
	      function Event(type, init) {
	        enoughArguments(arguments.length, 'Event');
	        var out = document.createEvent('Event');
	        if (!init) init = {};
	        out.initEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable
	        );
	        return out;
	      }
	      Event.prototype = $Event.prototype;
	      return Event;
	    }(window.Event || function Event() {}));
	    defineProperty(window, 'Event', {value: o_O});
	    // Android 4 gotcha
	    if (Event !== o_O) Event = o_O;
	  }
	
	  // window.KeyboardEvent as constructor
	  try { new KeyboardEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($KeyboardEvent) {
	      // code inspired by https://gist.github.com/termi/4654819
	      var
	        initType = 0,
	        defaults = {
	          char: '',
	          key: '',
	          location: 0,
	          ctrlKey: false,
	          shiftKey: false,
	          altKey: false,
	          metaKey: false,
	          altGraphKey: false,
	          repeat: false,
	          locale: navigator.language,
	          detail: 0,
	          bubbles: false,
	          cancelable: false,
	          keyCode: 0,
	          charCode: 0,
	          which: 0
	        },
	        eventType
	      ;
	      try {
	        var e = document.createEvent('KeyboardEvent');
	        e.initKeyboardEvent(
	          'keyup', false, false, window, '+', 3,
	          true, false, true, false, false
	        );
	        initType = (
	          (e.keyIdentifier || e.key) == '+' &&
	          (e.keyLocation || e.location) == 3
	        ) && (
	          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
	        ) || 9;
	      } catch(o_O) {}
	      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';
	
	      function getModifier(init) {
	        for (var
	          out = [],
	          keys = [
	            'ctrlKey',
	            'Control',
	            'shiftKey',
	            'Shift',
	            'altKey',
	            'Alt',
	            'metaKey',
	            'Meta',
	            'altGraphKey',
	            'AltGraph'
	          ],
	          i = 0; i < keys.length; i += 2
	        ) {
	          if (init[keys[i]])
	            out.push(keys[i + 1]);
	        }
	        return out.join(' ');
	      }
	
	      function withDefaults(target, source) {
	        for (var key in source) {
	          if (
	            source.hasOwnProperty(key) &&
	            !source.hasOwnProperty.call(target, key)
	          ) target[key] = source[key];
	        }
	        return target;
	      }
	
	      function withInitValues(key, out, init) {
	        try {
	          out[key] = init[key];
	        } catch(o_O) {}
	      }
	
	      function KeyboardEvent(type, init) {
	        enoughArguments(arguments.length, 'KeyboardEvent');
	        init = withDefaults(init || {}, defaults);
	        var
	          out = document.createEvent(eventType),
	          ctrlKey = init.ctrlKey,
	          shiftKey = init.shiftKey,
	          altKey = init.altKey,
	          metaKey = init.metaKey,
	          altGraphKey = init.altGraphKey,
	          modifiers = initType > 3 ? getModifier(init) : null,
	          key = String(init.key),
	          chr = String(init.char),
	          location = init.location,
	          keyCode = init.keyCode || (
	            (init.keyCode = key) &&
	            key.charCodeAt(0)
	          ) || 0,
	          charCode = init.charCode || (
	            (init.charCode = chr) &&
	            chr.charCodeAt(0)
	          ) || 0,
	          bubbles = init.bubbles,
	          cancelable = init.cancelable,
	          repeat = init.repeat,
	          locale = init.locale,
	          view = init.view || window,
	          args
	        ;
	        if (!init.which) init.which = init.keyCode;
	        if ('initKeyEvent' in out) {
	          out.initKeyEvent(
	            type, bubbles, cancelable, view,
	            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
	          );
	        } else if (0 < initType && 'initKeyboardEvent' in out) {
	          args = [type, bubbles, cancelable, view];
	          switch (initType) {
	            case 1:
	              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
	              break;
	            case 2:
	              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
	              break;
	            case 3:
	              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
	              break;
	            case 4:
	              args.push(key, location, modifiers, repeat, locale);
	              break;
	            default:
	              args.push(char, key, location, modifiers, repeat, locale);
	          }
	          out.initKeyboardEvent.apply(out, args);
	        } else {
	          out.initEvent(type, bubbles, cancelable);
	        }
	        for (key in out) {
	          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
	            withInitValues(key, out, init);
	          }
	        }
	        return out;
	      }
	      KeyboardEvent.prototype = $KeyboardEvent.prototype;
	      return KeyboardEvent;
	    }(window.KeyboardEvent || function KeyboardEvent() {}));
	    defineProperty(window, 'KeyboardEvent', {value: o_O});
	    // Android 4 gotcha
	    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
	  }
	
	  // window.MouseEvent as constructor
	  try { new MouseEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($MouseEvent) {
	      function MouseEvent(type, init) {
	        enoughArguments(arguments.length, 'MouseEvent');
	        var out = document.createEvent('MouseEvent');
	        if (!init) init = {};
	        out.initMouseEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable,
	          init.view || window,
	          init.detail || 1,
	          init.screenX || 0,
	          init.screenY || 0,
	          init.clientX || 0,
	          init.clientY || 0,
	          !!init.ctrlKey,
	          !!init.altKey,
	          !!init.shiftKey,
	          !!init.metaKey,
	          init.button || 0,
	          init.relatedTarget || null
	        );
	        return out;
	      }
	      MouseEvent.prototype = $MouseEvent.prototype;
	      return MouseEvent;
	    }(window.MouseEvent || function MouseEvent() {}));
	    defineProperty(window, 'MouseEvent', {value: o_O});
	    // Android 4 gotcha
	    if (MouseEvent !== o_O) MouseEvent = o_O;
	  }
	
	}(window));(function (global){'use strict';
	
	  // a WeakMap fallback for DOM nodes only used as key
	  var DOMMap = global.WeakMap || (function () {
	
	    var
	      counter = 0,
	      dispatched = false,
	      drop = false,
	      value
	    ;
	
	    function dispatch(key, ce, shouldDrop) {
	      drop = shouldDrop;
	      dispatched = false;
	      value = undefined;
	      key.dispatchEvent(ce);
	    }
	
	    function Handler(value) {
	      this.value = value;
	    }
	
	    Handler.prototype.handleEvent = function handleEvent(e) {
	      dispatched = true;
	      if (drop) {
	        e.currentTarget.removeEventListener(e.type, this, false);
	      } else {
	        value = this.value;
	      }
	    };
	
	    function DOMMap() {
	      counter++;  // make id clashing highly improbable
	      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
	    }
	
	    DOMMap.prototype = {
	      'constructor': DOMMap,
	      'delete': function del(key) {
	        return dispatch(key, this.__ce__, true), dispatched;
	      },
	      'get': function get(key) {
	        dispatch(key, this.__ce__, false);
	        var v = value;
	        value = undefined;
	        return v;
	      },
	      'has': function has(key) {
	        return dispatch(key, this.__ce__, false), dispatched;
	      },
	      'set': function set(key, value) {
	        dispatch(key, this.__ce__, true);
	        key.addEventListener(this.__ce__.type, new Handler(value), false);
	        return this;
	      },
	    };
	
	    return DOMMap;
	
	  }());
	
	  function Dict() {}
	  Dict.prototype = (Object.create || Object)(null);
	
	  // https://dom.spec.whatwg.org/#interface-eventtarget
	
	  function createEventListener(type, callback, options) {
	    function eventListener(e) {
	      if (eventListener.once) {
	        e.currentTarget.removeEventListener(
	          e.type,
	          callback,
	          eventListener
	        );
	        eventListener.removed = true;
	      }
	      if (eventListener.passive) {
	        e.preventDefault = createEventListener.preventDefault;
	      }
	      if (typeof eventListener.callback === 'function') {
	        /* jshint validthis: true */
	        eventListener.callback.call(this, e);
	      } else if (eventListener.callback) {
	        eventListener.callback.handleEvent(e);
	      }
	      if (eventListener.passive) {
	        delete e.preventDefault;
	      }
	    }
	    eventListener.type = type;
	    eventListener.callback = callback;
	    eventListener.capture = !!options.capture;
	    eventListener.passive = !!options.passive;
	    eventListener.once = !!options.once;
	    // currently pointless but specs say to use it, so ...
	    eventListener.removed = false;
	    return eventListener;
	  }
	
	  createEventListener.preventDefault = function preventDefault() {};
	
	  var
	    Event = global.CustomEvent,
	    hOP = Object.prototype.hasOwnProperty,
	    dE = global.dispatchEvent,
	    aEL = global.addEventListener,
	    rEL = global.removeEventListener,
	    counter = 0,
	    increment = function () { counter++; },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    getListenerKey = function (options) {
	      return ''.concat(
	        options.capture ? '1' : '0',
	        options.passive ? '1' : '0',
	        options.once ? '1' : '0'
	      );
	    },
	    augment, proto
	  ;
	
	  try {
	    aEL('_', increment, {once: true});
	    dE(new Event('_'));
	    dE(new Event('_'));
	    rEL('_', increment, {once: true});
	  } catch(o_O) {}
	
	  if (counter !== 1) {
	    (function () {
	      var dm = new DOMMap();
	      function createAEL(aEL) {
	        return function addEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key = getListenerKey(options),
	              i, tmp, wrap
	            ;
	            if (!info) dm.set(this, (info = new Dict()));
	            if (!(type in info)) info[type] = {
	              handler: [],
	              wrap: []
	            };
	            tmp = info[type];
	            i = indexOf.call(tmp.handler, handler);
	            if (i < 0) {
	              i = tmp.handler.push(handler) - 1;
	              tmp.wrap[i] = (wrap = new Dict());
	            } else {
	              wrap = tmp.wrap[i];
	            }
	            if (!(key in wrap)) {
	              wrap[key] = createEventListener(type, handler, options);
	              aEL.call(this, type, wrap[key], wrap[key].capture);
	            }
	          } else {
	            aEL.call(this, type, handler, options);
	          }
	        };
	      }
	      function createREL(rEL) {
	        return function removeEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key, i, tmp, wrap
	            ;
	            if (info && (type in info)) {
	              tmp = info[type];
	              i = indexOf.call(tmp.handler, handler);
	              if (-1 < i) {
	                key = getListenerKey(options);
	                wrap = tmp.wrap[i];
	                if (key in wrap) {
	                  rEL.call(this, type, wrap[key], wrap[key].capture);
	                  delete wrap[key];
	                  // return if there are other wraps
	                  for (key in wrap) return;
	                  // otherwise remove all the things
	                  tmp.handler.splice(i, 1);
	                  tmp.wrap.splice(i, 1);
	                  // if there are no other handlers
	                  if (tmp.handler.length === 0)
	                    // drop the info[type] entirely
	                    delete info[type];
	                }
	              }
	            }
	          } else {
	            rEL.call(this, type, handler, options);
	          }
	        };
	      }
	
	      augment = function (Constructor) {
	        if (!Constructor) return;
	        var proto = Constructor.prototype;
	        proto.addEventListener = createAEL(proto.addEventListener);
	        proto.removeEventListener = createREL(proto.removeEventListener);
	      };
	
	      if (global.EventTarget) {
	        augment(EventTarget);
	      } else {
	        augment(global.Text);
	        augment(global.Element || global.HTMLElement);
	        augment(global.HTMLDocument);
	        augment(global.Window || {prototype:global});
	        augment(global.XMLHttpRequest);
	      }
	
	    }());
	  }
	
	}(self));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*!
	 * @copyright Copyright (c) 2017 IcoMoon.io
	 * @license   Licensed under MIT license
	 *            See https://github.com/Keyamoon/svgxuse
	 * @version   1.2.6
	 */
	/*jslint browser: true */
	/*global XDomainRequest, MutationObserver, window */
	(function () {
	    "use strict";
	    if (typeof window !== "undefined" && window.addEventListener) {
	        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
	        var checkUseElems;
	        var tid; // timeout id
	        var debouncedCheck = function () {
	            clearTimeout(tid);
	            tid = setTimeout(checkUseElems, 100);
	        };
	        var unobserveChanges = function () {
	            return;
	        };
	        var observeChanges = function () {
	            var observer;
	            window.addEventListener("resize", debouncedCheck, false);
	            window.addEventListener("orientationchange", debouncedCheck, false);
	            if (window.MutationObserver) {
	                observer = new MutationObserver(debouncedCheck);
	                observer.observe(document.documentElement, {
	                    childList: true,
	                    subtree: true,
	                    attributes: true
	                });
	                unobserveChanges = function () {
	                    try {
	                        observer.disconnect();
	                        window.removeEventListener("resize", debouncedCheck, false);
	                        window.removeEventListener("orientationchange", debouncedCheck, false);
	                    } catch (ignore) {}
	                };
	            } else {
	                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
	                unobserveChanges = function () {
	                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
	                    window.removeEventListener("resize", debouncedCheck, false);
	                    window.removeEventListener("orientationchange", debouncedCheck, false);
	                };
	            }
	        };
	        var createRequest = function (url) {
	            // In IE 9, cross origin requests can only be sent using XDomainRequest.
	            // XDomainRequest would fail if CORS headers are not set.
	            // Therefore, XDomainRequest should only be used with cross origin requests.
	            function getOrigin(loc) {
	                var a;
	                if (loc.protocol !== undefined) {
	                    a = loc;
	                } else {
	                    a = document.createElement("a");
	                    a.href = loc;
	                }
	                return a.protocol.replace(/:/g, "") + a.host;
	            }
	            var Request;
	            var origin;
	            var origin2;
	            if (window.XMLHttpRequest) {
	                Request = new XMLHttpRequest();
	                origin = getOrigin(location);
	                origin2 = getOrigin(url);
	                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
	                    Request = XDomainRequest || undefined;
	                } else {
	                    Request = XMLHttpRequest;
	                }
	            }
	            return Request;
	        };
	        var xlinkNS = "http://www.w3.org/1999/xlink";
	        checkUseElems = function () {
	            var base;
	            var bcr;
	            var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
	            var hash;
	            var href;
	            var i;
	            var inProgressCount = 0;
	            var isHidden;
	            var Request;
	            var url;
	            var uses;
	            var xhr;
	            function observeIfDone() {
	                // If done with making changes, start watching for chagnes in DOM again
	                inProgressCount -= 1;
	                if (inProgressCount === 0) { // if all xhrs were resolved
	                    unobserveChanges(); // make sure to remove old handlers
	                    observeChanges(); // watch for changes to DOM
	                }
	            }
	            function attrUpdateFunc(spec) {
	                return function () {
	                    if (cache[spec.base] !== true) {
	                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
	                        if (spec.useEl.hasAttribute("href")) {
	                            spec.useEl.setAttribute("href", "#" + spec.hash);
	                        }
	                    }
	                };
	            }
	            function onloadFunc(xhr) {
	                return function () {
	                    var body = document.body;
	                    var x = document.createElement("x");
	                    var svg;
	                    xhr.onload = null;
	                    x.innerHTML = xhr.responseText;
	                    svg = x.getElementsByTagName("svg")[0];
	                    if (svg) {
	                        svg.setAttribute("aria-hidden", "true");
	                        svg.style.position = "absolute";
	                        svg.style.width = 0;
	                        svg.style.height = 0;
	                        svg.style.overflow = "hidden";
	                        body.insertBefore(svg, body.firstChild);
	                    }
	                    observeIfDone();
	                };
	            }
	            function onErrorTimeout(xhr) {
	                return function () {
	                    xhr.onerror = null;
	                    xhr.ontimeout = null;
	                    observeIfDone();
	                };
	            }
	            unobserveChanges(); // stop watching for changes to DOM
	            // find all use elements
	            uses = document.getElementsByTagName("use");
	            for (i = 0; i < uses.length; i += 1) {
	                try {
	                    bcr = uses[i].getBoundingClientRect();
	                } catch (ignore) {
	                    // failed to get bounding rectangle of the use element
	                    bcr = false;
	                }
	                href = uses[i].getAttribute("href")
	                        || uses[i].getAttributeNS(xlinkNS, "href")
	                        || uses[i].getAttribute("xlink:href");
	                if (href && href.split) {
	                    url = href.split("#");
	                } else {
	                    url = ["", ""];
	                }
	                base = url[0];
	                hash = url[1];
	                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
	                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
	                    // the use element is empty
	                    // if there is a reference to an external SVG, try to fetch it
	                    // use the optional fallback URL if there is no reference to an external SVG
	                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
	                        base = fallback;
	                    }
	                    if (uses[i].hasAttribute("href")) {
	                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
	                    }
	                    if (base.length) {
	                        // schedule updating xlink:href
	                        xhr = cache[base];
	                        if (xhr !== true) {
	                            // true signifies that prepending the SVG was not required
	                            setTimeout(attrUpdateFunc({
	                                useEl: uses[i],
	                                base: base,
	                                hash: hash
	                            }), 0);
	                        }
	                        if (xhr === undefined) {
	                            Request = createRequest(base);
	                            if (Request !== undefined) {
	                                xhr = new Request();
	                                cache[base] = xhr;
	                                xhr.onload = onloadFunc(xhr);
	                                xhr.onerror = onErrorTimeout(xhr);
	                                xhr.ontimeout = onErrorTimeout(xhr);
	                                xhr.open("GET", base);
	                                xhr.send();
	                                inProgressCount += 1;
	                            }
	                        }
	                    }
	                } else {
	                    if (!isHidden) {
	                        if (cache[base] === undefined) {
	                            // remember this URL if the use element was not empty and no request was sent
	                            cache[base] = true;
	                        } else if (cache[base].onload) {
	                            // if it turns out that prepending the SVG is not necessary,
	                            // abort the in-progress xhr.
	                            cache[base].abort();
	                            delete cache[base].onload;
	                            cache[base] = true;
	                        }
	                    } else if (base.length && cache[base]) {
	                        setTimeout(attrUpdateFunc({
	                            useEl: uses[i],
	                            base: base,
	                            hash: hash
	                        }), 0);
	                    }
	                }
	            }
	            uses = "";
	            inProgressCount += 1;
	            observeIfDone();
	        };
	        var winLoad;
	        winLoad = function () {
	            window.removeEventListener("load", winLoad, false); // to prevent memory leaks
	            tid = setTimeout(checkUseElems, 0);
	        };
	        if (document.readyState !== "complete") {
	            // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
	            window.addEventListener("load", winLoad, false);
	        } else {
	            // No need to add a listener if the document is already loaded, initialize immediately.
	            winLoad();
	        }
	    }
	}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _jsCookie = __webpack_require__(7);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * SubscribePopup component
	 * @author Dayne Coulson-Hoffacker
	 */
	var SubscribePopup =
	/**
	 * Constructs a new SubscribePopup instance
	 * @param {Object} options - Options object.
	 * @param {HMTLElement} options.element - Container element.
	 */
	function SubscribePopup(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, SubscribePopup);
	
	  this.element = options.element;
	  this.closeBtns = this.element.queryAll('[data-component="close-btn"]');
	
	  this.closeBtns.forEach(function (btn) {
	    btn.addEventListener('click', function () {
	      _this.element.classList.remove('visible');
	      _jsCookie2.default.set('subscribe-popup', 'hide');
	    });
	  });
	
	  var cookieExists = _jsCookie2.default.get('subscribe-popup');
	
	  if (!cookieExists) {
	    setTimeout(function () {
	      _this.element.classList.add('visible');
	    }, 45000);
	  }
	};
	
	exports.default = SubscribePopup;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _headroom = __webpack_require__(29);
	
	var _headroom2 = _interopRequireDefault(_headroom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * GlobalHeader component.
	 * @author Dayne Coulson-Hoffacker
	 */
	var GlobalHeader = function () {
	  /**
	   * Constructs a new scroll CTA.
	   * @param {Object} options - Options.
	   * @param {HTMLElement} options.element - Container.
	   */
	  function GlobalHeader(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, GlobalHeader);
	
	    this.element = options.element;
	    this.navToggle = this.element.querySelector('[data-component="nav-toggle"]');
	    this.mainNav = this.element.querySelector('[data-component="main-nav"]');
	    this.navItems = this.mainNav.queryAll('ul > li.menu-item-has-children');
	    this.aboutNavItems = this.mainNav.queryAll('li.about-menu .sub-menu-wrapper ul li a');
	
	    var headroom = new _headroom2.default(this.element);
	
	    this.navToggle.addEventListener('click', function (e) {
	      _this.element.classList.toggle('nav-open');
	      _this.navToggle.classList.toggle('is-active');
	    });
	
	    this.navItems.forEach(function (element) {
	      var toggle = element.querySelector('.arrow');
	      toggle.addEventListener('click', function (e) {
	        var index = _this.navItems.indexOf(element);
	        if (element.classList.contains('open')) {
	          _this.close(_this.navItems);
	          e.preventDefault();
	        } else {
	          e.preventDefault();
	          _this.close(_this.navItems);
	          _this.open(element, index);
	        }
	      });
	    });
	
	    if (document.body.classList.contains('page-template-page-about')) {
	      this.aboutNavItems.forEach(function (element) {
	        element.addEventListener('click', function (e) {
	          _this.element.classList.remove('nav-open');
	          _this.navToggle.classList.remove('is-active');
	        });
	      });
	    }
	
	    headroom.init();
	  }
	
	  /**
	  * Closes expanded state.
	  */
	
	
	  (0, _createClass3.default)(GlobalHeader, [{
	    key: 'close',
	    value: function close(navItems) {
	      this.navItems.forEach(function (element) {
	        element.classList.remove('open');
	      });
	    }
	
	    /**
	    * Opens expanded state.
	    */
	
	  }, {
	    key: 'open',
	    value: function open(element, index) {
	      element.classList.add('open');
	    }
	  }]);
	  return GlobalHeader;
	}();
	
	exports.default = GlobalHeader;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(10);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(11), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(12);
	var $Object = __webpack_require__(15).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(13);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperty: __webpack_require__(19).f });


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14);
	var core = __webpack_require__(15);
	var ctx = __webpack_require__(16);
	var hide = __webpack_require__(18);
	var has = __webpack_require__(28);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(17);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(19);
	var createDesc = __webpack_require__(27);
	module.exports = __webpack_require__(23) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(20);
	var IE8_DOM_DEFINE = __webpack_require__(22);
	var toPrimitive = __webpack_require__(26);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(23) && !__webpack_require__(24)(function () {
	  return Object.defineProperty(__webpack_require__(25)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(24)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	var document = __webpack_require__(14).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(21);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
	 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
	 * License: MIT
	 */
	
	(function(root, factory) {
	  'use strict';
	
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  else if (typeof exports === 'object') {
	    // COMMONJS
	    module.exports = factory();
	  }
	  else {
	    // BROWSER
	    root.Headroom = factory();
	  }
	}(this, function() {
	  'use strict';
	
	  /* exported features */
	  
	  var features = {
	    bind : !!(function(){}.bind),
	    classList : 'classList' in document.documentElement,
	    rAF : !!(window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame)
	  };
	  window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
	  
	  /**
	   * Handles debouncing of events via requestAnimationFrame
	   * @see http://www.html5rocks.com/en/tutorials/speed/animations/
	   * @param {Function} callback The callback to handle whichever event
	   */
	  function Debouncer (callback) {
	    this.callback = callback;
	    this.ticking = false;
	  }
	  Debouncer.prototype = {
	    constructor : Debouncer,
	  
	    /**
	     * dispatches the event to the supplied callback
	     * @private
	     */
	    update : function() {
	      this.callback && this.callback();
	      this.ticking = false;
	    },
	  
	    /**
	     * ensures events don't get stacked
	     * @private
	     */
	    requestTick : function() {
	      if(!this.ticking) {
	        requestAnimationFrame(this.rafCallback || (this.rafCallback = this.update.bind(this)));
	        this.ticking = true;
	      }
	    },
	  
	    /**
	     * Attach this as the event listeners
	     */
	    handleEvent : function() {
	      this.requestTick();
	    }
	  };
	  /**
	   * Check if object is part of the DOM
	   * @constructor
	   * @param {Object} obj element to check
	   */
	  function isDOMElement(obj) {
	    return obj && typeof window !== 'undefined' && (obj === window || obj.nodeType);
	  }
	  
	  /**
	   * Helper function for extending objects
	   */
	  function extend (object /*, objectN ... */) {
	    if(arguments.length <= 0) {
	      throw new Error('Missing arguments in extend function');
	    }
	  
	    var result = object || {},
	        key,
	        i;
	  
	    for (i = 1; i < arguments.length; i++) {
	      var replacement = arguments[i] || {};
	  
	      for (key in replacement) {
	        // Recurse into object except if the object is a DOM element
	        if(typeof result[key] === 'object' && ! isDOMElement(result[key])) {
	          result[key] = extend(result[key], replacement[key]);
	        }
	        else {
	          result[key] = result[key] || replacement[key];
	        }
	      }
	    }
	  
	    return result;
	  }
	  
	  /**
	   * Helper function for normalizing tolerance option to object format
	   */
	  function normalizeTolerance (t) {
	    return t === Object(t) ? t : { down : t, up : t };
	  }
	  
	  /**
	   * UI enhancement for fixed headers.
	   * Hides header when scrolling down
	   * Shows header when scrolling up
	   * @constructor
	   * @param {DOMElement} elem the header element
	   * @param {Object} options options for the widget
	   */
	  function Headroom (elem, options) {
	    options = extend(options, Headroom.options);
	  
	    this.lastKnownScrollY = 0;
	    this.elem             = elem;
	    this.tolerance        = normalizeTolerance(options.tolerance);
	    this.classes          = options.classes;
	    this.offset           = options.offset;
	    this.scroller         = options.scroller;
	    this.initialised      = false;
	    this.onPin            = options.onPin;
	    this.onUnpin          = options.onUnpin;
	    this.onTop            = options.onTop;
	    this.onNotTop         = options.onNotTop;
	    this.onBottom         = options.onBottom;
	    this.onNotBottom      = options.onNotBottom;
	  }
	  Headroom.prototype = {
	    constructor : Headroom,
	  
	    /**
	     * Initialises the widget
	     */
	    init : function() {
	      if(!Headroom.cutsTheMustard) {
	        return;
	      }
	  
	      this.debouncer = new Debouncer(this.update.bind(this));
	      this.elem.classList.add(this.classes.initial);
	  
	      // defer event registration to handle browser
	      // potentially restoring previous scroll position
	      setTimeout(this.attachEvent.bind(this), 100);
	  
	      return this;
	    },
	  
	    /**
	     * Unattaches events and removes any classes that were added
	     */
	    destroy : function() {
	      var classes = this.classes;
	  
	      this.initialised = false;
	  
	      for (var key in classes) {
	        if(classes.hasOwnProperty(key)) {
	          this.elem.classList.remove(classes[key]);
	        }
	      }
	  
	      this.scroller.removeEventListener('scroll', this.debouncer, false);
	    },
	  
	    /**
	     * Attaches the scroll event
	     * @private
	     */
	    attachEvent : function() {
	      if(!this.initialised){
	        this.lastKnownScrollY = this.getScrollY();
	        this.initialised = true;
	        this.scroller.addEventListener('scroll', this.debouncer, false);
	  
	        this.debouncer.handleEvent();
	      }
	    },
	  
	    /**
	     * Unpins the header if it's currently pinned
	     */
	    unpin : function() {
	      var classList = this.elem.classList,
	        classes = this.classes;
	  
	      if(classList.contains(classes.pinned) || !classList.contains(classes.unpinned)) {
	        classList.add(classes.unpinned);
	        classList.remove(classes.pinned);
	        this.onUnpin && this.onUnpin.call(this);
	      }
	    },
	  
	    /**
	     * Pins the header if it's currently unpinned
	     */
	    pin : function() {
	      var classList = this.elem.classList,
	        classes = this.classes;
	  
	      if(classList.contains(classes.unpinned)) {
	        classList.remove(classes.unpinned);
	        classList.add(classes.pinned);
	        this.onPin && this.onPin.call(this);
	      }
	    },
	  
	    /**
	     * Handles the top states
	     */
	    top : function() {
	      var classList = this.elem.classList,
	        classes = this.classes;
	  
	      if(!classList.contains(classes.top)) {
	        classList.add(classes.top);
	        classList.remove(classes.notTop);
	        this.onTop && this.onTop.call(this);
	      }
	    },
	  
	    /**
	     * Handles the not top state
	     */
	    notTop : function() {
	      var classList = this.elem.classList,
	        classes = this.classes;
	  
	      if(!classList.contains(classes.notTop)) {
	        classList.add(classes.notTop);
	        classList.remove(classes.top);
	        this.onNotTop && this.onNotTop.call(this);
	      }
	    },
	  
	    bottom : function() {
	      var classList = this.elem.classList,
	        classes = this.classes;
	  
	      if(!classList.contains(classes.bottom)) {
	        classList.add(classes.bottom);
	        classList.remove(classes.notBottom);
	        this.onBottom && this.onBottom.call(this);
	      }
	    },
	  
	    /**
	     * Handles the not top state
	     */
	    notBottom : function() {
	      var classList = this.elem.classList,
	        classes = this.classes;
	  
	      if(!classList.contains(classes.notBottom)) {
	        classList.add(classes.notBottom);
	        classList.remove(classes.bottom);
	        this.onNotBottom && this.onNotBottom.call(this);
	      }
	    },
	  
	    /**
	     * Gets the Y scroll position
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY
	     * @return {Number} pixels the page has scrolled along the Y-axis
	     */
	    getScrollY : function() {
	      return (this.scroller.pageYOffset !== undefined)
	        ? this.scroller.pageYOffset
	        : (this.scroller.scrollTop !== undefined)
	          ? this.scroller.scrollTop
	          : (document.documentElement || document.body.parentNode || document.body).scrollTop;
	    },
	  
	    /**
	     * Gets the height of the viewport
	     * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
	     * @return {int} the height of the viewport in pixels
	     */
	    getViewportHeight : function () {
	      return window.innerHeight
	        || document.documentElement.clientHeight
	        || document.body.clientHeight;
	    },
	  
	    /**
	     * Gets the physical height of the DOM element
	     * @param  {Object}  elm the element to calculate the physical height of which
	     * @return {int}     the physical height of the element in pixels
	     */
	    getElementPhysicalHeight : function (elm) {
	      return Math.max(
	        elm.offsetHeight,
	        elm.clientHeight
	      );
	    },
	  
	    /**
	     * Gets the physical height of the scroller element
	     * @return {int} the physical height of the scroller element in pixels
	     */
	    getScrollerPhysicalHeight : function () {
	      return (this.scroller === window || this.scroller === document.body)
	        ? this.getViewportHeight()
	        : this.getElementPhysicalHeight(this.scroller);
	    },
	  
	    /**
	     * Gets the height of the document
	     * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
	     * @return {int} the height of the document in pixels
	     */
	    getDocumentHeight : function () {
	      var body = document.body,
	        documentElement = document.documentElement;
	  
	      return Math.max(
	        body.scrollHeight, documentElement.scrollHeight,
	        body.offsetHeight, documentElement.offsetHeight,
	        body.clientHeight, documentElement.clientHeight
	      );
	    },
	  
	    /**
	     * Gets the height of the DOM element
	     * @param  {Object}  elm the element to calculate the height of which
	     * @return {int}     the height of the element in pixels
	     */
	    getElementHeight : function (elm) {
	      return Math.max(
	        elm.scrollHeight,
	        elm.offsetHeight,
	        elm.clientHeight
	      );
	    },
	  
	    /**
	     * Gets the height of the scroller element
	     * @return {int} the height of the scroller element in pixels
	     */
	    getScrollerHeight : function () {
	      return (this.scroller === window || this.scroller === document.body)
	        ? this.getDocumentHeight()
	        : this.getElementHeight(this.scroller);
	    },
	  
	    /**
	     * determines if the scroll position is outside of document boundaries
	     * @param  {int}  currentScrollY the current y scroll position
	     * @return {bool} true if out of bounds, false otherwise
	     */
	    isOutOfBounds : function (currentScrollY) {
	      var pastTop  = currentScrollY < 0,
	        pastBottom = currentScrollY + this.getScrollerPhysicalHeight() > this.getScrollerHeight();
	  
	      return pastTop || pastBottom;
	    },
	  
	    /**
	     * determines if the tolerance has been exceeded
	     * @param  {int} currentScrollY the current scroll y position
	     * @return {bool} true if tolerance exceeded, false otherwise
	     */
	    toleranceExceeded : function (currentScrollY, direction) {
	      return Math.abs(currentScrollY-this.lastKnownScrollY) >= this.tolerance[direction];
	    },
	  
	    /**
	     * determine if it is appropriate to unpin
	     * @param  {int} currentScrollY the current y scroll position
	     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
	     * @return {bool} true if should unpin, false otherwise
	     */
	    shouldUnpin : function (currentScrollY, toleranceExceeded) {
	      var scrollingDown = currentScrollY > this.lastKnownScrollY,
	        pastOffset = currentScrollY >= this.offset;
	  
	      return scrollingDown && pastOffset && toleranceExceeded;
	    },
	  
	    /**
	     * determine if it is appropriate to pin
	     * @param  {int} currentScrollY the current y scroll position
	     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
	     * @return {bool} true if should pin, false otherwise
	     */
	    shouldPin : function (currentScrollY, toleranceExceeded) {
	      var scrollingUp  = currentScrollY < this.lastKnownScrollY,
	        pastOffset = currentScrollY <= this.offset;
	  
	      return (scrollingUp && toleranceExceeded) || pastOffset;
	    },
	  
	    /**
	     * Handles updating the state of the widget
	     */
	    update : function() {
	      var currentScrollY  = this.getScrollY(),
	        scrollDirection = currentScrollY > this.lastKnownScrollY ? 'down' : 'up',
	        toleranceExceeded = this.toleranceExceeded(currentScrollY, scrollDirection);
	  
	      if(this.isOutOfBounds(currentScrollY)) { // Ignore bouncy scrolling in OSX
	        return;
	      }
	  
	      if (currentScrollY <= this.offset ) {
	        this.top();
	      } else {
	        this.notTop();
	      }
	  
	      if(currentScrollY + this.getViewportHeight() >= this.getScrollerHeight()) {
	        this.bottom();
	      }
	      else {
	        this.notBottom();
	      }
	  
	      if(this.shouldUnpin(currentScrollY, toleranceExceeded)) {
	        this.unpin();
	      }
	      else if(this.shouldPin(currentScrollY, toleranceExceeded)) {
	        this.pin();
	      }
	  
	      this.lastKnownScrollY = currentScrollY;
	    }
	  };
	  /**
	   * Default options
	   * @type {Object}
	   */
	  Headroom.options = {
	    tolerance : {
	      up : 0,
	      down : 0
	    },
	    offset : 0,
	    scroller: window,
	    classes : {
	      pinned : 'headroom--pinned',
	      unpinned : 'headroom--unpinned',
	      top : 'headroom--top',
	      notTop : 'headroom--not-top',
	      bottom : 'headroom--bottom',
	      notBottom : 'headroom--not-bottom',
	      initial : 'headroom'
	    }
	  };
	  Headroom.cutsTheMustard = typeof features !== 'undefined' && features.rAF && features.bind && features.classList;
	
	  return Headroom;
	}));

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _smoothScroll = __webpack_require__(31);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A CTA button that scrolls the page to the element folowing it's parent.
	 * @author Dayne Coulson-Hoffacker
	 */
	var ScrollBtn =
	/**
	 * Constructs a new scroll button.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function ScrollBtn(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, ScrollBtn);
	
	  this.element = options.element;
	  this.scrollTarget = this.element.parentNode.nextElementSibling;
	  this.scroll = new _smoothScroll2.default();
	  this.scrollOptions = {
	    speed: 750,
	    updateURL: false
	  };
	
	  this.element.addEventListener('click', function () {
	    _this.scroll.animateScroll(_this.scrollTarget, _this.element, _this.scrollOptions);
	  });
	};
	
	exports.default = ScrollBtn;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! smooth-scroll v16.1.3 | (c) 2020 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
	window.Element&&!Element.prototype.closest&&(Element.prototype.closest=function(e){var t,n=(this.document||this.ownerDocument).querySelectorAll(e),o=this;do{for(t=n.length;0<=--t&&n.item(t)!==o;);}while(t<0&&(o=o.parentElement));return o}),(function(){if("function"==typeof window.CustomEvent)return;function e(e,t){t=t||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}e.prototype=window.Event.prototype,window.CustomEvent=e})(),(function(){for(var r=0,e=["ms","moz","webkit","o"],t=0;t<e.length&&!window.requestAnimationFrame;++t)window.requestAnimationFrame=window[e[t]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[e[t]+"CancelAnimationFrame"]||window[e[t]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(e,t){var n=(new Date).getTime(),o=Math.max(0,16-(n-r)),a=window.setTimeout((function(){e(n+o)}),o);return r=n+o,a}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(e){clearTimeout(e)})})(),(function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return t(e)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(e):e.SmoothScroll=t(e)})("undefined"!=typeof global?global:"undefined"!=typeof window?window:this,(function(M){"use strict";var q={ignore:"[data-scroll-ignore]",header:null,topOnEmptyHash:!0,speed:500,speedAsDuration:!1,durationMax:null,durationMin:null,clip:!0,offset:0,easing:"easeInOutCubic",customEasing:null,updateURL:!0,popstate:!0,emitEvents:!0},I=function(){var n={};return Array.prototype.forEach.call(arguments,(function(e){for(var t in e){if(!e.hasOwnProperty(t))return;n[t]=e[t]}})),n},r=function(e){"#"===e.charAt(0)&&(e=e.substr(1));for(var t,n=String(e),o=n.length,a=-1,r="",i=n.charCodeAt(0);++a<o;){if(0===(t=n.charCodeAt(a)))throw new InvalidCharacterError("Invalid character: the input contains U+0000.");1<=t&&t<=31||127==t||0===a&&48<=t&&t<=57||1===a&&48<=t&&t<=57&&45===i?r+="\\"+t.toString(16)+" ":r+=128<=t||45===t||95===t||48<=t&&t<=57||65<=t&&t<=90||97<=t&&t<=122?n.charAt(a):"\\"+n.charAt(a)}return"#"+r},F=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.body.clientHeight,document.documentElement.clientHeight)},L=function(e){return e?(t=e,parseInt(M.getComputedStyle(t).height,10)+e.offsetTop):0;var t},x=function(e,t,n){0===e&&document.body.focus(),n||(e.focus(),document.activeElement!==e&&(e.setAttribute("tabindex","-1"),e.focus(),e.style.outline="none"),M.scrollTo(0,t))},H=function(e,t,n,o){if(t.emitEvents&&"function"==typeof M.CustomEvent){var a=new CustomEvent(e,{bubbles:!0,detail:{anchor:n,toggle:o}});document.dispatchEvent(a)}};return function(o,e){var b,a,A,O,C={};C.cancelScroll=function(e){cancelAnimationFrame(O),O=null,e||H("scrollCancel",b)},C.animateScroll=function(a,r,e){C.cancelScroll();var i=I(b||q,e||{}),c="[object Number]"===Object.prototype.toString.call(a),t=c||!a.tagName?null:a;if(c||t){var s=M.pageYOffset;i.header&&!A&&(A=document.querySelector(i.header));var n,o,u,l,m,d,f,h,p=L(A),g=c?a:(function(e,t,n,o){var a=0;if(e.offsetParent)for(;a+=e.offsetTop,e=e.offsetParent;);return a=Math.max(a-t-n,0),o&&(a=Math.min(a,F()-M.innerHeight)),a})(t,p,parseInt("function"==typeof i.offset?i.offset(a,r):i.offset,10),i.clip),y=g-s,v=F(),w=0,S=(n=y,u=(o=i).speedAsDuration?o.speed:Math.abs(n/1e3*o.speed),o.durationMax&&u>o.durationMax?o.durationMax:o.durationMin&&u<o.durationMin?o.durationMin:parseInt(u,10)),E=function(e){var t,n,o;l||(l=e),w+=e-l,d=s+y*(n=m=1<(m=0===S?0:w/S)?1:m,"easeInQuad"===(t=i).easing&&(o=n*n),"easeOutQuad"===t.easing&&(o=n*(2-n)),"easeInOutQuad"===t.easing&&(o=n<.5?2*n*n:(4-2*n)*n-1),"easeInCubic"===t.easing&&(o=n*n*n),"easeOutCubic"===t.easing&&(o=--n*n*n+1),"easeInOutCubic"===t.easing&&(o=n<.5?4*n*n*n:(n-1)*(2*n-2)*(2*n-2)+1),"easeInQuart"===t.easing&&(o=n*n*n*n),"easeOutQuart"===t.easing&&(o=1- --n*n*n*n),"easeInOutQuart"===t.easing&&(o=n<.5?8*n*n*n*n:1-8*--n*n*n*n),"easeInQuint"===t.easing&&(o=n*n*n*n*n),"easeOutQuint"===t.easing&&(o=1+--n*n*n*n*n),"easeInOutQuint"===t.easing&&(o=n<.5?16*n*n*n*n*n:1+16*--n*n*n*n*n),t.customEasing&&(o=t.customEasing(n)),o||n),M.scrollTo(0,Math.floor(d)),(function(e,t){var n=M.pageYOffset;if(e==t||n==t||(s<t&&M.innerHeight+n)>=v)return C.cancelScroll(!0),x(a,t,c),H("scrollStop",i,a,r),!(O=l=null)})(d,g)||(O=M.requestAnimationFrame(E),l=e)};0===M.pageYOffset&&M.scrollTo(0,0),f=a,h=i,c||history.pushState&&h.updateURL&&history.pushState({smoothScroll:JSON.stringify(h),anchor:f.id},document.title,f===document.documentElement?"#top":"#"+f.id),"matchMedia"in M&&M.matchMedia("(prefers-reduced-motion)").matches?x(a,Math.floor(g),!1):(H("scrollStart",i,a,r),C.cancelScroll(!0),M.requestAnimationFrame(E))}};var t=function(e){if(!e.defaultPrevented&&!(0!==e.button||e.metaKey||e.ctrlKey||e.shiftKey)&&"closest"in e.target&&(a=e.target.closest(o))&&"a"===a.tagName.toLowerCase()&&!e.target.closest(b.ignore)&&a.hostname===M.location.hostname&&a.pathname===M.location.pathname&&/#/.test(a.href)){var t,n;try{t=r(decodeURIComponent(a.hash))}catch(e){t=r(a.hash)}if("#"===t){if(!b.topOnEmptyHash)return;n=document.documentElement}else n=document.querySelector(t);(n=n||"#top"!==t?n:document.documentElement)&&(e.preventDefault(),(function(e){if(history.replaceState&&e.updateURL&&!history.state){var t=M.location.hash;t=t||"",history.replaceState({smoothScroll:JSON.stringify(e),anchor:t||M.pageYOffset},document.title,t||M.location.href)}})(b),C.animateScroll(n,a))}},n=function(e){if(null!==history.state&&history.state.smoothScroll&&history.state.smoothScroll===JSON.stringify(b)){var t=history.state.anchor;"string"==typeof t&&t&&!(t=document.querySelector(r(history.state.anchor)))||C.animateScroll(t,null,{updateURL:!1})}};C.destroy=function(){b&&(document.removeEventListener("click",t,!1),M.removeEventListener("popstate",n,!1),C.cancelScroll(),O=A=a=b=null)};return (function(){if(!("querySelector"in document&&"addEventListener"in M&&"requestAnimationFrame"in M&&"closest"in M.Element.prototype))throw"Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";C.destroy(),b=I(q,e||{}),A=b.header?document.querySelector(b.header):null,document.addEventListener("click",t,!1),b.updateURL&&b.popstate&&M.addEventListener("popstate",n,!1)})(),C}}));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Accordion =
	/**
	* Constructs a new expander.
	* @param {object} options - Options.
	*/
	function Accordion(options) {
	  (0, _classCallCheck3.default)(this, Accordion);
	
	  this.element = options.element;
	  var acc = this.element.queryAll(".accordion");
	  var panel = this.element.queryAll('.panel');
	  for (var i = 0; i < acc.length; i++) {
	    acc[i].onclick = function () {
	      var setClasses = !this.classList.contains('active');
	      setClass(acc, 'active', 'remove');
	      setClass(panel, 'active', 'remove');
	      if (setClasses) {
	        this.classList.toggle("active");
	        this.nextElementSibling.classList.toggle("active");
	      }
	    };
	  }
	  function setClass(els, className, fnName) {
	    for (var i = 0; i < els.length; i++) {
	      els[i].classList[fnName](className);
	    }
	  }
	};
	
	exports.default = Accordion;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _smoothScroll = __webpack_require__(31);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @author Dayne Coulson-Hoffacker
	 */
	var PageHero =
	/**
	 * Constructs a PageHero component.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function PageHero(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, PageHero);
	
	  this.element = options.element;
	  this.ctaScroll = this.element.querySelector('[data-component="cta-scroll"]');
	  this.scrollTarget = this.element.nextElementSibling;
	  this.scroll = new _smoothScroll2.default();
	  this.scrollOptions = {
	    speed: 750,
	    updateURL: false,
	    header: '[data-component="global-header"]'
	  };
	
	  if (this.ctaScroll) {
	    this.ctaScroll.addEventListener('click', function () {
	      _this.scroll.animateScroll(_this.scrollTarget, _this.element, _this.scrollOptions);
	    });
	  }
	};
	
	exports.default = PageHero;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _bundle = __webpack_require__(35);
	
	var _bundle2 = _interopRequireDefault(_bundle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Slider component.
	 * @author Dayne Coulson-Hoffacker
	 */
	var Slider =
	/**
	 * Constructs a new Slider component.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function Slider(options) {
	  (0, _classCallCheck3.default)(this, Slider);
	
	  this.element = options.element;
	  this.swiperContainer = this.element.querySelector('.swiper-container');
	  this.sliderPrevButton = this.element.querySelector('button.previous');
	  this.sliderNextButton = this.element.querySelector('button.next');
	
	  var slider = new _bundle2.default(this.swiperContainer, {
	    loop: true,
	    slidesPerView: 1,
	    autoHeight: true,
	    watchOverflow: true,
	    pagination: {
	      el: '.swiper-pagination',
	      type: 'fraction'
	    }
	  });
	
	  this.sliderPrevButton.addEventListener('click', function () {
	    slider.slidePrev();
	  });
	
	  this.sliderNextButton.addEventListener('click', function () {
	    slider.slideNext();
	  });
	};
	
	exports.default = Slider;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Swiper 6.3.5
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * https://swiperjs.com
	 *
	 * Copyright 2014-2020 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: October 30, 2020
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var Swiper = _interopDefault(__webpack_require__(36));
	var Virtual = _interopDefault(__webpack_require__(107));
	var Keyboard = _interopDefault(__webpack_require__(108));
	var Mousewheel = _interopDefault(__webpack_require__(109));
	var Navigation = _interopDefault(__webpack_require__(110));
	var Pagination = _interopDefault(__webpack_require__(111));
	var Scrollbar = _interopDefault(__webpack_require__(112));
	var Parallax = _interopDefault(__webpack_require__(113));
	var Zoom = _interopDefault(__webpack_require__(114));
	var Lazy = _interopDefault(__webpack_require__(115));
	var Controller = _interopDefault(__webpack_require__(116));
	var A11y = _interopDefault(__webpack_require__(117));
	var History = _interopDefault(__webpack_require__(118));
	var HashNavigation = _interopDefault(__webpack_require__(119));
	var Autoplay = _interopDefault(__webpack_require__(120));
	var EffectFade = _interopDefault(__webpack_require__(121));
	var EffectCube = _interopDefault(__webpack_require__(122));
	var EffectFlip = _interopDefault(__webpack_require__(123));
	var EffectCoverflow = _interopDefault(__webpack_require__(124));
	var Thumbs = _interopDefault(__webpack_require__(125));
	
	// Swiper Class
	var components = [Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Lazy, Controller, A11y, History, HashNavigation, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs];
	Swiper.use(components);
	
	exports.Swiper = Swiper;
	exports.default = Swiper;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	var _getSupport = __webpack_require__(41);
	
	var _getDevice = __webpack_require__(42);
	
	var _getBrowser = __webpack_require__(43);
	
	var _resize = _interopRequireDefault(__webpack_require__(44));
	
	var _observer = _interopRequireDefault(__webpack_require__(45));
	
	var _modular = _interopRequireDefault(__webpack_require__(46));
	
	var _eventsEmitter = _interopRequireDefault(__webpack_require__(47));
	
	var _index = _interopRequireDefault(__webpack_require__(48));
	
	var _index2 = _interopRequireDefault(__webpack_require__(58));
	
	var _index3 = _interopRequireDefault(__webpack_require__(64));
	
	var _index4 = _interopRequireDefault(__webpack_require__(68));
	
	var _index5 = _interopRequireDefault(__webpack_require__(76));
	
	var _index6 = _interopRequireDefault(__webpack_require__(80));
	
	var _index7 = _interopRequireDefault(__webpack_require__(83));
	
	var _index8 = _interopRequireDefault(__webpack_require__(89));
	
	var _index9 = _interopRequireDefault(__webpack_require__(96));
	
	var _index10 = _interopRequireDefault(__webpack_require__(99));
	
	var _index11 = _interopRequireDefault(__webpack_require__(102));
	
	var _index12 = _interopRequireDefault(__webpack_require__(105));
	
	var _defaults = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var prototypes = {
	  modular: _modular.default,
	  eventsEmitter: _eventsEmitter.default,
	  update: _index.default,
	  translate: _index2.default,
	  transition: _index3.default,
	  slide: _index4.default,
	  loop: _index5.default,
	  grabCursor: _index6.default,
	  manipulation: _index7.default,
	  events: _index8.default,
	  breakpoints: _index9.default,
	  checkOverflow: _index12.default,
	  classes: _index10.default,
	  images: _index11.default
	};
	var extendedDefaults = {};
	
	var Swiper = /*#__PURE__*/function () {
	  function Swiper() {
	    var el;
	    var params;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	      params = args[0];
	    } else {
	      el = args[0];
	      params = args[1];
	    }
	
	    if (!params) params = {};
	    params = (0, _utils.extend)({}, params);
	    if (el && !params.el) params.el = el; // Swiper Instance
	
	    var swiper = this;
	    swiper.support = (0, _getSupport.getSupport)();
	    swiper.device = (0, _getDevice.getDevice)({
	      userAgent: params.userAgent
	    });
	    swiper.browser = (0, _getBrowser.getBrowser)();
	    swiper.eventsListeners = {};
	    swiper.eventsAnyListeners = [];
	
	    if (typeof swiper.modules === 'undefined') {
	      swiper.modules = {};
	    }
	
	    Object.keys(swiper.modules).forEach(function (moduleName) {
	      var module = swiper.modules[moduleName];
	
	      if (module.params) {
	        var moduleParamName = Object.keys(module.params)[0];
	        var moduleParams = module.params[moduleParamName];
	        if (typeof moduleParams !== 'object' || moduleParams === null) return;
	        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
	
	        if (params[moduleParamName] === true) {
	          params[moduleParamName] = {
	            enabled: true
	          };
	        }
	
	        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
	          params[moduleParamName].enabled = true;
	        }
	
	        if (!params[moduleParamName]) params[moduleParamName] = {
	          enabled: false
	        };
	      }
	    }); // Extend defaults with modules params
	
	    var swiperParams = (0, _utils.extend)({}, _defaults.default);
	    swiper.useParams(swiperParams); // Extend defaults with passed params
	
	    swiper.params = (0, _utils.extend)({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = (0, _utils.extend)({}, swiper.params);
	    swiper.passedParams = (0, _utils.extend)({}, params); // add event listeners
	
	    if (swiper.params && swiper.params.on) {
	      Object.keys(swiper.params.on).forEach(function (eventName) {
	        swiper.on(eventName, swiper.params.on[eventName]);
	      });
	    }
	
	    if (swiper.params && swiper.params.onAny) {
	      swiper.onAny(swiper.params.onAny);
	    } // Save Dom lib
	
	
	    swiper.$ = _dom.default; // Find el
	
	    var $el = (0, _dom.default)(swiper.params.el);
	    el = $el[0];
	
	    if (!el) {
	      return undefined;
	    }
	
	    if ($el.length > 1) {
	      var swipers = [];
	      $el.each(function (containerEl) {
	        var newParams = (0, _utils.extend)({}, params, {
	          el: containerEl
	        });
	        swipers.push(new Swiper(newParams));
	      });
	      return swipers;
	    }
	
	    el.swiper = swiper; // Find Wrapper
	
	    var $wrapperEl;
	
	    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
	      $wrapperEl = (0, _dom.default)(el.shadowRoot.querySelector("." + swiper.params.wrapperClass)); // Children needs to return slot items
	
	      $wrapperEl.children = function (options) {
	        return $el.children(options);
	      };
	    } else {
	      $wrapperEl = $el.children("." + swiper.params.wrapperClass);
	    } // Extend Swiper
	
	
	    (0, _utils.extend)(swiper, {
	      $el: $el,
	      el: el,
	      $wrapperEl: $wrapperEl,
	      wrapperEl: $wrapperEl[0],
	      // Classes
	      classNames: [],
	      // Slides
	      slides: (0, _dom.default)(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],
	      // isDirection
	      isHorizontal: function isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical: function isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	      // RTL
	      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
	      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box',
	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	      //
	      isBeginning: true,
	      isEnd: false,
	      // Props
	      translate: 0,
	      previousTranslate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	      // Touch Events
	      touchEvents: function touchEvents() {
	        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
	        var desktop = ['mousedown', 'mousemove', 'mouseup'];
	
	        if (swiper.support.pointerEvents) {
	          desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        }
	
	        swiper.touchEventsTouch = {
	          start: touch[0],
	          move: touch[1],
	          end: touch[2],
	          cancel: touch[3]
	        };
	        swiper.touchEventsDesktop = {
	          start: desktop[0],
	          move: desktop[1],
	          end: desktop[2]
	        };
	        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	      }(),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        formElements: 'input, select, option, textarea, button, video, label',
	        // Last click time
	        lastClickTime: (0, _utils.now)(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined
	      },
	      // Clicks
	      allowClick: true,
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0
	      },
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0
	    }); // Install Modules
	
	    swiper.useModules();
	    swiper.emit('_swiper'); // Init
	
	    if (swiper.params.init) {
	      swiper.init();
	    } // Return app instance
	
	
	    return swiper;
	  }
	
	  var _proto = Swiper.prototype;
	
	  _proto.emitContainerClasses = function emitContainerClasses() {
	    var swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    var classes = swiper.el.className.split(' ').filter(function (className) {
	      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
	    });
	    swiper.emit('_containerClasses', classes.join(' '));
	  };
	
	  _proto.getSlideClasses = function getSlideClasses(slideEl) {
	    var swiper = this;
	    return slideEl.className.split(' ').filter(function (className) {
	      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
	    }).join(' ');
	  };
	
	  _proto.emitSlidesClasses = function emitSlidesClasses() {
	    var swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    swiper.slides.each(function (slideEl) {
	      var classNames = swiper.getSlideClasses(slideEl);
	      swiper.emit('_slideClass', slideEl, classNames);
	    });
	  };
	
	  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
	    var swiper = this;
	    var params = swiper.params,
	        slides = swiper.slides,
	        slidesGrid = swiper.slidesGrid,
	        swiperSize = swiper.size,
	        activeIndex = swiper.activeIndex;
	    var spv = 1;
	
	    if (params.centeredSlides) {
	      var slideSize = slides[activeIndex].swiperSlideSize;
	      var breakLoop;
	
	      for (var i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	
	      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
	        if (slides[_i] && !breakLoop) {
	          slideSize += slides[_i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	    } else {
	      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
	        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
	          spv += 1;
	        }
	      }
	    }
	
	    return spv;
	  };
	
	  _proto.update = function update() {
	    var swiper = this;
	    if (!swiper || swiper.destroyed) return;
	    var snapGrid = swiper.snapGrid,
	        params = swiper.params; // Breakpoints
	
	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	
	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();
	
	    function setTranslate() {
	      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	
	    var translated;
	
	    if (swiper.params.freeMode) {
	      setTranslate();
	
	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	
	      if (!translated) {
	        setTranslate();
	      }
	    }
	
	    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }
	
	    swiper.emit('update');
	  };
	
	  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
	    if (needUpdate === void 0) {
	      needUpdate = true;
	    }
	
	    var swiper = this;
	    var currentDirection = swiper.params.direction;
	
	    if (!newDirection) {
	      // eslint-disable-next-line
	      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	    }
	
	    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
	      return swiper;
	    }
	
	    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
	    swiper.emitContainerClasses();
	    swiper.params.direction = newDirection;
	    swiper.slides.each(function (slideEl) {
	      if (newDirection === 'vertical') {
	        slideEl.style.width = '';
	      } else {
	        slideEl.style.height = '';
	      }
	    });
	    swiper.emit('changeDirection');
	    if (needUpdate) swiper.update();
	    return swiper;
	  };
	
	  _proto.init = function init() {
	    var swiper = this;
	    if (swiper.initialized) return;
	    swiper.emit('beforeInit'); // Set breakpoint
	
	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    } // Add Classes
	
	
	    swiper.addClasses(); // Create loop
	
	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    } // Update size
	
	
	    swiper.updateSize(); // Update slides
	
	    swiper.updateSlides();
	
	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    } // Set Grab Cursor
	
	
	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }
	
	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    } // Slide To Initial Slide
	
	
	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	    } // Attach events
	
	
	    swiper.attachEvents(); // Init Flag
	
	    swiper.initialized = true; // Emit
	
	    swiper.emit('init');
	    swiper.emit('afterInit');
	  };
	
	  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
	    if (deleteInstance === void 0) {
	      deleteInstance = true;
	    }
	
	    if (cleanStyles === void 0) {
	      cleanStyles = true;
	    }
	
	    var swiper = this;
	    var params = swiper.params,
	        $el = swiper.$el,
	        $wrapperEl = swiper.$wrapperEl,
	        slides = swiper.slides;
	
	    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	      return null;
	    }
	
	    swiper.emit('beforeDestroy'); // Init Flag
	
	    swiper.initialized = false; // Detach events
	
	    swiper.detachEvents(); // Destroy loop
	
	    if (params.loop) {
	      swiper.loopDestroy();
	    } // Cleanup styles
	
	
	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');
	
	      if (slides && slides.length) {
	        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
	      }
	    }
	
	    swiper.emit('destroy'); // Detach emitter events
	
	    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	      swiper.off(eventName);
	    });
	
	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      (0, _utils.deleteProps)(swiper);
	    }
	
	    swiper.destroyed = true;
	    return null;
	  };
	
	  Swiper.extendDefaults = function extendDefaults(newDefaults) {
	    (0, _utils.extend)(extendedDefaults, newDefaults);
	  };
	
	  Swiper.installModule = function installModule(module) {
	    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
	    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + (0, _utils.now)();
	    Swiper.prototype.modules[name] = module;
	  };
	
	  Swiper.use = function use(module) {
	    if (Array.isArray(module)) {
	      module.forEach(function (m) {
	        return Swiper.installModule(m);
	      });
	      return Swiper;
	    }
	
	    Swiper.installModule(module);
	    return Swiper;
	  };
	
	  _createClass(Swiper, null, [{
	    key: "extendedDefaults",
	    get: function get() {
	      return extendedDefaults;
	    }
	  }, {
	    key: "defaults",
	    get: function get() {
	      return _defaults.default;
	    }
	  }]);
	
	  return Swiper;
	}();
	
	Object.keys(prototypes).forEach(function (prototypeGroup) {
	  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	  });
	});
	Swiper.use([_resize.default, _observer.default]);
	var _default = Swiper;
	exports.default = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = __webpack_require__(38);
	
	var Methods = {
	  addClass: _dom.addClass,
	  removeClass: _dom.removeClass,
	  hasClass: _dom.hasClass,
	  toggleClass: _dom.toggleClass,
	  attr: _dom.attr,
	  removeAttr: _dom.removeAttr,
	  transform: _dom.transform,
	  transition: _dom.transition,
	  on: _dom.on,
	  off: _dom.off,
	  trigger: _dom.trigger,
	  transitionEnd: _dom.transitionEnd,
	  outerWidth: _dom.outerWidth,
	  outerHeight: _dom.outerHeight,
	  styles: _dom.styles,
	  offset: _dom.offset,
	  css: _dom.css,
	  each: _dom.each,
	  html: _dom.html,
	  text: _dom.text,
	  is: _dom.is,
	  index: _dom.index,
	  eq: _dom.eq,
	  append: _dom.append,
	  prepend: _dom.prepend,
	  next: _dom.next,
	  nextAll: _dom.nextAll,
	  prev: _dom.prev,
	  prevAll: _dom.prevAll,
	  parent: _dom.parent,
	  parents: _dom.parents,
	  closest: _dom.closest,
	  find: _dom.find,
	  children: _dom.children,
	  filter: _dom.filter,
	  remove: _dom.remove
	};
	Object.keys(Methods).forEach(function (methodName) {
	  _dom.$.fn[methodName] = Methods[methodName];
	});
	var _default = _dom.$;
	exports.default = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Dom7 3.0.0
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * https://framework7.io/docs/dom7.html
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var ssrWindow = __webpack_require__(39);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	
	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _construct(Parent, args, Class) {
	  if (_isNativeReflectConstruct()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf(instance, Class.prototype);
	      return instance;
	    };
	  }
	
	  return _construct.apply(null, arguments);
	}
	
	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}
	
	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;
	
	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;
	
	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);
	
	      _cache.set(Class, Wrapper);
	    }
	
	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
	    }
	
	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf(Wrapper, Class);
	  };
	
	  return _wrapNativeSuper(Class);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	/* eslint-disable no-proto */
	function makeReactive(obj) {
	  var proto = obj.__proto__;
	  Object.defineProperty(obj, '__proto__', {
	    get: function get() {
	      return proto;
	    },
	    set: function set(value) {
	      proto.__proto__ = value;
	    }
	  });
	}
	
	var Dom7 = /*#__PURE__*/function (_Array) {
	  _inheritsLoose(Dom7, _Array);
	
	  function Dom7(items) {
	    var _this;
	
	    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
	    makeReactive(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  return Dom7;
	}( /*#__PURE__*/_wrapNativeSuper(Array));
	
	function arrayFlat(arr) {
	  if (arr === void 0) {
	    arr = [];
	  }
	
	  var res = [];
	  arr.forEach(function (el) {
	    if (Array.isArray(el)) {
	      res.push.apply(res, arrayFlat(el));
	    } else {
	      res.push(el);
	    }
	  });
	  return res;
	}
	function arrayFilter(arr, callback) {
	  return Array.prototype.filter.call(arr, callback);
	}
	function arrayUnique(arr) {
	  var uniqueArray = [];
	
	  for (var i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
	  }
	
	  return uniqueArray;
	}
	function toCamelCase(string) {
	  return string.toLowerCase().replace(/-(.)/g, function (match, group) {
	    return group.toUpperCase();
	  });
	}
	
	function qsa(selector, context) {
	  if (typeof selector !== 'string') {
	    return [selector];
	  }
	
	  var a = [];
	  var res = context.querySelectorAll(selector);
	
	  for (var i = 0; i < res.length; i += 1) {
	    a.push(res[i]);
	  }
	
	  return a;
	}
	
	function $(selector, context) {
	  var window = ssrWindow.getWindow();
	  var document = ssrWindow.getDocument();
	  var arr = [];
	
	  if (!context && selector instanceof Dom7) {
	    return selector;
	  }
	
	  if (!selector) {
	    return new Dom7(arr);
	  }
	
	  if (typeof selector === 'string') {
	    var html = selector.trim();
	
	    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	      var toCreate = 'div';
	      if (html.indexOf('<li') === 0) toCreate = 'ul';
	      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	      if (html.indexOf('<tbody') === 0) toCreate = 'table';
	      if (html.indexOf('<option') === 0) toCreate = 'select';
	      var tempParent = document.createElement(toCreate);
	      tempParent.innerHTML = html;
	
	      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
	        arr.push(tempParent.childNodes[i]);
	      }
	    } else {
	      arr = qsa(selector.trim(), context || document);
	    } // arr = qsa(selector, document);
	
	  } else if (selector.nodeType || selector === window || selector === document) {
	    arr.push(selector);
	  } else if (Array.isArray(selector)) {
	    if (selector instanceof Dom7) return selector;
	    arr = selector;
	  }
	
	  return new Dom7(arrayUnique(arr));
	}
	
	$.fn = Dom7.prototype;
	
	function addClass() {
	  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
	    classes[_key] = arguments[_key];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList;
	
	    (_el$classList = el.classList).add.apply(_el$classList, classNames);
	  });
	  return this;
	}
	
	function removeClass() {
	  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    classes[_key2] = arguments[_key2];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList2;
	
	    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
	  });
	  return this;
	}
	
	function toggleClass() {
	  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    classes[_key3] = arguments[_key3];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    classNames.forEach(function (className) {
	      el.classList.toggle(className);
	    });
	  });
	}
	
	function hasClass() {
	  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    classes[_key4] = arguments[_key4];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  return arrayFilter(this, function (el) {
	    return classNames.filter(function (className) {
	      return el.classList.contains(className);
	    }).length > 0;
	  }).length > 0;
	}
	
	function attr(attrs, value) {
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) return this[0].getAttribute(attrs);
	    return undefined;
	  } // Set attrs
	
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (arguments.length === 2) {
	      // String
	      this[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      for (var attrName in attrs) {
	        this[i][attrName] = attrs[attrName];
	        this[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }
	
	  return this;
	}
	
	function removeAttr(attr) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].removeAttribute(attr);
	  }
	
	  return this;
	}
	
	function prop(props, value) {
	  if (arguments.length === 1 && typeof props === 'string') {
	    // Get prop
	    if (this[0]) return this[0][props];
	  } else {
	    // Set props
	    for (var i = 0; i < this.length; i += 1) {
	      if (arguments.length === 2) {
	        // String
	        this[i][props] = value;
	      } else {
	        // Object
	        for (var propName in props) {
	          this[i][propName] = props[propName];
	        }
	      }
	    }
	
	    return this;
	  }
	
	  return this;
	}
	
	function data(key, value) {
	  var el;
	
	  if (typeof value === 'undefined') {
	    el = this[0];
	    if (!el) return undefined; // Get value
	
	    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
	      return el.dom7ElementDataStorage[key];
	    }
	
	    var dataKey = el.getAttribute("data-" + key);
	
	    if (dataKey) {
	      return dataKey;
	    }
	
	    return undefined;
	  } // Set value
	
	
	  for (var i = 0; i < this.length; i += 1) {
	    el = this[i];
	    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
	    el.dom7ElementDataStorage[key] = value;
	  }
	
	  return this;
	}
	
	function removeData(key) {
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
	      el.dom7ElementDataStorage[key] = null;
	      delete el.dom7ElementDataStorage[key];
	    }
	  }
	}
	
	function dataset() {
	  var el = this[0];
	  if (!el) return undefined;
	  var dataset = {}; // eslint-disable-line
	
	  if (el.dataset) {
	    for (var dataKey in el.dataset) {
	      dataset[dataKey] = el.dataset[dataKey];
	    }
	  } else {
	    for (var i = 0; i < el.attributes.length; i += 1) {
	      var _attr = el.attributes[i];
	
	      if (_attr.name.indexOf('data-') >= 0) {
	        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
	      }
	    }
	  }
	
	  for (var key in dataset) {
	    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
	  }
	
	  return dataset;
	}
	
	function val(value) {
	  if (typeof value === 'undefined') {
	    // get value
	    var el = this[0];
	    if (!el) return undefined;
	
	    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
	      var values = [];
	
	      for (var i = 0; i < el.selectedOptions.length; i += 1) {
	        values.push(el.selectedOptions[i].value);
	      }
	
	      return values;
	    }
	
	    return el.value;
	  } // set value
	
	
	  for (var _i = 0; _i < this.length; _i += 1) {
	    var _el = this[_i];
	
	    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
	      for (var j = 0; j < _el.options.length; j += 1) {
	        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
	      }
	    } else {
	      _el.value = value;
	    }
	  }
	
	  return this;
	}
	
	function value(value) {
	  return this.val(value);
	}
	
	function transform(transform) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.transform = transform;
	  }
	
	  return this;
	}
	
	function transition(duration) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
	  }
	
	  return this;
	}
	
	function on() {
	  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    args[_key5] = arguments[_key5];
	  }
	
	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];
	
	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }
	
	  if (!capture) capture = false;
	
	  function handleLiveEvent(e) {
	    var target = e.target;
	    if (!target) return;
	    var eventData = e.target.dom7EventData || [];
	
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	
	    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
	      var _parents = $(target).parents(); // eslint-disable-line
	
	
	      for (var k = 0; k < _parents.length; k += 1) {
	        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
	      }
	    }
	  }
	
	  function handleEvent(e) {
	    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	
	    listener.apply(this, eventData);
	  }
	
	  var events = eventType.split(' ');
	  var j;
	
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        var event = events[j];
	        if (!el.dom7Listeners) el.dom7Listeners = {};
	        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
	        el.dom7Listeners[event].push({
	          listener: listener,
	          proxyListener: handleEvent
	        });
	        el.addEventListener(event, handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        var _event = events[j];
	        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
	        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
	
	        el.dom7LiveListeners[_event].push({
	          listener: listener,
	          proxyListener: handleLiveEvent
	        });
	
	        el.addEventListener(_event, handleLiveEvent, capture);
	      }
	    }
	  }
	
	  return this;
	}
	
	function off() {
	  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    args[_key6] = arguments[_key6];
	  }
	
	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];
	
	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }
	
	  if (!capture) capture = false;
	  var events = eventType.split(' ');
	
	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];
	
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this[j];
	      var handlers = void 0;
	
	      if (!targetSelector && el.dom7Listeners) {
	        handlers = el.dom7Listeners[event];
	      } else if (targetSelector && el.dom7LiveListeners) {
	        handlers = el.dom7LiveListeners[event];
	      }
	
	      if (handlers && handlers.length) {
	        for (var k = handlers.length - 1; k >= 0; k -= 1) {
	          var handler = handlers[k];
	
	          if (listener && handler.listener === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (!listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          }
	        }
	      }
	    }
	  }
	
	  return this;
	}
	
	function once() {
	  var dom = this;
	
	  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	    args[_key7] = arguments[_key7];
	  }
	
	  var eventName = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];
	
	  if (typeof args[1] === 'function') {
	    eventName = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }
	
	  function onceHandler() {
	    for (var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	      eventArgs[_key8] = arguments[_key8];
	    }
	
	    listener.apply(this, eventArgs);
	    dom.off(eventName, targetSelector, onceHandler, capture);
	
	    if (onceHandler.dom7proxy) {
	      delete onceHandler.dom7proxy;
	    }
	  }
	
	  onceHandler.dom7proxy = listener;
	  return dom.on(eventName, targetSelector, onceHandler, capture);
	}
	
	function trigger() {
	  var window = ssrWindow.getWindow();
	
	  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
	    args[_key9] = arguments[_key9];
	  }
	
	  var events = args[0].split(' ');
	  var eventData = args[1];
	
	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];
	
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this[j];
	
	      if (window.CustomEvent) {
	        var evt = new window.CustomEvent(event, {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true
	        });
	        el.dom7EventData = args.filter(function (data, dataIndex) {
	          return dataIndex > 0;
	        });
	        el.dispatchEvent(evt);
	        el.dom7EventData = [];
	        delete el.dom7EventData;
	      }
	    }
	  }
	
	  return this;
	}
	
	function transitionEnd(callback) {
	  var dom = this;
	
	  function fireCallBack(e) {
	    if (e.target !== this) return;
	    callback.call(this, e);
	    dom.off('transitionend', fireCallBack);
	  }
	
	  if (callback) {
	    dom.on('transitionend', fireCallBack);
	  }
	
	  return this;
	}
	
	function animationEnd(callback) {
	  var dom = this;
	
	  function fireCallBack(e) {
	    if (e.target !== this) return;
	    callback.call(this, e);
	    dom.off('animationend', fireCallBack);
	  }
	
	  if (callback) {
	    dom.on('animationend', fireCallBack);
	  }
	
	  return this;
	}
	
	function width() {
	  var window = ssrWindow.getWindow();
	
	  if (this[0] === window) {
	    return window.innerWidth;
	  }
	
	  if (this.length > 0) {
	    return parseFloat(this.css('width'));
	  }
	
	  return null;
	}
	
	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      var _styles = this.styles();
	
	      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
	    }
	
	    return this[0].offsetWidth;
	  }
	
	  return null;
	}
	
	function height() {
	  var window = ssrWindow.getWindow();
	
	  if (this[0] === window) {
	    return window.innerHeight;
	  }
	
	  if (this.length > 0) {
	    return parseFloat(this.css('height'));
	  }
	
	  return null;
	}
	
	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      var _styles2 = this.styles();
	
	      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
	    }
	
	    return this[0].offsetHeight;
	  }
	
	  return null;
	}
	
	function offset() {
	  if (this.length > 0) {
	    var window = ssrWindow.getWindow();
	    var document = ssrWindow.getDocument();
	    var el = this[0];
	    var box = el.getBoundingClientRect();
	    var body = document.body;
	    var clientTop = el.clientTop || body.clientTop || 0;
	    var clientLeft = el.clientLeft || body.clientLeft || 0;
	    var scrollTop = el === window ? window.scrollY : el.scrollTop;
	    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	    return {
	      top: box.top + scrollTop - clientTop,
	      left: box.left + scrollLeft - clientLeft
	    };
	  }
	
	  return null;
	}
	
	function hide() {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.display = 'none';
	  }
	
	  return this;
	}
	
	function show() {
	  var window = ssrWindow.getWindow();
	
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (el.style.display === 'none') {
	      el.style.display = '';
	    }
	
	    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
	      // Still not visible
	      el.style.display = 'block';
	    }
	  }
	
	  return this;
	}
	
	function styles() {
	  var window = ssrWindow.getWindow();
	  if (this[0]) return window.getComputedStyle(this[0], null);
	  return {};
	}
	
	function css(props, value) {
	  var window = ssrWindow.getWindow();
	  var i;
	
	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      // .css('width')
	      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	    } else {
	      // .css({ width: '100px' })
	      for (i = 0; i < this.length; i += 1) {
	        for (var _prop in props) {
	          this[i].style[_prop] = props[_prop];
	        }
	      }
	
	      return this;
	    }
	  }
	
	  if (arguments.length === 2 && typeof props === 'string') {
	    // .css('width', '100px')
	    for (i = 0; i < this.length; i += 1) {
	      this[i].style[props] = value;
	    }
	
	    return this;
	  }
	
	  return this;
	}
	
	function each(callback) {
	  if (!callback) return this;
	  this.forEach(function (el, index) {
	    callback.apply(el, [el, index]);
	  });
	  return this;
	}
	
	function filter(callback) {
	  var result = arrayFilter(this, callback);
	  return $(result);
	}
	
	function html(html) {
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : null;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].innerHTML = html;
	  }
	
	  return this;
	}
	
	function text(text) {
	  if (typeof text === 'undefined') {
	    return this[0] ? this[0].textContent.trim() : null;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].textContent = text;
	  }
	
	  return this;
	}
	
	function is(selector) {
	  var window = ssrWindow.getWindow();
	  var document = ssrWindow.getDocument();
	  var el = this[0];
	  var compareWith;
	  var i;
	  if (!el || typeof selector === 'undefined') return false;
	
	  if (typeof selector === 'string') {
	    if (el.matches) return el.matches(selector);
	    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	    compareWith = $(selector);
	
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }
	
	    return false;
	  }
	
	  if (selector === document) {
	    return el === document;
	  }
	
	  if (selector === window) {
	    return el === window;
	  }
	
	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;
	
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }
	
	    return false;
	  }
	
	  return false;
	}
	
	function index() {
	  var child = this[0];
	  var i;
	
	  if (child) {
	    i = 0; // eslint-disable-next-line
	
	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) i += 1;
	    }
	
	    return i;
	  }
	
	  return undefined;
	}
	
	function eq(index) {
	  if (typeof index === 'undefined') return this;
	  var length = this.length;
	
	  if (index > length - 1) {
	    return $([]);
	  }
	
	  if (index < 0) {
	    var returnIndex = length + index;
	    if (returnIndex < 0) return $([]);
	    return $([this[returnIndex]]);
	  }
	
	  return $([this[index]]);
	}
	
	function append() {
	  var newChild;
	  var document = ssrWindow.getDocument();
	
	  for (var k = 0; k < arguments.length; k += 1) {
	    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
	
	    for (var i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = document.createElement('div');
	        tempDiv.innerHTML = newChild;
	
	        while (tempDiv.firstChild) {
	          this[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (var j = 0; j < newChild.length; j += 1) {
	          this[i].appendChild(newChild[j]);
	        }
	      } else {
	        this[i].appendChild(newChild);
	      }
	    }
	  }
	
	  return this;
	}
	
	function appendTo(parent) {
	  $(parent).append(this);
	  return this;
	}
	
	function prepend(newChild) {
	  var document = ssrWindow.getDocument();
	  var i;
	  var j;
	
	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      var tempDiv = document.createElement('div');
	      tempDiv.innerHTML = newChild;
	
	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	      }
	    } else {
	      this[i].insertBefore(newChild, this[i].childNodes[0]);
	    }
	  }
	
	  return this;
	}
	
	function prependTo(parent) {
	  $(parent).prepend(this);
	  return this;
	}
	
	function insertBefore(selector) {
	  var before = $(selector);
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (before.length === 1) {
	      before[0].parentNode.insertBefore(this[i], before[0]);
	    } else if (before.length > 1) {
	      for (var j = 0; j < before.length; j += 1) {
	        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
	      }
	    }
	  }
	}
	
	function insertAfter(selector) {
	  var after = $(selector);
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (after.length === 1) {
	      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
	    } else if (after.length > 1) {
	      for (var j = 0; j < after.length; j += 1) {
	        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
	      }
	    }
	  }
	}
	
	function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	        return $([this[0].nextElementSibling]);
	      }
	
	      return $([]);
	    }
	
	    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
	    return $([]);
	  }
	
	  return $([]);
	}
	
	function nextAll(selector) {
	  var nextEls = [];
	  var el = this[0];
	  if (!el) return $([]);
	
	  while (el.nextElementSibling) {
	    var _next = el.nextElementSibling; // eslint-disable-line
	
	    if (selector) {
	      if ($(_next).is(selector)) nextEls.push(_next);
	    } else nextEls.push(_next);
	
	    el = _next;
	  }
	
	  return $(nextEls);
	}
	
	function prev(selector) {
	  if (this.length > 0) {
	    var el = this[0];
	
	    if (selector) {
	      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	        return $([el.previousElementSibling]);
	      }
	
	      return $([]);
	    }
	
	    if (el.previousElementSibling) return $([el.previousElementSibling]);
	    return $([]);
	  }
	
	  return $([]);
	}
	
	function prevAll(selector) {
	  var prevEls = [];
	  var el = this[0];
	  if (!el) return $([]);
	
	  while (el.previousElementSibling) {
	    var _prev = el.previousElementSibling; // eslint-disable-line
	
	    if (selector) {
	      if ($(_prev).is(selector)) prevEls.push(_prev);
	    } else prevEls.push(_prev);
	
	    el = _prev;
	  }
	
	  return $(prevEls);
	}
	
	function siblings(selector) {
	  return this.nextAll(selector).add(this.prevAll(selector));
	}
	
	function parent(selector) {
	  var parents = []; // eslint-disable-line
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode !== null) {
	      if (selector) {
	        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	      } else {
	        parents.push(this[i].parentNode);
	      }
	    }
	  }
	
	  return $(parents);
	}
	
	function parents(selector) {
	  var parents = []; // eslint-disable-line
	
	  for (var i = 0; i < this.length; i += 1) {
	    var _parent = this[i].parentNode; // eslint-disable-line
	
	    while (_parent) {
	      if (selector) {
	        if ($(_parent).is(selector)) parents.push(_parent);
	      } else {
	        parents.push(_parent);
	      }
	
	      _parent = _parent.parentNode;
	    }
	  }
	
	  return $(parents);
	}
	
	function closest(selector) {
	  var closest = this; // eslint-disable-line
	
	  if (typeof selector === 'undefined') {
	    return $([]);
	  }
	
	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }
	
	  return closest;
	}
	
	function find(selector) {
	  var foundElements = [];
	
	  for (var i = 0; i < this.length; i += 1) {
	    var found = this[i].querySelectorAll(selector);
	
	    for (var j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }
	
	  return $(foundElements);
	}
	
	function children(selector) {
	  var children = []; // eslint-disable-line
	
	  for (var i = 0; i < this.length; i += 1) {
	    var childNodes = this[i].children;
	
	    for (var j = 0; j < childNodes.length; j += 1) {
	      if (!selector || $(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }
	
	  return $(children);
	}
	
	function remove() {
	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	  }
	
	  return this;
	}
	
	function detach() {
	  return this.remove();
	}
	
	function add() {
	  var dom = this;
	  var i;
	  var j;
	
	  for (var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
	    els[_key10] = arguments[_key10];
	  }
	
	  for (i = 0; i < els.length; i += 1) {
	    var toAdd = $(els[i]);
	
	    for (j = 0; j < toAdd.length; j += 1) {
	      dom.push(toAdd[j]);
	    }
	  }
	
	  return dom;
	}
	
	function empty() {
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (el.nodeType === 1) {
	      for (var j = 0; j < el.childNodes.length; j += 1) {
	        if (el.childNodes[j].parentNode) {
	          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
	        }
	      }
	
	      el.textContent = '';
	    }
	  }
	
	  return this;
	}
	
	function scrollTo() {
	  var window = ssrWindow.getWindow();
	
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var left = args[0],
	      top = args[1],
	      duration = args[2],
	      easing = args[3],
	      callback = args[4];
	
	  if (args.length === 4 && typeof easing === 'function') {
	    callback = easing;
	    left = args[0];
	    top = args[1];
	    duration = args[2];
	    callback = args[3];
	    easing = args[4];
	  }
	
	  if (typeof easing === 'undefined') easing = 'swing';
	  return this.each(function animate() {
	    var el = this;
	    var currentTop;
	    var currentLeft;
	    var maxTop;
	    var maxLeft;
	    var newTop;
	    var newLeft;
	    var scrollTop; // eslint-disable-line
	
	    var scrollLeft; // eslint-disable-line
	
	    var animateTop = top > 0 || top === 0;
	    var animateLeft = left > 0 || left === 0;
	
	    if (typeof easing === 'undefined') {
	      easing = 'swing';
	    }
	
	    if (animateTop) {
	      currentTop = el.scrollTop;
	
	      if (!duration) {
	        el.scrollTop = top;
	      }
	    }
	
	    if (animateLeft) {
	      currentLeft = el.scrollLeft;
	
	      if (!duration) {
	        el.scrollLeft = left;
	      }
	    }
	
	    if (!duration) return;
	
	    if (animateTop) {
	      maxTop = el.scrollHeight - el.offsetHeight;
	      newTop = Math.max(Math.min(top, maxTop), 0);
	    }
	
	    if (animateLeft) {
	      maxLeft = el.scrollWidth - el.offsetWidth;
	      newLeft = Math.max(Math.min(left, maxLeft), 0);
	    }
	
	    var startTime = null;
	    if (animateTop && newTop === currentTop) animateTop = false;
	    if (animateLeft && newLeft === currentLeft) animateLeft = false;
	
	    function render(time) {
	      if (time === void 0) {
	        time = new Date().getTime();
	      }
	
	      if (startTime === null) {
	        startTime = time;
	      }
	
	      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
	      var done;
	      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
	      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
	
	      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
	        el.scrollTop = newTop;
	        done = true;
	      }
	
	      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
	        el.scrollTop = newTop;
	        done = true;
	      }
	
	      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
	        el.scrollLeft = newLeft;
	        done = true;
	      }
	
	      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
	        el.scrollLeft = newLeft;
	        done = true;
	      }
	
	      if (done) {
	        if (callback) callback();
	        return;
	      }
	
	      if (animateTop) el.scrollTop = scrollTop;
	      if (animateLeft) el.scrollLeft = scrollLeft;
	      window.requestAnimationFrame(render);
	    }
	
	    window.requestAnimationFrame(render);
	  });
	} // scrollTop(top, duration, easing, callback) {
	
	
	function scrollTop() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var top = args[0],
	      duration = args[1],
	      easing = args[2],
	      callback = args[3];
	
	  if (args.length === 3 && typeof easing === 'function') {
	    top = args[0];
	    duration = args[1];
	    callback = args[2];
	    easing = args[3];
	  }
	
	  var dom = this;
	
	  if (typeof top === 'undefined') {
	    if (dom.length > 0) return dom[0].scrollTop;
	    return null;
	  }
	
	  return dom.scrollTo(undefined, top, duration, easing, callback);
	}
	
	function scrollLeft() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  var left = args[0],
	      duration = args[1],
	      easing = args[2],
	      callback = args[3];
	
	  if (args.length === 3 && typeof easing === 'function') {
	    left = args[0];
	    duration = args[1];
	    callback = args[2];
	    easing = args[3];
	  }
	
	  var dom = this;
	
	  if (typeof left === 'undefined') {
	    if (dom.length > 0) return dom[0].scrollLeft;
	    return null;
	  }
	
	  return dom.scrollTo(left, undefined, duration, easing, callback);
	}
	
	function animate(initialProps, initialParams) {
	  var window = ssrWindow.getWindow();
	  var els = this;
	  var a = {
	    props: Object.assign({}, initialProps),
	    params: Object.assign({
	      duration: 300,
	      easing: 'swing' // or 'linear'
	
	      /* Callbacks
	      begin(elements)
	      complete(elements)
	      progress(elements, complete, remaining, start, tweenValue)
	      */
	
	    }, initialParams),
	    elements: els,
	    animating: false,
	    que: [],
	    easingProgress: function easingProgress(easing, progress) {
	      if (easing === 'swing') {
	        return 0.5 - Math.cos(progress * Math.PI) / 2;
	      }
	
	      if (typeof easing === 'function') {
	        return easing(progress);
	      }
	
	      return progress;
	    },
	    stop: function stop() {
	      if (a.frameId) {
	        window.cancelAnimationFrame(a.frameId);
	      }
	
	      a.animating = false;
	      a.elements.each(function (el) {
	        var element = el;
	        delete element.dom7AnimateInstance;
	      });
	      a.que = [];
	    },
	    done: function done(complete) {
	      a.animating = false;
	      a.elements.each(function (el) {
	        var element = el;
	        delete element.dom7AnimateInstance;
	      });
	      if (complete) complete(els);
	
	      if (a.que.length > 0) {
	        var que = a.que.shift();
	        a.animate(que[0], que[1]);
	      }
	    },
	    animate: function animate(props, params) {
	      if (a.animating) {
	        a.que.push([props, params]);
	        return a;
	      }
	
	      var elements = []; // Define & Cache Initials & Units
	
	      a.elements.each(function (el, index) {
	        var initialFullValue;
	        var initialValue;
	        var unit;
	        var finalValue;
	        var finalFullValue;
	        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
	        elements[index] = {
	          container: el
	        };
	        Object.keys(props).forEach(function (prop) {
	          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
	          initialValue = parseFloat(initialFullValue);
	          unit = initialFullValue.replace(initialValue, '');
	          finalValue = parseFloat(props[prop]);
	          finalFullValue = props[prop] + unit;
	          elements[index][prop] = {
	            initialFullValue: initialFullValue,
	            initialValue: initialValue,
	            unit: unit,
	            finalValue: finalValue,
	            finalFullValue: finalFullValue,
	            currentValue: initialValue
	          };
	        });
	      });
	      var startTime = null;
	      var time;
	      var elementsDone = 0;
	      var propsDone = 0;
	      var done;
	      var began = false;
	      a.animating = true;
	
	      function render() {
	        time = new Date().getTime();
	        var progress;
	        var easeProgress; // let el;
	
	        if (!began) {
	          began = true;
	          if (params.begin) params.begin(els);
	        }
	
	        if (startTime === null) {
	          startTime = time;
	        }
	
	        if (params.progress) {
	          // eslint-disable-next-line
	          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
	        }
	
	        elements.forEach(function (element) {
	          var el = element;
	          if (done || el.done) return;
	          Object.keys(props).forEach(function (prop) {
	            if (done || el.done) return;
	            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
	            easeProgress = a.easingProgress(params.easing, progress);
	            var _el$prop = el[prop],
	                initialValue = _el$prop.initialValue,
	                finalValue = _el$prop.finalValue,
	                unit = _el$prop.unit;
	            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
	            var currentValue = el[prop].currentValue;
	
	            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
	              el.container.style[prop] = finalValue + unit;
	              propsDone += 1;
	
	              if (propsDone === Object.keys(props).length) {
	                el.done = true;
	                elementsDone += 1;
	              }
	
	              if (elementsDone === elements.length) {
	                done = true;
	              }
	            }
	
	            if (done) {
	              a.done(params.complete);
	              return;
	            }
	
	            el.container.style[prop] = currentValue + unit;
	          });
	        });
	        if (done) return; // Then call
	
	        a.frameId = window.requestAnimationFrame(render);
	      }
	
	      a.frameId = window.requestAnimationFrame(render);
	      return a;
	    }
	  };
	
	  if (a.elements.length === 0) {
	    return els;
	  }
	
	  var animateInstance;
	
	  for (var i = 0; i < a.elements.length; i += 1) {
	    if (a.elements[i].dom7AnimateInstance) {
	      animateInstance = a.elements[i].dom7AnimateInstance;
	    } else a.elements[i].dom7AnimateInstance = a;
	  }
	
	  if (!animateInstance) {
	    animateInstance = a;
	  }
	
	  if (initialProps === 'stop') {
	    animateInstance.stop();
	  } else {
	    animateInstance.animate(a.props, a.params);
	  }
	
	  return els;
	}
	
	function stop() {
	  var els = this;
	
	  for (var i = 0; i < els.length; i += 1) {
	    if (els[i].dom7AnimateInstance) {
	      els[i].dom7AnimateInstance.stop();
	    }
	  }
	}
	
	var noTrigger = 'resize scroll'.split(' ');
	
	function shortcut(name) {
	  function eventHandler() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (typeof args[0] === 'undefined') {
	      for (var i = 0; i < this.length; i += 1) {
	        if (noTrigger.indexOf(name) < 0) {
	          if (name in this[i]) this[i][name]();else {
	            $(this[i]).trigger(name);
	          }
	        }
	      }
	
	      return this;
	    }
	
	    return this.on.apply(this, [name].concat(args));
	  }
	
	  return eventHandler;
	}
	
	var click = shortcut('click');
	var blur = shortcut('blur');
	var focus = shortcut('focus');
	var focusin = shortcut('focusin');
	var focusout = shortcut('focusout');
	var keyup = shortcut('keyup');
	var keydown = shortcut('keydown');
	var keypress = shortcut('keypress');
	var submit = shortcut('submit');
	var change = shortcut('change');
	var mousedown = shortcut('mousedown');
	var mousemove = shortcut('mousemove');
	var mouseup = shortcut('mouseup');
	var mouseenter = shortcut('mouseenter');
	var mouseleave = shortcut('mouseleave');
	var mouseout = shortcut('mouseout');
	var mouseover = shortcut('mouseover');
	var touchstart = shortcut('touchstart');
	var touchend = shortcut('touchend');
	var touchmove = shortcut('touchmove');
	var resize = shortcut('resize');
	var scroll = shortcut('scroll');
	
	exports.$ = $;
	exports.add = add;
	exports.addClass = addClass;
	exports.animate = animate;
	exports.animationEnd = animationEnd;
	exports.append = append;
	exports.appendTo = appendTo;
	exports.attr = attr;
	exports.blur = blur;
	exports.change = change;
	exports.children = children;
	exports.click = click;
	exports.closest = closest;
	exports.css = css;
	exports.data = data;
	exports.dataset = dataset;
	exports.default = $;
	exports.detach = detach;
	exports.each = each;
	exports.empty = empty;
	exports.eq = eq;
	exports.filter = filter;
	exports.find = find;
	exports.focus = focus;
	exports.focusin = focusin;
	exports.focusout = focusout;
	exports.hasClass = hasClass;
	exports.height = height;
	exports.hide = hide;
	exports.html = html;
	exports.index = index;
	exports.insertAfter = insertAfter;
	exports.insertBefore = insertBefore;
	exports.is = is;
	exports.keydown = keydown;
	exports.keypress = keypress;
	exports.keyup = keyup;
	exports.mousedown = mousedown;
	exports.mouseenter = mouseenter;
	exports.mouseleave = mouseleave;
	exports.mousemove = mousemove;
	exports.mouseout = mouseout;
	exports.mouseover = mouseover;
	exports.mouseup = mouseup;
	exports.next = next;
	exports.nextAll = nextAll;
	exports.off = off;
	exports.offset = offset;
	exports.on = on;
	exports.once = once;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.parent = parent;
	exports.parents = parents;
	exports.prepend = prepend;
	exports.prependTo = prependTo;
	exports.prev = prev;
	exports.prevAll = prevAll;
	exports.prop = prop;
	exports.remove = remove;
	exports.removeAttr = removeAttr;
	exports.removeClass = removeClass;
	exports.removeData = removeData;
	exports.resize = resize;
	exports.scroll = scroll;
	exports.scrollLeft = scrollLeft;
	exports.scrollTo = scrollTo;
	exports.scrollTop = scrollTop;
	exports.show = show;
	exports.siblings = siblings;
	exports.stop = stop;
	exports.styles = styles;
	exports.submit = submit;
	exports.text = text;
	exports.toggleClass = toggleClass;
	exports.touchend = touchend;
	exports.touchmove = touchmove;
	exports.touchstart = touchstart;
	exports.transform = transform;
	exports.transition = transition;
	exports.transitionEnd = transitionEnd;
	exports.trigger = trigger;
	exports.val = val;
	exports.value = value;
	exports.width = width;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * SSR Window 3.0.0
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */
	(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (global = global || self, factory(global.ssrWindow = {}));
	}(this, (function (exports) { 'use strict';
	
	    /* eslint-disable no-param-reassign */
	    function isObject(obj) {
	        return (obj !== null &&
	            typeof obj === 'object' &&
	            'constructor' in obj &&
	            obj.constructor === Object);
	    }
	    function extend(target, src) {
	        if (target === void 0) { target = {}; }
	        if (src === void 0) { src = {}; }
	        Object.keys(src).forEach(function (key) {
	            if (typeof target[key] === 'undefined')
	                target[key] = src[key];
	            else if (isObject(src[key]) &&
	                isObject(target[key]) &&
	                Object.keys(src[key]).length > 0) {
	                extend(target[key], src[key]);
	            }
	        });
	    }
	
	    var ssrDocument = {
	        body: {},
	        addEventListener: function () { },
	        removeEventListener: function () { },
	        activeElement: {
	            blur: function () { },
	            nodeName: '',
	        },
	        querySelector: function () {
	            return null;
	        },
	        querySelectorAll: function () {
	            return [];
	        },
	        getElementById: function () {
	            return null;
	        },
	        createEvent: function () {
	            return {
	                initEvent: function () { },
	            };
	        },
	        createElement: function () {
	            return {
	                children: [],
	                childNodes: [],
	                style: {},
	                setAttribute: function () { },
	                getElementsByTagName: function () {
	                    return [];
	                },
	            };
	        },
	        createElementNS: function () {
	            return {};
	        },
	        importNode: function () {
	            return null;
	        },
	        location: {
	            hash: '',
	            host: '',
	            hostname: '',
	            href: '',
	            origin: '',
	            pathname: '',
	            protocol: '',
	            search: '',
	        },
	    };
	    function getDocument() {
	        var doc = typeof document !== 'undefined' ? document : {};
	        extend(doc, ssrDocument);
	        return doc;
	    }
	
	    var ssrWindow = {
	        document: ssrDocument,
	        navigator: {
	            userAgent: '',
	        },
	        location: {
	            hash: '',
	            host: '',
	            hostname: '',
	            href: '',
	            origin: '',
	            pathname: '',
	            protocol: '',
	            search: '',
	        },
	        history: {
	            replaceState: function () { },
	            pushState: function () { },
	            go: function () { },
	            back: function () { },
	        },
	        CustomEvent: function CustomEvent() {
	            return this;
	        },
	        addEventListener: function () { },
	        removeEventListener: function () { },
	        getComputedStyle: function () {
	            return {
	                getPropertyValue: function () {
	                    return '';
	                },
	            };
	        },
	        Image: function () { },
	        Date: function () { },
	        screen: {},
	        setTimeout: function () { },
	        clearTimeout: function () { },
	        matchMedia: function () {
	            return {};
	        },
	        requestAnimationFrame: function (callback) {
	            if (typeof setTimeout === 'undefined') {
	                callback();
	                return null;
	            }
	            return setTimeout(callback, 0);
	        },
	        cancelAnimationFrame: function (id) {
	            if (typeof setTimeout === 'undefined') {
	                return;
	            }
	            clearTimeout(id);
	        },
	    };
	    function getWindow() {
	        var win = typeof window !== 'undefined' ? window : {};
	        extend(win, ssrWindow);
	        return win;
	    }
	
	    exports.extend = extend;
	    exports.getDocument = getDocument;
	    exports.getWindow = getWindow;
	    exports.ssrDocument = ssrDocument;
	    exports.ssrWindow = ssrWindow;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=ssr-window.umd.js.map


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.deleteProps = deleteProps;
	exports.nextTick = nextTick;
	exports.now = now;
	exports.getTranslate = getTranslate;
	exports.isObject = isObject;
	exports.extend = extend;
	exports.bindModuleMethods = bindModuleMethods;
	
	var _ssrWindow = __webpack_require__(39);
	
	function deleteProps(obj) {
	  var object = obj;
	  Object.keys(object).forEach(function (key) {
	    try {
	      object[key] = null;
	    } catch (e) {// no getter for object
	    }
	
	    try {
	      delete object[key];
	    } catch (e) {// something got wrong
	    }
	  });
	}
	
	function nextTick(callback, delay) {
	  if (delay === void 0) {
	    delay = 0;
	  }
	
	  return setTimeout(callback, delay);
	}
	
	function now() {
	  return Date.now();
	}
	
	function getTranslate(el, axis) {
	  if (axis === void 0) {
	    axis = 'x';
	  }
	
	  var window = (0, _ssrWindow.getWindow)();
	  var matrix;
	  var curTransform;
	  var transformMatrix;
	  var curStyle = window.getComputedStyle(el, null);
	
	  if (window.WebKitCSSMatrix) {
	    curTransform = curStyle.transform || curStyle.webkitTransform;
	
	    if (curTransform.split(',').length > 6) {
	      curTransform = curTransform.split(', ').map(function (a) {
	        return a.replace(',', '.');
	      }).join(', ');
	    } // Some old versions of Webkit choke when 'none' is passed; pass
	    // empty string instead in this case
	
	
	    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	  } else {
	    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	    matrix = transformMatrix.toString().split(',');
	  }
	
	  if (axis === 'x') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
	      else curTransform = parseFloat(matrix[4]);
	  }
	
	  if (axis === 'y') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
	      else curTransform = parseFloat(matrix[5]);
	  }
	
	  return curTransform || 0;
	}
	
	function isObject(o) {
	  return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	}
	
	function extend() {
	  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
	
	  for (var i = 1; i < arguments.length; i += 1) {
	    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
	
	    if (nextSource !== undefined && nextSource !== null) {
	      var keysArray = Object.keys(Object(nextSource));
	
	      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	        var nextKey = keysArray[nextIndex];
	        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	
	        if (desc !== undefined && desc.enumerable) {
	          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            extend(to[nextKey], nextSource[nextKey]);
	          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            to[nextKey] = {};
	            extend(to[nextKey], nextSource[nextKey]);
	          } else {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	  }
	
	  return to;
	}
	
	function bindModuleMethods(instance, obj) {
	  Object.keys(obj).forEach(function (key) {
	    if (isObject(obj[key])) {
	      Object.keys(obj[key]).forEach(function (subKey) {
	        if (typeof obj[key][subKey] === 'function') {
	          obj[key][subKey] = obj[key][subKey].bind(instance);
	        }
	      });
	    }
	
	    instance[key] = obj[key];
	  });
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getSupport = getSupport;
	
	var _ssrWindow = __webpack_require__(39);
	
	var support;
	
	function calcSupport() {
	  var window = (0, _ssrWindow.getWindow)();
	  var document = (0, _ssrWindow.getDocument)();
	  return {
	    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
	    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
	    observer: function checkObserver() {
	      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
	    }(),
	    passiveListener: function checkPassiveListener() {
	      var supportsPassive = false;
	
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get: function get() {
	            supportsPassive = true;
	          }
	        });
	        window.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {// No support
	      }
	
	      return supportsPassive;
	    }(),
	    gestures: function checkGestures() {
	      return 'ongesturestart' in window;
	    }()
	  };
	}
	
	function getSupport() {
	  if (!support) {
	    support = calcSupport();
	  }
	
	  return support;
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getDevice = getDevice;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _getSupport = __webpack_require__(41);
	
	var device;
	
	function calcDevice(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      userAgent = _ref.userAgent;
	
	  var support = (0, _getSupport.getSupport)();
	  var window = (0, _ssrWindow.getWindow)();
	  var platform = window.navigator.platform;
	  var ua = userAgent || window.navigator.userAgent;
	  var device = {
	    ios: false,
	    android: false
	  };
	  var screenWidth = window.screen.width;
	  var screenHeight = window.screen.height;
	  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	
	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  var windows = platform === 'Win32';
	  var macos = platform === 'MacIntel'; // iPadOs 13 fix
	
	  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
	
	  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
	    ipad = ua.match(/(Version)\/([\d.]+)/);
	    if (!ipad) ipad = [0, 1, '13_0_0'];
	    macos = false;
	  } // Android
	
	
	  if (android && !windows) {
	    device.os = 'android';
	    device.android = true;
	  }
	
	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  } // Export object
	
	
	  return device;
	}
	
	function getDevice(overrides) {
	  if (overrides === void 0) {
	    overrides = {};
	  }
	
	  if (!device) {
	    device = calcDevice(overrides);
	  }
	
	  return device;
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBrowser = getBrowser;
	
	var _ssrWindow = __webpack_require__(39);
	
	var browser;
	
	function calcBrowser() {
	  var window = (0, _ssrWindow.getWindow)();
	
	  function isSafari() {
	    var ua = window.navigator.userAgent.toLowerCase();
	    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
	  }
	
	  return {
	    isEdge: !!window.navigator.userAgent.match(/Edge/g),
	    isSafari: isSafari(),
	    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
	  };
	}
	
	function getBrowser() {
	  if (!browser) {
	    browser = calcBrowser();
	  }
	
	  return browser;
	}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _utils = __webpack_require__(40);
	
	var _default = {
	  name: 'resize',
	  create: function create() {
	    var swiper = this;
	    (0, _utils.extend)(swiper, {
	      resize: {
	        resizeHandler: function resizeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) return;
	          swiper.emit('beforeResize');
	          swiper.emit('resize');
	        },
	        orientationChangeHandler: function orientationChangeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) return;
	          swiper.emit('orientationchange');
	        }
	      }
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      var window = (0, _ssrWindow.getWindow)(); // Emit resize
	
	      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange
	
	      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	    destroy: function destroy(swiper) {
	      var window = (0, _ssrWindow.getWindow)();
	      window.removeEventListener('resize', swiper.resize.resizeHandler);
	      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _utils = __webpack_require__(40);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Observer = {
	  attach: function attach(target, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var window = (0, _ssrWindow.getWindow)();
	    var swiper = this;
	    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	    var observer = new ObserverFunc(function (mutations) {
	      // The observerUpdate event should only be triggered
	      // once despite the number of mutations.  Additional
	      // triggers are redundant and are very costly
	      if (mutations.length === 1) {
	        swiper.emit('observerUpdate', mutations[0]);
	        return;
	      }
	
	      var observerUpdate = function observerUpdate() {
	        swiper.emit('observerUpdate', mutations[0]);
	      };
	
	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(observerUpdate);
	      } else {
	        window.setTimeout(observerUpdate, 0);
	      }
	    });
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	    });
	    swiper.observer.observers.push(observer);
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.support.observer || !swiper.params.observer) return;
	
	    if (swiper.params.observeParents) {
	      var containerParents = swiper.$el.parents();
	
	      for (var i = 0; i < containerParents.length; i += 1) {
	        swiper.observer.attach(containerParents[i]);
	      }
	    } // Observe container
	
	
	    swiper.observer.attach(swiper.$el[0], {
	      childList: swiper.params.observeSlideChildren
	    }); // Observe wrapper
	
	    swiper.observer.attach(swiper.$wrapperEl[0], {
	      attributes: false
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.observer.observers.forEach(function (observer) {
	      observer.disconnect();
	    });
	    swiper.observer.observers = [];
	  }
	};
	var _default = {
	  name: 'observer',
	  params: {
	    observer: false,
	    observeParents: false,
	    observeSlideChildren: false
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      observer: _extends(_extends({}, Observer), {}, {
	        observers: []
	      })
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.observer.init();
	    },
	    destroy: function destroy(swiper) {
	      swiper.observer.destroy();
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(40);
	
	var _default = {
	  useParams: function useParams(instanceParams) {
	    var instance = this;
	    if (!instance.modules) return;
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName]; // Extend params
	
	      if (module.params) {
	        (0, _utils.extend)(instanceParams, module.params);
	      }
	    });
	  },
	  useModules: function useModules(modulesParams) {
	    if (modulesParams === void 0) {
	      modulesParams = {};
	    }
	
	    var instance = this;
	    if (!instance.modules) return;
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName];
	      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners
	
	      if (module.on && instance.on) {
	        Object.keys(module.on).forEach(function (moduleEventName) {
	          instance.on(moduleEventName, module.on[moduleEventName]);
	        });
	      } // Module create callback
	
	
	      if (module.create) {
	        module.create.bind(instance)(moduleParams);
	      }
	    });
	  }
	};
	exports.default = _default;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/* eslint-disable no-underscore-dangle */
	var _default = {
	  on: function on(events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(function (event) {
	      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  },
	  once: function once(events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	
	    function onceHandler() {
	      self.off(events, onceHandler);
	
	      if (onceHandler.__emitterProxy) {
	        delete onceHandler.__emitterProxy;
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      handler.apply(self, args);
	    }
	
	    onceHandler.__emitterProxy = handler;
	    return self.on(events, onceHandler, priority);
	  },
	  onAny: function onAny(handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';
	
	    if (self.eventsAnyListeners.indexOf(handler) < 0) {
	      self.eventsAnyListeners[method](handler);
	    }
	
	    return self;
	  },
	  offAny: function offAny(handler) {
	    var self = this;
	    if (!self.eventsAnyListeners) return self;
	    var index = self.eventsAnyListeners.indexOf(handler);
	
	    if (index >= 0) {
	      self.eventsAnyListeners.splice(index, 1);
	    }
	
	    return self;
	  },
	  off: function off(events, handler) {
	    var self = this;
	    if (!self.eventsListeners) return self;
	    events.split(' ').forEach(function (event) {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(function (eventHandler, index) {
	          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  },
	  emit: function emit() {
	    var self = this;
	    if (!self.eventsListeners) return self;
	    var events;
	    var data;
	    var context;
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }
	
	    data.unshift(context);
	    var eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(function (event) {
	      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
	        self.eventsAnyListeners.forEach(function (eventHandler) {
	          eventHandler.apply(context, [event].concat(data));
	        });
	      }
	
	      if (self.eventsListeners && self.eventsListeners[event]) {
	        var handlers = [];
	        self.eventsListeners[event].forEach(function (eventHandler) {
	          handlers.push(eventHandler);
	        });
	        handlers.forEach(function (eventHandler) {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  }
	};
	exports.default = _default;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _updateSize = _interopRequireDefault(__webpack_require__(49));
	
	var _updateSlides = _interopRequireDefault(__webpack_require__(50));
	
	var _updateAutoHeight = _interopRequireDefault(__webpack_require__(51));
	
	var _updateSlidesOffset = _interopRequireDefault(__webpack_require__(52));
	
	var _updateSlidesProgress = _interopRequireDefault(__webpack_require__(53));
	
	var _updateProgress = _interopRequireDefault(__webpack_require__(54));
	
	var _updateSlidesClasses = _interopRequireDefault(__webpack_require__(55));
	
	var _updateActiveIndex = _interopRequireDefault(__webpack_require__(56));
	
	var _updateClickedSlide = _interopRequireDefault(__webpack_require__(57));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  updateSize: _updateSize.default,
	  updateSlides: _updateSlides.default,
	  updateAutoHeight: _updateAutoHeight.default,
	  updateSlidesOffset: _updateSlidesOffset.default,
	  updateSlidesProgress: _updateSlidesProgress.default,
	  updateProgress: _updateProgress.default,
	  updateSlidesClasses: _updateSlidesClasses.default,
	  updateActiveIndex: _updateActiveIndex.default,
	  updateClickedSlide: _updateClickedSlide.default
	};
	exports.default = _default;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSize;
	
	var _utils = __webpack_require__(40);
	
	function updateSize() {
	  var swiper = this;
	  var width;
	  var height;
	  var $el = swiper.$el;
	
	  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }
	
	  if (typeof swiper.params.height !== 'undefined' && swiper.params.width !== null) {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }
	
	  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
	    return;
	  } // Subtract paddings
	
	
	  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
	  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
	  if (Number.isNaN(width)) width = 0;
	  if (Number.isNaN(height)) height = 0;
	  (0, _utils.extend)(swiper, {
	    width: width,
	    height: height,
	    size: swiper.isHorizontal() ? width : height
	  });
	}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlides;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _utils = __webpack_require__(40);
	
	function updateSlides() {
	  var swiper = this;
	  var window = (0, _ssrWindow.getWindow)();
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl,
	      swiperSize = swiper.size,
	      rtl = swiper.rtlTranslate,
	      wrongRTL = swiper.wrongRTL;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  var slides = $wrapperEl.children("." + swiper.params.slideClass);
	  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  var snapGrid = [];
	  var slidesGrid = [];
	  var slidesSizesGrid = [];
	
	  function slidesForMargin(slideEl, slideIndex) {
	    if (!params.cssMode) return true;
	
	    if (slideIndex === slides.length - 1) {
	      return false;
	    }
	
	    return true;
	  }
	
	  var offsetBefore = params.slidesOffsetBefore;
	
	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }
	
	  var offsetAfter = params.slidesOffsetAfter;
	
	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }
	
	  var previousSnapGridLength = swiper.snapGrid.length;
	  var previousSlidesGridLength = swiper.snapGrid.length;
	  var spaceBetween = params.spaceBetween;
	  var slidePosition = -offsetBefore;
	  var prevSlideSize = 0;
	  var index = 0;
	
	  if (typeof swiperSize === 'undefined') {
	    return;
	  }
	
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
	  }
	
	  swiper.virtualSize = -spaceBetween; // reset margins
	
	  if (rtl) slides.css({
	    marginLeft: '',
	    marginTop: ''
	  });else slides.css({
	    marginRight: '',
	    marginBottom: ''
	  });
	  var slidesNumberEvenToRows;
	
	  if (params.slidesPerColumn > 1) {
	    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	      slidesNumberEvenToRows = slidesLength;
	    } else {
	      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	    }
	
	    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	    }
	  } // Calc slides
	
	
	  var slideSize;
	  var slidesPerColumn = params.slidesPerColumn;
	  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
	
	  for (var i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    var slide = slides.eq(i);
	
	    if (params.slidesPerColumn > 1) {
	      // Set slides order
	      var newSlideOrderIndex = void 0;
	      var column = void 0;
	      var row = void 0;
	
	      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
	        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
	        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
	        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
	        row = Math.floor(slideIndexInGroup / columnsInGroup);
	        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
	        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
	        slide.css({
	          '-webkit-box-ordinal-group': newSlideOrderIndex,
	          '-moz-box-ordinal-group': newSlideOrderIndex,
	          '-ms-flex-order': newSlideOrderIndex,
	          '-webkit-order': newSlideOrderIndex,
	          order: newSlideOrderIndex
	        });
	      } else if (params.slidesPerColumnFill === 'column') {
	        column = Math.floor(i / slidesPerColumn);
	        row = i - column * slidesPerColumn;
	
	        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
	          row += 1;
	
	          if (row >= slidesPerColumn) {
	            row = 0;
	            column += 1;
	          }
	        }
	      } else {
	        row = Math.floor(i / slidesPerRow);
	        column = i - row * slidesPerRow;
	      }
	
	      slide.css("margin-" + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + "px");
	    }
	
	    if (slide.css('display') === 'none') continue; // eslint-disable-line
	
	    if (params.slidesPerView === 'auto') {
	      var slideStyles = window.getComputedStyle(slide[0], null);
	      var currentTransform = slide[0].style.transform;
	      var currentWebKitTransform = slide[0].style.webkitTransform;
	
	      if (currentTransform) {
	        slide[0].style.transform = 'none';
	      }
	
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = 'none';
	      }
	
	      if (params.roundLengths) {
	        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	      } else {
	        // eslint-disable-next-line
	        if (swiper.isHorizontal()) {
	          var width = parseFloat(slideStyles.getPropertyValue('width') || 0);
	          var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left') || 0);
	          var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right') || 0);
	          var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left') || 0);
	          var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right') || 0);
	          var boxSizing = slideStyles.getPropertyValue('box-sizing');
	
	          if (boxSizing && boxSizing === 'border-box') {
	            slideSize = width + marginLeft + marginRight;
	          } else {
	            var _slide$ = slide[0],
	                clientWidth = _slide$.clientWidth,
	                offsetWidth = _slide$.offsetWidth;
	            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
	          }
	        } else {
	          var height = parseFloat(slideStyles.getPropertyValue('height') || 0);
	          var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top') || 0);
	          var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom') || 0);
	          var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top') || 0);
	          var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom') || 0);
	
	          var _boxSizing = slideStyles.getPropertyValue('box-sizing');
	
	          if (_boxSizing && _boxSizing === 'border-box') {
	            slideSize = height + marginTop + marginBottom;
	          } else {
	            var _slide$2 = slide[0],
	                clientHeight = _slide$2.clientHeight,
	                offsetHeight = _slide$2.offsetHeight;
	            slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom + (offsetHeight - clientHeight);
	          }
	        }
	      }
	
	      if (currentTransform) {
	        slide[0].style.transform = currentTransform;
	      }
	
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = currentWebKitTransform;
	      }
	
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	    } else {
	      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	
	      if (slides[i]) {
	        if (swiper.isHorizontal()) {
	          slides[i].style.width = slideSize + "px";
	        } else {
	          slides[i].style.height = slideSize + "px";
	        }
	      }
	    }
	
	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }
	
	    slidesSizesGrid.push(slideSize);
	
	    if (params.centeredSlides) {
	      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	    } else {
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }
	
	    swiper.virtualSize += slideSize + spaceBetween;
	    prevSlideSize = slideSize;
	    index += 1;
	  }
	
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  var newSlidesGrid;
	
	  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({
	      width: swiper.virtualSize + params.spaceBetween + "px"
	    });
	  }
	
	  if (params.setWrapperSize) {
	    if (swiper.isHorizontal()) $wrapperEl.css({
	      width: swiper.virtualSize + params.spaceBetween + "px"
	    });else $wrapperEl.css({
	      height: swiper.virtualSize + params.spaceBetween + "px"
	    });
	  }
	
	  if (params.slidesPerColumn > 1) {
	    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	    if (swiper.isHorizontal()) $wrapperEl.css({
	      width: swiper.virtualSize + params.spaceBetween + "px"
	    });else $wrapperEl.css({
	      height: swiper.virtualSize + params.spaceBetween + "px"
	    });
	
	    if (params.centeredSlides) {
	      newSlidesGrid = [];
	
	      for (var _i = 0; _i < snapGrid.length; _i += 1) {
	        var slidesGridItem = snapGrid[_i];
	        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
	        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
	      }
	
	      snapGrid = newSlidesGrid;
	    }
	  } // Remove last grid elements depending on width
	
	
	  if (!params.centeredSlides) {
	    newSlidesGrid = [];
	
	    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
	      var _slidesGridItem = snapGrid[_i2];
	      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
	
	      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(_slidesGridItem);
	      }
	    }
	
	    snapGrid = newSlidesGrid;
	
	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }
	
	  if (snapGrid.length === 0) snapGrid = [0];
	
	  if (params.spaceBetween !== 0) {
	    if (swiper.isHorizontal()) {
	      if (rtl) slides.filter(slidesForMargin).css({
	        marginLeft: spaceBetween + "px"
	      });else slides.filter(slidesForMargin).css({
	        marginRight: spaceBetween + "px"
	      });
	    } else slides.filter(slidesForMargin).css({
	      marginBottom: spaceBetween + "px"
	    });
	  }
	
	  if (params.centeredSlides && params.centeredSlidesBounds) {
	    var allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    allSlidesSize -= params.spaceBetween;
	    var maxSnap = allSlidesSize - swiperSize;
	    snapGrid = snapGrid.map(function (snap) {
	      if (snap < 0) return -offsetBefore;
	      if (snap > maxSnap) return maxSnap + offsetAfter;
	      return snap;
	    });
	  }
	
	  if (params.centerInsufficientSlides) {
	    var _allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    _allSlidesSize -= params.spaceBetween;
	
	    if (_allSlidesSize < swiperSize) {
	      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
	      snapGrid.forEach(function (snap, snapIndex) {
	        snapGrid[snapIndex] = snap - allSlidesOffset;
	      });
	      slidesGrid.forEach(function (snap, snapIndex) {
	        slidesGrid[snapIndex] = snap + allSlidesOffset;
	      });
	    }
	  }
	
	  (0, _utils.extend)(swiper, {
	    slides: slides,
	    snapGrid: snapGrid,
	    slidesGrid: slidesGrid,
	    slidesSizesGrid: slidesSizesGrid
	  });
	
	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }
	
	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) swiper.checkOverflow();
	    swiper.emit('snapGridLengthChange');
	  }
	
	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }
	
	  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateSlidesOffset();
	  }
	}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateAutoHeight;
	
	function updateAutoHeight(speed) {
	  var swiper = this;
	  var activeSlides = [];
	  var newHeight = 0;
	  var i;
	
	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  } // Find slides currently in view
	
	
	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    if (swiper.params.centeredSlides) {
	      swiper.visibleSlides.each(function (slide) {
	        activeSlides.push(slide);
	      });
	    } else {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        var index = swiper.activeIndex + i;
	        if (index > swiper.slides.length) break;
	        activeSlides.push(swiper.slides.eq(index)[0]);
	      }
	    }
	  } else {
	    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	  } // Find new height from highest slide in view
	
	
	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      var height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  } // Update Height
	
	
	  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
	}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlidesOffset;
	
	function updateSlidesOffset() {
	  var swiper = this;
	  var slides = swiper.slides;
	
	  for (var i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlidesProgress;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateSlidesProgress(translate) {
	  if (translate === void 0) {
	    translate = this && this.translate || 0;
	  }
	
	  var swiper = this;
	  var params = swiper.params;
	  var slides = swiper.slides,
	      rtl = swiper.rtlTranslate;
	  if (slides.length === 0) return;
	  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
	  var offsetCenter = -translate;
	  if (rtl) offsetCenter = translate; // Visible Slides
	
	  slides.removeClass(params.slideVisibleClass);
	  swiper.visibleSlidesIndexes = [];
	  swiper.visibleSlides = [];
	
	  for (var i = 0; i < slides.length; i += 1) {
	    var slide = slides[i];
	    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
	
	    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
	      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
	
	      if (isVisible) {
	        swiper.visibleSlides.push(slide);
	        swiper.visibleSlidesIndexes.push(i);
	        slides.eq(i).addClass(params.slideVisibleClass);
	      }
	    }
	
	    slide.progress = rtl ? -slideProgress : slideProgress;
	  }
	
	  swiper.visibleSlides = (0, _dom.default)(swiper.visibleSlides);
	}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateProgress;
	
	var _utils = __webpack_require__(40);
	
	function updateProgress(translate) {
	  var swiper = this;
	
	  if (typeof translate === 'undefined') {
	    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
	
	    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
	  }
	
	  var params = swiper.params;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  var progress = swiper.progress,
	      isBeginning = swiper.isBeginning,
	      isEnd = swiper.isEnd;
	  var wasBeginning = isBeginning;
	  var wasEnd = isEnd;
	
	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / translatesDiff;
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }
	
	  (0, _utils.extend)(swiper, {
	    progress: progress,
	    isBeginning: isBeginning,
	    isEnd: isEnd
	  });
	  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
	
	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }
	
	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }
	
	  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
	    swiper.emit('fromEdge');
	  }
	
	  swiper.emit('progress', progress);
	}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlidesClasses;
	
	function updateSlidesClasses() {
	  var swiper = this;
	  var slides = swiper.slides,
	      params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex,
	      realIndex = swiper.realIndex;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
	  var activeSlide;
	
	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  } // Active classes
	
	
	  activeSlide.addClass(params.slideActiveClass);
	
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
	    }
	  } // Next Slide
	
	
	  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
	
	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  } // Prev Slide
	
	
	  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
	
	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }
	
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
	    }
	
	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
	    }
	  }
	
	  swiper.emitSlidesClasses();
	}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateActiveIndex;
	
	var _utils = __webpack_require__(40);
	
	function updateActiveIndex(newActiveIndex) {
	  var swiper = this;
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  var slidesGrid = swiper.slidesGrid,
	      snapGrid = swiper.snapGrid,
	      params = swiper.params,
	      previousIndex = swiper.activeIndex,
	      previousRealIndex = swiper.realIndex,
	      previousSnapIndex = swiper.snapIndex;
	  var activeIndex = newActiveIndex;
	  var snapIndex;
	
	  if (typeof activeIndex === 'undefined') {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    } // Normalize slideIndex
	
	
	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
	    }
	  }
	
	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
	    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	  }
	
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	
	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }
	
	    return;
	  } // Get real index
	
	
	  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	  (0, _utils.extend)(swiper, {
	    snapIndex: snapIndex,
	    realIndex: realIndex,
	    previousIndex: previousIndex,
	    activeIndex: activeIndex
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	
	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }
	
	  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
	    swiper.emit('slideChange');
	  }
	}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateClickedSlide;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateClickedSlide(e) {
	  var swiper = this;
	  var params = swiper.params;
	  var slide = (0, _dom.default)(e.target).closest("." + params.slideClass)[0];
	  var slideFound = false;
	
	  if (slide) {
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) slideFound = true;
	    }
	  }
	
	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;
	
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt((0, _dom.default)(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = (0, _dom.default)(slide).index();
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }
	
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _getTranslate = _interopRequireDefault(__webpack_require__(59));
	
	var _setTranslate = _interopRequireDefault(__webpack_require__(60));
	
	var _minTranslate = _interopRequireDefault(__webpack_require__(61));
	
	var _maxTranslate = _interopRequireDefault(__webpack_require__(62));
	
	var _translateTo = _interopRequireDefault(__webpack_require__(63));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  getTranslate: _getTranslate.default,
	  setTranslate: _setTranslate.default,
	  minTranslate: _minTranslate.default,
	  maxTranslate: _maxTranslate.default,
	  translateTo: _translateTo.default
	};
	exports.default = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getSwiperTranslate;
	
	var _utils = __webpack_require__(40);
	
	function getSwiperTranslate(axis) {
	  if (axis === void 0) {
	    axis = this.isHorizontal() ? 'x' : 'y';
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      rtl = swiper.rtlTranslate,
	      translate = swiper.translate,
	      $wrapperEl = swiper.$wrapperEl;
	
	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }
	
	  if (params.cssMode) {
	    return translate;
	  }
	
	  var currentTranslate = (0, _utils.getTranslate)($wrapperEl[0], axis);
	  if (rtl) currentTranslate = -currentTranslate;
	  return currentTranslate || 0;
	}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setTranslate;
	
	function setTranslate(translate, byController) {
	  var swiper = this;
	  var rtl = swiper.rtlTranslate,
	      params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      wrapperEl = swiper.wrapperEl,
	      progress = swiper.progress;
	  var x = 0;
	  var y = 0;
	  var z = 0;
	
	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }
	
	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }
	
	  if (params.cssMode) {
	    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	  } else if (!params.virtualTranslate) {
	    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
	  }
	
	  swiper.previousTranslate = swiper.translate;
	  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
	
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
	  }
	
	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }
	
	  swiper.emit('setTranslate', swiper.translate, byController);
	}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = minTranslate;
	
	function minTranslate() {
	  return -this.snapGrid[0];
	}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = maxTranslate;
	
	function maxTranslate() {
	  return -this.snapGrid[this.snapGrid.length - 1];
	}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = translateTo;
	
	function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
	  if (translate === void 0) {
	    translate = 0;
	  }
	
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  if (translateBounds === void 0) {
	    translateBounds = true;
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      wrapperEl = swiper.wrapperEl;
	
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }
	
	  var minTranslate = swiper.minTranslate();
	  var maxTranslate = swiper.maxTranslate();
	  var newTranslate;
	  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress
	
	  swiper.updateProgress(newTranslate);
	
	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();
	
	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	    } else {
	      // eslint-disable-next-line
	      if (wrapperEl.scrollTo) {
	        var _wrapperEl$scrollTo;
	
	        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
	      } else {
	        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	      }
	    }
	
	    return true;
	  }
	
	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(newTranslate);
	
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionEnd');
	    }
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(newTranslate);
	
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionStart');
	    }
	
	    if (!swiper.animating) {
	      swiper.animating = true;
	
	      if (!swiper.onTranslateToWrapperTransitionEnd) {
	        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.onTranslateToWrapperTransitionEnd = null;
	          delete swiper.onTranslateToWrapperTransitionEnd;
	
	          if (runCallbacks) {
	            swiper.emit('transitionEnd');
	          }
	        };
	      }
	
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _setTransition = _interopRequireDefault(__webpack_require__(65));
	
	var _transitionStart = _interopRequireDefault(__webpack_require__(66));
	
	var _transitionEnd = _interopRequireDefault(__webpack_require__(67));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  setTransition: _setTransition.default,
	  transitionStart: _transitionStart.default,
	  transitionEnd: _transitionEnd.default
	};
	exports.default = _default;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setTransition;
	
	function setTransition(duration, byController) {
	  var swiper = this;
	
	  if (!swiper.params.cssMode) {
	    swiper.$wrapperEl.transition(duration);
	  }
	
	  swiper.emit('setTransition', duration, byController);
	}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = transitionStart;
	
	function transitionStart(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      params = swiper.params,
	      previousIndex = swiper.previousIndex;
	  if (params.cssMode) return;
	
	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }
	
	  var dir = direction;
	
	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }
	
	  swiper.emit('transitionStart');
	
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionStart');
	      return;
	    }
	
	    swiper.emit('slideChangeTransitionStart');
	
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionStart');
	    } else {
	      swiper.emit('slidePrevTransitionStart');
	    }
	  }
	}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = transitionEnd;
	
	function transitionEnd(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      previousIndex = swiper.previousIndex,
	      params = swiper.params;
	  swiper.animating = false;
	  if (params.cssMode) return;
	  swiper.setTransition(0);
	  var dir = direction;
	
	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }
	
	  swiper.emit('transitionEnd');
	
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionEnd');
	      return;
	    }
	
	    swiper.emit('slideChangeTransitionEnd');
	
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionEnd');
	    } else {
	      swiper.emit('slidePrevTransitionEnd');
	    }
	  }
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _slideTo = _interopRequireDefault(__webpack_require__(69));
	
	var _slideToLoop = _interopRequireDefault(__webpack_require__(70));
	
	var _slideNext = _interopRequireDefault(__webpack_require__(71));
	
	var _slidePrev = _interopRequireDefault(__webpack_require__(72));
	
	var _slideReset = _interopRequireDefault(__webpack_require__(73));
	
	var _slideToClosest = _interopRequireDefault(__webpack_require__(74));
	
	var _slideToClickedSlide = _interopRequireDefault(__webpack_require__(75));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  slideTo: _slideTo.default,
	  slideToLoop: _slideToLoop.default,
	  slideNext: _slideNext.default,
	  slidePrev: _slidePrev.default,
	  slideReset: _slideReset.default,
	  slideToClosest: _slideToClosest.default,
	  slideToClickedSlide: _slideToClickedSlide.default
	};
	exports.default = _default;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideTo;
	
	function slideTo(index, speed, runCallbacks, internal) {
	  if (index === void 0) {
	    index = 0;
	  }
	
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  if (typeof index !== 'number' && typeof index !== 'string') {
	    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
	  }
	
	  if (typeof index === 'string') {
	    /**
	     * The `index` argument converted from `string` to `number`.
	     * @type {number}
	     */
	    var indexAsNumber = parseInt(index, 10);
	    /**
	     * Determines whether the `index` argument is a valid `number`
	     * after being converted from the `string` type.
	     * @type {boolean}
	     */
	
	    var isValidNumber = isFinite(indexAsNumber);
	
	    if (!isValidNumber) {
	      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
	    } // Knowing that the converted `index` is a valid number,
	    // we can update the original argument's value.
	
	
	    index = indexAsNumber;
	  }
	
	  var swiper = this;
	  var slideIndex = index;
	  if (slideIndex < 0) slideIndex = 0;
	  var params = swiper.params,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      previousIndex = swiper.previousIndex,
	      activeIndex = swiper.activeIndex,
	      rtl = swiper.rtlTranslate,
	      wrapperEl = swiper.wrapperEl;
	
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }
	
	  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	
	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }
	
	  var translate = -snapGrid[snapIndex]; // Update progress
	
	  swiper.updateProgress(translate); // Normalize slideIndex
	
	  if (params.normalizeSlideIndex) {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	        slideIndex = i;
	      }
	    }
	  } // Directions locks
	
	
	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }
	
	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) return false;
	    }
	  }
	
	  var direction;
	  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index
	
	  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
	    swiper.updateActiveIndex(slideIndex); // Update Height
	
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	
	    swiper.updateSlidesClasses();
	
	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }
	
	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }
	
	    return false;
	  }
	
	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();
	    var t = -translate;
	
	    if (rtl) {
	      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
	    }
	
	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	    } else {
	      // eslint-disable-next-line
	      if (wrapperEl.scrollTo) {
	        var _wrapperEl$scrollTo;
	
	        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
	      } else {
	        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	      }
	    }
	
	    return true;
	  }
	
	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	    swiper.transitionEnd(runCallbacks, direction);
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	
	    if (!swiper.animating) {
	      swiper.animating = true;
	
	      if (!swiper.onSlideToWrapperTransitionEnd) {
	        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	          swiper.onSlideToWrapperTransitionEnd = null;
	          delete swiper.onSlideToWrapperTransitionEnd;
	          swiper.transitionEnd(runCallbacks, direction);
	        };
	      }
	
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideToLoop;
	
	function slideToLoop(index, speed, runCallbacks, internal) {
	  if (index === void 0) {
	    index = 0;
	  }
	
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var newIndex = index;
	
	  if (swiper.params.loop) {
	    newIndex += swiper.loopedSlides;
	  }
	
	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideNext;
	
	/* eslint no-unused-vars: "off" */
	function slideNext(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      animating = swiper.animating;
	  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
	
	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line
	
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	
	  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slidePrev;
	
	/* eslint no-unused-vars: "off" */
	function slidePrev(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      animating = swiper.animating,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      rtlTranslate = swiper.rtlTranslate;
	
	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line
	
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	
	  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
	
	  function normalize(val) {
	    if (val < 0) return -Math.floor(Math.abs(val));
	    return Math.floor(val);
	  }
	
	  var normalizedTranslate = normalize(translate);
	  var normalizedSnapGrid = snapGrid.map(function (val) {
	    return normalize(val);
	  });
	  var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
	  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	
	  if (typeof prevSnap === 'undefined' && params.cssMode) {
	    snapGrid.forEach(function (snap) {
	      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
	    });
	  }
	
	  var prevIndex;
	
	  if (typeof prevSnap !== 'undefined') {
	    prevIndex = slidesGrid.indexOf(prevSnap);
	    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
	  }
	
	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideReset;
	
	/* eslint no-unused-vars: "off" */
	function slideReset(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideToClosest;
	
	/* eslint no-unused-vars: "off" */
	function slideToClosest(speed, runCallbacks, internal, threshold) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  if (threshold === void 0) {
	    threshold = 0.5;
	  }
	
	  var swiper = this;
	  var index = swiper.activeIndex;
	  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	
	  if (translate >= swiper.snapGrid[snapIndex]) {
	    // The current translate is on or after the current snap index, so the choice
	    // is between the current index and the one after it.
	    var currentSnap = swiper.snapGrid[snapIndex];
	    var nextSnap = swiper.snapGrid[snapIndex + 1];
	
	    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
	      index += swiper.params.slidesPerGroup;
	    }
	  } else {
	    // The current translate is before the current snap index, so the choice
	    // is between the current index and the one before it.
	    var prevSnap = swiper.snapGrid[snapIndex - 1];
	    var _currentSnap = swiper.snapGrid[snapIndex];
	
	    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
	      index -= swiper.params.slidesPerGroup;
	    }
	  }
	
	  index = Math.max(index, 0);
	  index = Math.min(index, swiper.slidesGrid.length - 1);
	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideToClickedSlide;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function slideToClickedSlide() {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl;
	  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  var slideToIndex = swiper.clickedIndex;
	  var realIndex;
	
	  if (params.loop) {
	    if (swiper.animating) return;
	    realIndex = parseInt((0, _dom.default)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	
	    if (params.centeredSlides) {
	      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
	        (0, _utils.nextTick)(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
	      (0, _utils.nextTick)(function () {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _loopCreate = _interopRequireDefault(__webpack_require__(77));
	
	var _loopFix = _interopRequireDefault(__webpack_require__(78));
	
	var _loopDestroy = _interopRequireDefault(__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  loopCreate: _loopCreate.default,
	  loopFix: _loopFix.default,
	  loopDestroy: _loopDestroy.default
	};
	exports.default = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loopCreate;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loopCreate() {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
	
	  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
	  var slides = $wrapperEl.children("." + params.slideClass);
	
	  if (params.loopFillGroupWithBlank) {
	    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
	
	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankNode = (0, _dom.default)(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
	        $wrapperEl.append(blankNode);
	      }
	
	      slides = $wrapperEl.children("." + params.slideClass);
	    }
	  }
	
	  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
	  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
	  swiper.loopedSlides += params.loopAdditionalSlides;
	
	  if (swiper.loopedSlides > slides.length) {
	    swiper.loopedSlides = slides.length;
	  }
	
	  var prependSlides = [];
	  var appendSlides = [];
	  slides.each(function (el, index) {
	    var slide = (0, _dom.default)(el);
	
	    if (index < swiper.loopedSlides) {
	      appendSlides.push(el);
	    }
	
	    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
	      prependSlides.push(el);
	    }
	
	    slide.attr('data-swiper-slide-index', index);
	  });
	
	  for (var _i = 0; _i < appendSlides.length; _i += 1) {
	    $wrapperEl.append((0, _dom.default)(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	
	  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
	    $wrapperEl.prepend((0, _dom.default)(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loopFix;
	
	function loopFix() {
	  var swiper = this;
	  swiper.emit('beforeLoopFix');
	  var activeIndex = swiper.activeIndex,
	      slides = swiper.slides,
	      loopedSlides = swiper.loopedSlides,
	      allowSlidePrev = swiper.allowSlidePrev,
	      allowSlideNext = swiper.allowSlideNext,
	      snapGrid = swiper.snapGrid,
	      rtl = swiper.rtlTranslate;
	  var newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	  var snapTranslate = -snapGrid[activeIndex];
	  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
	
	  if (activeIndex < loopedSlides) {
	    newIndex = slides.length - loopedSlides * 3 + activeIndex;
	    newIndex += loopedSlides;
	    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
	
	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  } else if (activeIndex >= slides.length - loopedSlides) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;
	
	    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
	
	    if (_slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  }
	
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  swiper.emit('loopFix');
	}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loopDestroy;
	
	function loopDestroy() {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params,
	      slides = swiper.slides;
	  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _setGrabCursor = _interopRequireDefault(__webpack_require__(81));
	
	var _unsetGrabCursor = _interopRequireDefault(__webpack_require__(82));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  setGrabCursor: _setGrabCursor.default,
	  unsetGrabCursor: _unsetGrabCursor.default
	};
	exports.default = _default;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setGrabCursor;
	
	function setGrabCursor(moving) {
	  var swiper = this;
	  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
	  var el = swiper.el;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = unsetGrabCursor;
	
	function unsetGrabCursor() {
	  var swiper = this;
	
	  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
	    return;
	  }
	
	  swiper.el.style.cursor = '';
	}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _appendSlide = _interopRequireDefault(__webpack_require__(84));
	
	var _prependSlide = _interopRequireDefault(__webpack_require__(85));
	
	var _addSlide = _interopRequireDefault(__webpack_require__(86));
	
	var _removeSlide = _interopRequireDefault(__webpack_require__(87));
	
	var _removeAllSlides = _interopRequireDefault(__webpack_require__(88));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  appendSlide: _appendSlide.default,
	  prependSlide: _prependSlide.default,
	  addSlide: _addSlide.default,
	  removeSlide: _removeSlide.default,
	  removeAllSlides: _removeAllSlides.default
	};
	exports.default = _default;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = appendSlide;
	
	function appendSlide(slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) $wrapperEl.append(slides[i]);
	    }
	  } else {
	    $wrapperEl.append(slides);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = prependSlide;
	
	function prependSlide(slides) {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	
	  var newActiveIndex = activeIndex + 1;
	
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) $wrapperEl.prepend(slides[i]);
	    }
	
	    newActiveIndex = activeIndex + slides.length;
	  } else {
	    $wrapperEl.prepend(slides);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	
	  swiper.slideTo(newActiveIndex, 0, false);
	}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = addSlide;
	
	function addSlide(index, slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params,
	      activeIndex = swiper.activeIndex;
	  var activeIndexBuffer = activeIndex;
	
	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children("." + params.slideClass);
	  }
	
	  var baseLength = swiper.slides.length;
	
	  if (index <= 0) {
	    swiper.prependSlide(slides);
	    return;
	  }
	
	  if (index >= baseLength) {
	    swiper.appendSlide(slides);
	    return;
	  }
	
	  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
	  var slidesBuffer = [];
	
	  for (var i = baseLength - 1; i >= index; i -= 1) {
	    var currentSlide = swiper.slides.eq(i);
	    currentSlide.remove();
	    slidesBuffer.unshift(currentSlide);
	  }
	
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var _i = 0; _i < slides.length; _i += 1) {
	      if (slides[_i]) $wrapperEl.append(slides[_i]);
	    }
	
	    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	  } else {
	    $wrapperEl.append(slides);
	  }
	
	  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
	    $wrapperEl.append(slidesBuffer[_i2]);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeSlide;
	
	function removeSlide(slidesIndexes) {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex;
	  var activeIndexBuffer = activeIndex;
	
	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children("." + params.slideClass);
	  }
	
	  var newActiveIndex = activeIndexBuffer;
	  var indexToRemove;
	
	  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	    for (var i = 0; i < slidesIndexes.length; i += 1) {
	      indexToRemove = slidesIndexes[i];
	      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
	      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
	    }
	
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  } else {
	    indexToRemove = slidesIndexes;
	    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
	    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeAllSlides;
	
	function removeAllSlides() {
	  var swiper = this;
	  var slidesIndexes = [];
	
	  for (var i = 0; i < swiper.slides.length; i += 1) {
	    slidesIndexes.push(i);
	  }
	
	  swiper.removeSlide(slidesIndexes);
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _onTouchStart = _interopRequireDefault(__webpack_require__(90));
	
	var _onTouchMove = _interopRequireDefault(__webpack_require__(91));
	
	var _onTouchEnd = _interopRequireDefault(__webpack_require__(92));
	
	var _onResize = _interopRequireDefault(__webpack_require__(93));
	
	var _onClick = _interopRequireDefault(__webpack_require__(94));
	
	var _onScroll = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dummyEventAttached = false;
	
	function dummyEventListener() {}
	
	function attachEvents() {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var params = swiper.params,
	      touchEvents = swiper.touchEvents,
	      el = swiper.el,
	      wrapperEl = swiper.wrapperEl,
	      device = swiper.device,
	      support = swiper.support;
	  swiper.onTouchStart = _onTouchStart.default.bind(swiper);
	  swiper.onTouchMove = _onTouchMove.default.bind(swiper);
	  swiper.onTouchEnd = _onTouchEnd.default.bind(swiper);
	
	  if (params.cssMode) {
	    swiper.onScroll = _onScroll.default.bind(swiper);
	  }
	
	  swiper.onClick = _onClick.default.bind(swiper);
	  var capture = !!params.nested; // Touch Events
	
	  if (!support.touch && support.pointerEvents) {
	    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    if (support.touch) {
	      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
	        passive: true,
	        capture: false
	      } : false;
	      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
	        passive: false,
	        capture: capture
	      } : capture);
	      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	
	      if (touchEvents.cancel) {
	        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	      }
	
	      if (!dummyEventAttached) {
	        document.addEventListener('touchstart', dummyEventListener);
	        dummyEventAttached = true;
	      }
	    }
	
	    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
	      el.addEventListener('mousedown', swiper.onTouchStart, false);
	      document.addEventListener('mousemove', swiper.onTouchMove, capture);
	      document.addEventListener('mouseup', swiper.onTouchEnd, false);
	    }
	  } // Prevent Links Clicks
	
	
	  if (params.preventClicks || params.preventClicksPropagation) {
	    el.addEventListener('click', swiper.onClick, true);
	  }
	
	  if (params.cssMode) {
	    wrapperEl.addEventListener('scroll', swiper.onScroll);
	  } // Resize handler
	
	
	  if (params.updateOnWindowResize) {
	    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', _onResize.default, true);
	  } else {
	    swiper.on('observerUpdate', _onResize.default, true);
	  }
	}
	
	function detachEvents() {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var params = swiper.params,
	      touchEvents = swiper.touchEvents,
	      el = swiper.el,
	      wrapperEl = swiper.wrapperEl,
	      device = swiper.device,
	      support = swiper.support;
	  var capture = !!params.nested; // Touch Events
	
	  if (!support.touch && support.pointerEvents) {
	    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    if (support.touch) {
	      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
	        passive: true,
	        capture: false
	      } : false;
	      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	
	      if (touchEvents.cancel) {
	        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	      }
	    }
	
	    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
	      el.removeEventListener('mousedown', swiper.onTouchStart, false);
	      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
	      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
	    }
	  } // Prevent Links Clicks
	
	
	  if (params.preventClicks || params.preventClicksPropagation) {
	    el.removeEventListener('click', swiper.onClick, true);
	  }
	
	  if (params.cssMode) {
	    wrapperEl.removeEventListener('scroll', swiper.onScroll);
	  } // Resize handler
	
	
	  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', _onResize.default);
	}
	
	var _default = {
	  attachEvents: attachEvents,
	  detachEvents: detachEvents
	};
	exports.default = _default;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onTouchStart;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function onTouchStart(event) {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var window = (0, _ssrWindow.getWindow)();
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches;
	
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return;
	  }
	
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  var $targetEl = (0, _dom.default)(e.target);
	
	  if (params.touchEventsTarget === 'wrapper') {
	    if (!$targetEl.closest(swiper.wrapperEl).length) return;
	  }
	
	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
	  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
	  if (data.isTouched && data.isMoved) return; // change target el for shadow root componenet
	
	  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
	
	  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
	    $targetEl = (0, _dom.default)(event.path[0]);
	  }
	
	  if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
	    swiper.allowClick = true;
	    return;
	  }
	
	  if (params.swipeHandler) {
	    if (!$targetEl.closest(params.swipeHandler)[0]) return;
	  }
	
	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  var startX = touches.currentX;
	  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
	
	  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
	
	  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.screen.width - edgeSwipeThreshold)) {
	    return;
	  }
	
	  (0, _utils.extend)(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined
	  });
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = (0, _utils.now)();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) data.allowThresholdMove = false;
	
	  if (e.type !== 'touchstart') {
	    var preventDefault = true;
	    if ($targetEl.is(data.formElements)) preventDefault = false;
	
	    if (document.activeElement && (0, _dom.default)(document.activeElement).is(data.formElements) && document.activeElement !== $targetEl[0]) {
	      document.activeElement.blur();
	    }
	
	    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
	
	    if (params.touchStartForcePreventDefault || shouldPreventDefault) {
	      e.preventDefault();
	    }
	  }
	
	  swiper.emit('touchStart', e);
	}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onTouchMove;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function onTouchMove(event) {
	  var document = (0, _ssrWindow.getDocument)();
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	
	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	
	    return;
	  }
	
	  if (data.isTouchEvent && e.type !== 'touchmove') return;
	  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
	  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
	  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
	
	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }
	
	  if (!swiper.allowTouchMove) {
	    // isMoved = true;
	    swiper.allowClick = false;
	
	    if (data.isTouched) {
	      (0, _utils.extend)(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY
	      });
	      data.touchStartTime = (0, _utils.now)();
	    }
	
	    return;
	  }
	
	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
	      return;
	    }
	  }
	
	  if (data.isTouchEvent && document.activeElement) {
	    if (e.target === document.activeElement && (0, _dom.default)(e.target).is(data.formElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }
	
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }
	
	  if (e.targetTouches && e.targetTouches.length > 1) return;
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	  var diffX = touches.currentX - touches.startX;
	  var diffY = touches.currentY - touches.startY;
	  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
	
	  if (typeof data.isScrolling === 'undefined') {
	    var touchAngle;
	
	    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if (diffX * diffX + diffY * diffY >= 25) {
	        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
	      }
	    }
	  }
	
	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }
	
	  if (typeof data.startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }
	
	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }
	
	  if (!data.startMoving) {
	    return;
	  }
	
	  swiper.allowClick = false;
	
	  if (!params.cssMode && e.cancelable) {
	    e.preventDefault();
	  }
	
	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }
	
	  if (!data.isMoved) {
	    if (params.loop) {
	      swiper.loopFix();
	    }
	
	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);
	
	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }
	
	    data.allowMomentumBounce = false; // Grab Cursor
	
	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }
	
	    swiper.emit('sliderFirstMove', e);
	  }
	
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	  var diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;
	  diff *= params.touchRatio;
	  if (rtl) diff = -diff;
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;
	  var disableParentSwiper = true;
	  var resistanceRatio = params.resistanceRatio;
	
	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }
	
	  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
	  }
	
	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  } // Directions locks
	
	
	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  } // Threshold
	
	
	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }
	
	  if (!params.followFinger || params.cssMode) return; // Update active index in free mode
	
	  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	
	  if (params.freeMode) {
	    // Velocity
	    if (data.velocities.length === 0) {
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	        time: data.touchStartTime
	      });
	    }
	
	    data.velocities.push({
	      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	      time: (0, _utils.now)()
	    });
	  } // Update progress
	
	
	  swiper.updateProgress(data.currentTranslate); // Update translate
	
	  swiper.setTranslate(data.currentTranslate);
	}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onTouchEnd;
	
	var _utils = __webpack_require__(40);
	
	function onTouchEnd(event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate,
	      $wrapperEl = swiper.$wrapperEl,
	      slidesGrid = swiper.slidesGrid,
	      snapGrid = swiper.snapGrid;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }
	
	  data.allowTouchCallbacks = false;
	
	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }
	
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  } // Return Grab Cursor
	
	
	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  } // Time diff
	
	
	  var touchEndTime = (0, _utils.now)();
	  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
	
	  if (swiper.allowClick) {
	    swiper.updateClickedSlide(e);
	    swiper.emit('tap click', e);
	
	    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
	      swiper.emit('doubleTap doubleClick', e);
	    }
	  }
	
	  data.lastClickTime = (0, _utils.now)();
	  (0, _utils.nextTick)(function () {
	    if (!swiper.destroyed) swiper.allowClick = true;
	  });
	
	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	
	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;
	  var currentPos;
	
	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }
	
	  if (params.cssMode) {
	    return;
	  }
	
	  if (params.freeMode) {
	    if (currentPos < -swiper.minTranslate()) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	
	    if (currentPos > -swiper.maxTranslate()) {
	      if (swiper.slides.length < snapGrid.length) {
	        swiper.slideTo(snapGrid.length - 1);
	      } else {
	        swiper.slideTo(swiper.slides.length - 1);
	      }
	
	      return;
	    }
	
	    if (params.freeModeMomentum) {
	      if (data.velocities.length > 1) {
	        var lastMoveEvent = data.velocities.pop();
	        var velocityEvent = data.velocities.pop();
	        var distance = lastMoveEvent.position - velocityEvent.position;
	        var time = lastMoveEvent.time - velocityEvent.time;
	        swiper.velocity = distance / time;
	        swiper.velocity /= 2;
	
	        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	          swiper.velocity = 0;
	        } // this implies that the user stopped moving a finger then released.
	        // There would be no events with distance zero, so the last event is stale.
	
	
	        if (time > 150 || (0, _utils.now)() - lastMoveEvent.time > 300) {
	          swiper.velocity = 0;
	        }
	      } else {
	        swiper.velocity = 0;
	      }
	
	      swiper.velocity *= params.freeModeMomentumVelocityRatio;
	      data.velocities.length = 0;
	      var momentumDuration = 1000 * params.freeModeMomentumRatio;
	      var momentumDistance = swiper.velocity * momentumDuration;
	      var newPosition = swiper.translate + momentumDistance;
	      if (rtl) newPosition = -newPosition;
	      var doBounce = false;
	      var afterBouncePosition;
	      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	      var needsLoopFix;
	
	      if (newPosition < swiper.maxTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	            newPosition = swiper.maxTranslate() - bounceAmount;
	          }
	
	          afterBouncePosition = swiper.maxTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.maxTranslate();
	        }
	
	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (newPosition > swiper.minTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition - swiper.minTranslate() > bounceAmount) {
	            newPosition = swiper.minTranslate() + bounceAmount;
	          }
	
	          afterBouncePosition = swiper.minTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.minTranslate();
	        }
	
	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (params.freeModeSticky) {
	        var nextSlide;
	
	        for (var j = 0; j < snapGrid.length; j += 1) {
	          if (snapGrid[j] > -newPosition) {
	            nextSlide = j;
	            break;
	          }
	        }
	
	        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	          newPosition = snapGrid[nextSlide];
	        } else {
	          newPosition = snapGrid[nextSlide - 1];
	        }
	
	        newPosition = -newPosition;
	      }
	
	      if (needsLoopFix) {
	        swiper.once('transitionEnd', function () {
	          swiper.loopFix();
	        });
	      } // Fix duration
	
	
	      if (swiper.velocity !== 0) {
	        if (rtl) {
	          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	        } else {
	          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	        }
	
	        if (params.freeModeSticky) {
	          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
	          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
	          // It's easy to see this when simulating touch with mouse events. To fix this,
	          // limit single-slide swipes to the default slide duration. This also has the
	          // nice side effect of matching slide speed if the user stopped moving before
	          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
	          // For faster swipes, also apply limits (albeit higher ones).
	          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
	          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
	
	          if (moveDistance < currentSlideSize) {
	            momentumDuration = params.speed;
	          } else if (moveDistance < 2 * currentSlideSize) {
	            momentumDuration = params.speed * 1.5;
	          } else {
	            momentumDuration = params.speed * 2.5;
	          }
	        }
	      } else if (params.freeModeSticky) {
	        swiper.slideToClosest();
	        return;
	      }
	
	      if (params.freeModeMomentumBounce && doBounce) {
	        swiper.updateProgress(afterBouncePosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        swiper.animating = true;
	        $wrapperEl.transitionEnd(function () {
	          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
	          swiper.emit('momentumBounce');
	          swiper.setTransition(params.speed);
	          setTimeout(function () {
	            swiper.setTranslate(afterBouncePosition);
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed) return;
	              swiper.transitionEnd();
	            });
	          }, 0);
	        });
	      } else if (swiper.velocity) {
	        swiper.updateProgress(newPosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	
	        if (!swiper.animating) {
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) return;
	            swiper.transitionEnd();
	          });
	        }
	      } else {
	        swiper.updateProgress(newPosition);
	      }
	
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    } else if (params.freeModeSticky) {
	      swiper.slideToClosest();
	      return;
	    }
	
	    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	
	    return;
	  } // Find current slide
	
	
	  var stopIndex = 0;
	  var groupSize = swiper.slidesSizesGrid[0];
	
	  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
	    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	
	    if (typeof slidesGrid[i + _increment] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  } // Find current slide size
	
	
	  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	
	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	
	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
	    }
	
	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	
	    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
	
	    if (!isNavButtonTarget) {
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(stopIndex + increment);
	      }
	
	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(stopIndex);
	      }
	    } else if (e.target === swiper.navigation.nextEl) {
	      swiper.slideTo(stopIndex + increment);
	    } else {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onResize;
	
	function onResize() {
	  var swiper = this;
	  var params = swiper.params,
	      el = swiper.el;
	  if (el && el.offsetWidth === 0) return; // Breakpoints
	
	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  } // Save locks
	
	
	  var allowSlideNext = swiper.allowSlideNext,
	      allowSlidePrev = swiper.allowSlidePrev,
	      snapGrid = swiper.snapGrid; // Disable locks on resize
	
	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	  swiper.updateSize();
	  swiper.updateSlides();
	  swiper.updateSlidesClasses();
	
	  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
	    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	  } else {
	    swiper.slideTo(swiper.activeIndex, 0, false, true);
	  }
	
	  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	    swiper.autoplay.run();
	  } // Return locks after resize
	
	
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	
	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	    swiper.checkOverflow();
	  }
	}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onClick;
	
	function onClick(e) {
	  var swiper = this;
	
	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) e.preventDefault();
	
	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onScroll;
	
	function onScroll() {
	  var swiper = this;
	  var wrapperEl = swiper.wrapperEl,
	      rtlTranslate = swiper.rtlTranslate;
	  swiper.previousTranslate = swiper.translate;
	
	  if (swiper.isHorizontal()) {
	    if (rtlTranslate) {
	      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
	    } else {
	      swiper.translate = -wrapperEl.scrollLeft;
	    }
	  } else {
	    swiper.translate = -wrapperEl.scrollTop;
	  } // eslint-disable-next-line
	
	
	  if (swiper.translate === -0) swiper.translate = 0;
	  swiper.updateActiveIndex();
	  swiper.updateSlidesClasses();
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
	  }
	
	  if (newProgress !== swiper.progress) {
	    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	  }
	
	  swiper.emit('setTranslate', swiper.translate, false);
	}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _setBreakpoint = _interopRequireDefault(__webpack_require__(97));
	
	var _getBreakpoint = _interopRequireDefault(__webpack_require__(98));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  setBreakpoint: _setBreakpoint.default,
	  getBreakpoint: _getBreakpoint.default
	};
	exports.default = _default;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setBreakpoint;
	
	var _utils = __webpack_require__(40);
	
	function setBreakpoint() {
	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      initialized = swiper.initialized,
	      _swiper$loopedSlides = swiper.loopedSlides,
	      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
	      params = swiper.params,
	      $el = swiper.$el;
	  var breakpoints = params.breakpoints;
	  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
	
	  var breakpoint = swiper.getBreakpoint(breakpoints);
	
	  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	
	    if (breakpointOnlyParams) {
	      ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
	        var paramValue = breakpointOnlyParams[param];
	        if (typeof paramValue === 'undefined') return;
	
	        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
	          breakpointOnlyParams[param] = 'auto';
	        } else if (param === 'slidesPerView') {
	          breakpointOnlyParams[param] = parseFloat(paramValue);
	        } else {
	          breakpointOnlyParams[param] = parseInt(paramValue, 10);
	        }
	      });
	    }
	
	    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
	    var wasMultiRow = params.slidesPerColumn > 1;
	    var isMultiRow = breakpointParams.slidesPerColumn > 1;
	
	    if (wasMultiRow && !isMultiRow) {
	      $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
	      swiper.emitContainerClasses();
	    } else if (!wasMultiRow && isMultiRow) {
	      $el.addClass(params.containerModifierClass + "multirow");
	
	      if (breakpointParams.slidesPerColumnFill === 'column') {
	        $el.addClass(params.containerModifierClass + "multirow-column");
	      }
	
	      swiper.emitContainerClasses();
	    }
	
	    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
	
	    if (directionChanged && initialized) {
	      swiper.changeDirection();
	    }
	
	    (0, _utils.extend)(swiper.params, breakpointParams);
	    (0, _utils.extend)(swiper, {
	      allowTouchMove: swiper.params.allowTouchMove,
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev
	    });
	    swiper.currentBreakpoint = breakpoint;
	    swiper.emit('_beforeBreakpoint', breakpointParams);
	
	    if (needsReLoop && initialized) {
	      swiper.loopDestroy();
	      swiper.loopCreate();
	      swiper.updateSlides();
	      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
	    }
	
	    swiper.emit('breakpoint', breakpointParams);
	  }
	}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getBreakpoints;
	
	var _ssrWindow = __webpack_require__(39);
	
	function getBreakpoints(breakpoints) {
	  var window = (0, _ssrWindow.getWindow)(); // Get breakpoint for window width
	
	  if (!breakpoints) return undefined;
	  var breakpoint = false;
	  var points = Object.keys(breakpoints).map(function (point) {
	    if (typeof point === 'string' && point.indexOf('@') === 0) {
	      var minRatio = parseFloat(point.substr(1));
	      var value = window.innerHeight * minRatio;
	      return {
	        value: value,
	        point: point
	      };
	    }
	
	    return {
	      value: point,
	      point: point
	    };
	  });
	  points.sort(function (a, b) {
	    return parseInt(a.value, 10) - parseInt(b.value, 10);
	  });
	
	  for (var i = 0; i < points.length; i += 1) {
	    var _points$i = points[i],
	        point = _points$i.point,
	        value = _points$i.value;
	
	    if (value <= window.innerWidth) {
	      breakpoint = point;
	    }
	  }
	
	  return breakpoint || 'max';
	}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClasses = _interopRequireDefault(__webpack_require__(100));
	
	var _removeClasses = _interopRequireDefault(__webpack_require__(101));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  addClasses: _addClasses.default,
	  removeClasses: _removeClasses.default
	};
	exports.default = _default;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = addClasses;
	
	function addClasses() {
	  var swiper = this;
	  var classNames = swiper.classNames,
	      params = swiper.params,
	      rtl = swiper.rtl,
	      $el = swiper.$el,
	      device = swiper.device;
	  var suffixes = [];
	  suffixes.push('initialized');
	  suffixes.push(params.direction);
	
	  if (params.freeMode) {
	    suffixes.push('free-mode');
	  }
	
	  if (params.autoHeight) {
	    suffixes.push('autoheight');
	  }
	
	  if (rtl) {
	    suffixes.push('rtl');
	  }
	
	  if (params.slidesPerColumn > 1) {
	    suffixes.push('multirow');
	
	    if (params.slidesPerColumnFill === 'column') {
	      suffixes.push('multirow-column');
	    }
	  }
	
	  if (device.android) {
	    suffixes.push('android');
	  }
	
	  if (device.ios) {
	    suffixes.push('ios');
	  }
	
	  if (params.cssMode) {
	    suffixes.push('css-mode');
	  }
	
	  suffixes.forEach(function (suffix) {
	    classNames.push(params.containerModifierClass + suffix);
	  });
	  $el.addClass(classNames.join(' '));
	  swiper.emitContainerClasses();
	}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClasses;
	
	function removeClasses() {
	  var swiper = this;
	  var $el = swiper.$el,
	      classNames = swiper.classNames;
	  $el.removeClass(classNames.join(' '));
	  swiper.emitContainerClasses();
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _loadImage = _interopRequireDefault(__webpack_require__(103));
	
	var _preloadImages = _interopRequireDefault(__webpack_require__(104));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  loadImage: _loadImage.default,
	  preloadImages: _preloadImages.default
	};
	exports.default = _default;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loadImage;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
	  var window = (0, _ssrWindow.getWindow)();
	  var image;
	
	  function onReady() {
	    if (callback) callback();
	  }
	
	  var isPicture = (0, _dom.default)(imageEl).parent('picture')[0];
	
	  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
	    if (src) {
	      image = new window.Image();
	      image.onload = onReady;
	      image.onerror = onReady;
	
	      if (sizes) {
	        image.sizes = sizes;
	      }
	
	      if (srcset) {
	        image.srcset = srcset;
	      }
	
	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = preloadImages;
	
	function preloadImages() {
	  var swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');
	
	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
	    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
	
	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) swiper.update();
	      swiper.emit('imagesReady');
	    }
	  }
	
	  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    var imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
	  }
	}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	function checkOverflow() {
	  var swiper = this;
	  var params = swiper.params;
	  var wasLocked = swiper.isLocked;
	  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
	
	  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
	    swiper.isLocked = lastSlidePosition <= swiper.size;
	  } else {
	    swiper.isLocked = swiper.snapGrid.length === 1;
	  }
	
	  swiper.allowSlideNext = !swiper.isLocked;
	  swiper.allowSlidePrev = !swiper.isLocked; // events
	
	  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
	
	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	    if (swiper.navigation) swiper.navigation.update();
	  }
	}
	
	var _default = {
	  checkOverflow: checkOverflow
	};
	exports.default = _default;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'container',
	  initialSlide: 0,
	  speed: 300,
	  cssMode: false,
	  updateOnWindowResize: true,
	  nested: false,
	  // Overrides
	  width: null,
	  height: null,
	  //
	  preventInteractionOnTransition: false,
	  // ssr
	  userAgent: null,
	  url: null,
	  // To support iOS's swipe-to-go-back gesture (when being used in-app).
	  edgeSwipeDetection: false,
	  edgeSwipeThreshold: 20,
	  // Free mode
	  freeMode: false,
	  freeModeMomentum: true,
	  freeModeMomentumRatio: 1,
	  freeModeMomentumBounce: true,
	  freeModeMomentumBounceRatio: 1,
	  freeModeMomentumVelocityRatio: 1,
	  freeModeSticky: false,
	  freeModeMinimumVelocity: 0.02,
	  // Autoheight
	  autoHeight: false,
	  // Set wrapper width
	  setWrapperSize: false,
	  // Virtual Translate
	  virtualTranslate: false,
	  // Effects
	  effect: 'slide',
	  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	  // Breakpoints
	  breakpoints: undefined,
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerColumn: 1,
	  slidesPerColumnFill: 'column',
	  slidesPerGroup: 1,
	  slidesPerGroupSkip: 0,
	  centeredSlides: false,
	  centeredSlidesBounds: false,
	  slidesOffsetBefore: 0,
	  // in px
	  slidesOffsetAfter: 0,
	  // in px
	  normalizeSlideIndex: true,
	  centerInsufficientSlides: false,
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: false,
	  // Round length
	  roundLengths: false,
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: false,
	  touchStartPreventDefault: true,
	  touchStartForcePreventDefault: false,
	  touchReleaseOnEdges: false,
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	  // Progress
	  watchSlidesProgress: false,
	  watchSlidesVisibility: false,
	  // Cursor
	  grabCursor: false,
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,
	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopFillGroupWithBlank: false,
	  loopPreventsSlide: true,
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null,
	  // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,
	  // Passive Listeners
	  passiveListeners: true,
	  // NS
	  containerModifierClass: 'swiper-container-',
	  // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',
	  // Callbacks
	  runCallbacksOnInit: true,
	  // Internals
	  _emitClasses: false
	};
	exports.default = _default;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Virtual = {
	  update: function update(force) {
	    var swiper = this;
	    var _swiper$params = swiper.params,
	        slidesPerView = _swiper$params.slidesPerView,
	        slidesPerGroup = _swiper$params.slidesPerGroup,
	        centeredSlides = _swiper$params.centeredSlides;
	    var _swiper$params$virtua = swiper.params.virtual,
	        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
	        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
	    var _swiper$virtual = swiper.virtual,
	        previousFrom = _swiper$virtual.from,
	        previousTo = _swiper$virtual.to,
	        slides = _swiper$virtual.slides,
	        previousSlidesGrid = _swiper$virtual.slidesGrid,
	        renderSlide = _swiper$virtual.renderSlide,
	        previousOffset = _swiper$virtual.offset;
	    swiper.updateActiveIndex();
	    var activeIndex = swiper.activeIndex || 0;
	    var offsetProp;
	    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
	    var slidesAfter;
	    var slidesBefore;
	
	    if (centeredSlides) {
	      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
	      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
	    } else {
	      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
	      slidesBefore = slidesPerGroup + addSlidesBefore;
	    }
	
	    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
	    (0, _utils.extend)(swiper.virtual, {
	      from: from,
	      to: to,
	      offset: offset,
	      slidesGrid: swiper.slidesGrid
	    });
	
	    function onRendered() {
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	
	      if (swiper.lazy && swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    }
	
	    if (previousFrom === from && previousTo === to && !force) {
	      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	        swiper.slides.css(offsetProp, offset + "px");
	      }
	
	      swiper.updateProgress();
	      return;
	    }
	
	    if (swiper.params.virtual.renderExternal) {
	      swiper.params.virtual.renderExternal.call(swiper, {
	        offset: offset,
	        from: from,
	        to: to,
	        slides: function getSlides() {
	          var slidesToRender = [];
	
	          for (var i = from; i <= to; i += 1) {
	            slidesToRender.push(slides[i]);
	          }
	
	          return slidesToRender;
	        }()
	      });
	
	      if (swiper.params.virtual.renderExternalUpdate) {
	        onRendered();
	      }
	
	      return;
	    }
	
	    var prependIndexes = [];
	    var appendIndexes = [];
	
	    if (force) {
	      swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
	    } else {
	      for (var i = previousFrom; i <= previousTo; i += 1) {
	        if (i < from || i > to) {
	          swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
	        }
	      }
	    }
	
	    for (var _i = 0; _i < slides.length; _i += 1) {
	      if (_i >= from && _i <= to) {
	        if (typeof previousTo === 'undefined' || force) {
	          appendIndexes.push(_i);
	        } else {
	          if (_i > previousTo) appendIndexes.push(_i);
	          if (_i < previousFrom) prependIndexes.push(_i);
	        }
	      }
	    }
	
	    appendIndexes.forEach(function (index) {
	      swiper.$wrapperEl.append(renderSlide(slides[index], index));
	    });
	    prependIndexes.sort(function (a, b) {
	      return b - a;
	    }).forEach(function (index) {
	      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	    });
	    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
	    onRendered();
	  },
	  renderSlide: function renderSlide(slide, index) {
	    var swiper = this;
	    var params = swiper.params.virtual;
	
	    if (params.cache && swiper.virtual.cache[index]) {
	      return swiper.virtual.cache[index];
	    }
	
	    var $slideEl = params.renderSlide ? (0, _dom.default)(params.renderSlide.call(swiper, slide, index)) : (0, _dom.default)("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
	    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
	    if (params.cache) swiper.virtual.cache[index] = $slideEl;
	    return $slideEl;
	  },
	  appendSlide: function appendSlide(slides) {
	    var swiper = this;
	
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) swiper.virtual.slides.push(slides[i]);
	      }
	    } else {
	      swiper.virtual.slides.push(slides);
	    }
	
	    swiper.virtual.update(true);
	  },
	  prependSlide: function prependSlide(slides) {
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var newActiveIndex = activeIndex + 1;
	    var numberOfNewSlides = 1;
	
	    if (Array.isArray(slides)) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
	      }
	
	      newActiveIndex = activeIndex + slides.length;
	      numberOfNewSlides = slides.length;
	    } else {
	      swiper.virtual.slides.unshift(slides);
	    }
	
	    if (swiper.params.virtual.cache) {
	      var cache = swiper.virtual.cache;
	      var newCache = {};
	      Object.keys(cache).forEach(function (cachedIndex) {
	        var $cachedEl = cache[cachedIndex];
	        var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
	
	        if (cachedElIndex) {
	          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
	        }
	
	        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
	      });
	      swiper.virtual.cache = newCache;
	    }
	
	    swiper.virtual.update(true);
	    swiper.slideTo(newActiveIndex, 0);
	  },
	  removeSlide: function removeSlide(slidesIndexes) {
	    var swiper = this;
	    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
	    var activeIndex = swiper.activeIndex;
	
	    if (Array.isArray(slidesIndexes)) {
	      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
	        swiper.virtual.slides.splice(slidesIndexes[i], 1);
	
	        if (swiper.params.virtual.cache) {
	          delete swiper.virtual.cache[slidesIndexes[i]];
	        }
	
	        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
	        activeIndex = Math.max(activeIndex, 0);
	      }
	    } else {
	      swiper.virtual.slides.splice(slidesIndexes, 1);
	
	      if (swiper.params.virtual.cache) {
	        delete swiper.virtual.cache[slidesIndexes];
	      }
	
	      if (slidesIndexes < activeIndex) activeIndex -= 1;
	      activeIndex = Math.max(activeIndex, 0);
	    }
	
	    swiper.virtual.update(true);
	    swiper.slideTo(activeIndex, 0);
	  },
	  removeAllSlides: function removeAllSlides() {
	    var swiper = this;
	    swiper.virtual.slides = [];
	
	    if (swiper.params.virtual.cache) {
	      swiper.virtual.cache = {};
	    }
	
	    swiper.virtual.update(true);
	    swiper.slideTo(0, 0);
	  }
	};
	var _default = {
	  name: 'virtual',
	  params: {
	    virtual: {
	      enabled: false,
	      slides: [],
	      cache: true,
	      renderSlide: null,
	      renderExternal: null,
	      renderExternalUpdate: true,
	      addSlidesBefore: 0,
	      addSlidesAfter: 0
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      virtual: _extends(_extends({}, Virtual), {}, {
	        slides: swiper.params.virtual.slides,
	        cache: {}
	      })
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (!swiper.params.virtual.enabled) return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
	      var overwriteParams = {
	        watchSlidesProgress: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	
	      if (!swiper.params.initialSlide) {
	        swiper.virtual.update();
	      }
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (!swiper.params.virtual.enabled) return;
	      swiper.virtual.update();
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Keyboard = {
	  handle: function handle(event) {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    var document = (0, _ssrWindow.getDocument)();
	    var rtl = swiper.rtlTranslate;
	    var e = event;
	    if (e.originalEvent) e = e.originalEvent; // jquery fix
	
	    var kc = e.keyCode || e.charCode;
	    var pageUpDown = swiper.params.keyboard.pageUpDown;
	    var isPageUp = pageUpDown && kc === 33;
	    var isPageDown = pageUpDown && kc === 34;
	    var isArrowLeft = kc === 37;
	    var isArrowRight = kc === 39;
	    var isArrowUp = kc === 38;
	    var isArrowDown = kc === 40; // Directions locks
	
	    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
	      return false;
	    }
	
	    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
	      return false;
	    }
	
	    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	      return undefined;
	    }
	
	    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
	      return undefined;
	    }
	
	    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
	      var inView = false; // Check that swiper should be inside of visible area of window
	
	      if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
	        return undefined;
	      }
	
	      var windowWidth = window.innerWidth;
	      var windowHeight = window.innerHeight;
	      var swiperOffset = swiper.$el.offset();
	      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
	      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
	
	      for (var i = 0; i < swiperCoord.length; i += 1) {
	        var point = swiperCoord[i];
	
	        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
	          inView = true;
	        }
	      }
	
	      if (!inView) return undefined;
	    }
	
	    if (swiper.isHorizontal()) {
	      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
	        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	      }
	
	      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
	      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
	    } else {
	      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
	        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	      }
	
	      if (isPageDown || isArrowDown) swiper.slideNext();
	      if (isPageUp || isArrowUp) swiper.slidePrev();
	    }
	
	    swiper.emit('keyPress', kc);
	    return undefined;
	  },
	  enable: function enable() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    if (swiper.keyboard.enabled) return;
	    (0, _dom.default)(document).on('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    if (!swiper.keyboard.enabled) return;
	    (0, _dom.default)(document).off('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = false;
	  }
	};
	var _default = {
	  name: 'keyboard',
	  params: {
	    keyboard: {
	      enabled: false,
	      onlyInViewport: true,
	      pageUpDown: true
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      keyboard: _extends({
	        enabled: false
	      }, Keyboard)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.keyboard.enabled) {
	        swiper.keyboard.enable();
	      }
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.keyboard.enabled) {
	        swiper.keyboard.disable();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isEventSupported() {
	  var document = (0, _ssrWindow.getDocument)();
	  var eventName = 'onwheel';
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true) {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	var Mousewheel = {
	  lastScrollTime: (0, _utils.now)(),
	  lastEventBeforeSnap: undefined,
	  recentWheelEvents: [],
	  event: function event() {
	    var window = (0, _ssrWindow.getWindow)();
	    if (window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
	    return isEventSupported() ? 'wheel' : 'mousewheel';
	  },
	  normalize: function normalize(e) {
	    // Reasonable defaults
	    var PIXEL_STEP = 10;
	    var LINE_HEIGHT = 40;
	    var PAGE_HEIGHT = 800;
	    var sX = 0;
	    var sY = 0; // spinX, spinY
	
	    var pX = 0;
	    var pY = 0; // pixelX, pixelY
	    // Legacy
	
	    if ('detail' in e) {
	      sY = e.detail;
	    }
	
	    if ('wheelDelta' in e) {
	      sY = -e.wheelDelta / 120;
	    }
	
	    if ('wheelDeltaY' in e) {
	      sY = -e.wheelDeltaY / 120;
	    }
	
	    if ('wheelDeltaX' in e) {
	      sX = -e.wheelDeltaX / 120;
	    } // side scrolling on FF with DOMMouseScroll
	
	
	    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	      sX = sY;
	      sY = 0;
	    }
	
	    pX = sX * PIXEL_STEP;
	    pY = sY * PIXEL_STEP;
	
	    if ('deltaY' in e) {
	      pY = e.deltaY;
	    }
	
	    if ('deltaX' in e) {
	      pX = e.deltaX;
	    }
	
	    if (e.shiftKey && !pX) {
	      // if user scrolls with shift he wants horizontal scroll
	      pX = pY;
	      pY = 0;
	    }
	
	    if ((pX || pY) && e.deltaMode) {
	      if (e.deltaMode === 1) {
	        // delta in LINE units
	        pX *= LINE_HEIGHT;
	        pY *= LINE_HEIGHT;
	      } else {
	        // delta in PAGE units
	        pX *= PAGE_HEIGHT;
	        pY *= PAGE_HEIGHT;
	      }
	    } // Fall-back if spin cannot be determined
	
	
	    if (pX && !sX) {
	      sX = pX < 1 ? -1 : 1;
	    }
	
	    if (pY && !sY) {
	      sY = pY < 1 ? -1 : 1;
	    }
	
	    return {
	      spinX: sX,
	      spinY: sY,
	      pixelX: pX,
	      pixelY: pY
	    };
	  },
	  handleMouseEnter: function handleMouseEnter() {
	    var swiper = this;
	    swiper.mouseEntered = true;
	  },
	  handleMouseLeave: function handleMouseLeave() {
	    var swiper = this;
	    swiper.mouseEntered = false;
	  },
	  handle: function handle(event) {
	    var e = event;
	    var swiper = this;
	    var params = swiper.params.mousewheel;
	
	    if (swiper.params.cssMode) {
	      e.preventDefault();
	    }
	
	    var target = swiper.$el;
	
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = (0, _dom.default)(swiper.params.mousewheel.eventsTarget);
	    }
	
	    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
	    if (e.originalEvent) e = e.originalEvent; // jquery fix
	
	    var delta = 0;
	    var rtlFactor = swiper.rtlTranslate ? -1 : 1;
	    var data = Mousewheel.normalize(e);
	
	    if (params.forceToAxis) {
	      if (swiper.isHorizontal()) {
	        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
	      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
	    } else {
	      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	    }
	
	    if (delta === 0) return true;
	    if (params.invert) delta = -delta;
	
	    if (!swiper.params.freeMode) {
	      // Register the new event in a variable which stores the relevant data
	      var newEvent = {
	        time: (0, _utils.now)(),
	        delta: Math.abs(delta),
	        direction: Math.sign(delta),
	        raw: event
	      }; // Keep the most recent events
	
	      var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
	
	      if (recentWheelEvents.length >= 2) {
	        recentWheelEvents.shift(); // only store the last N events
	      }
	
	      var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
	      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
	      //   If direction has changed or
	      //   if the scroll is quicker than the previous one:
	      //     Animate the slider.
	      // Else (this is the first time the wheel is moved):
	      //     Animate the slider.
	
	      if (prevEvent) {
	        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
	          swiper.mousewheel.animateSlider(newEvent);
	        }
	      } else {
	        swiper.mousewheel.animateSlider(newEvent);
	      } // If it's time to release the scroll:
	      //   Return now so you don't hit the preventDefault.
	
	
	      if (swiper.mousewheel.releaseScroll(newEvent)) {
	        return true;
	      }
	    } else {
	      // Freemode or scrollContainer:
	      // If we recently snapped after a momentum scroll, then ignore wheel events
	      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
	      // or if it's a new scroll (larger delta or inverse sign as last event before
	      // an end-of-momentum snap).
	      var _newEvent = {
	        time: (0, _utils.now)(),
	        delta: Math.abs(delta),
	        direction: Math.sign(delta)
	      };
	      var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
	      var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;
	
	      if (!ignoreWheelEvents) {
	        swiper.mousewheel.lastEventBeforeSnap = undefined;
	
	        if (swiper.params.loop) {
	          swiper.loopFix();
	        }
	
	        var position = swiper.getTranslate() + delta * params.sensitivity;
	        var wasBeginning = swiper.isBeginning;
	        var wasEnd = swiper.isEnd;
	        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
	        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
	        swiper.setTransition(0);
	        swiper.setTranslate(position);
	        swiper.updateProgress();
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	
	        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
	          swiper.updateSlidesClasses();
	        }
	
	        if (swiper.params.freeModeSticky) {
	          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
	          // the end of a momentum scroll by storing recent (N=15?) wheel events.
	          // 1. do all N events have decreasing or same (absolute value) delta?
	          // 2. did all N events arrive in the last M (M=500?) msecs?
	          // 3. does the earliest event have an (absolute value) delta that's
	          //    at least P (P=1?) larger than the most recent event's delta?
	          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
	          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
	          // Snap immediately and ignore remaining wheel events in this scroll.
	          // See comment above for "remaining wheel events in this scroll" determination.
	          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
	          clearTimeout(swiper.mousewheel.timeout);
	          swiper.mousewheel.timeout = undefined;
	          var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;
	
	          if (_recentWheelEvents.length >= 15) {
	            _recentWheelEvents.shift(); // only store the last N events
	
	          }
	
	          var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;
	
	          var firstEvent = _recentWheelEvents[0];
	
	          _recentWheelEvents.push(_newEvent);
	
	          if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
	            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
	            _recentWheelEvents.splice(0);
	          } else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
	            // We're at the end of the deceleration of a momentum scroll, so there's no need
	            // to wait for more events. Snap ASAP on the next tick.
	            // Also, because there's some remaining momentum we'll bias the snap in the
	            // direction of the ongoing scroll because it's better UX for the scroll to snap
	            // in the same direction as the scroll instead of reversing to snap.  Therefore,
	            // if it's already scrolled more than 20% in the current direction, keep going.
	            var snapToThreshold = delta > 0 ? 0.8 : 0.2;
	            swiper.mousewheel.lastEventBeforeSnap = _newEvent;
	
	            _recentWheelEvents.splice(0);
	
	            swiper.mousewheel.timeout = (0, _utils.nextTick)(function () {
	              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	            }, 0); // no delay; move on next tick
	          }
	
	          if (!swiper.mousewheel.timeout) {
	            // if we get here, then we haven't detected the end of a momentum scroll, so
	            // we'll consider a scroll "complete" when there haven't been any wheel events
	            // for 500ms.
	            swiper.mousewheel.timeout = (0, _utils.nextTick)(function () {
	              var snapToThreshold = 0.5;
	              swiper.mousewheel.lastEventBeforeSnap = _newEvent;
	
	              _recentWheelEvents.splice(0);
	
	              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	            }, 500);
	          }
	        } // Emit event
	
	
	        if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay
	
	        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
	
	        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
	      }
	    }
	
	    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	    return false;
	  },
	  animateSlider: function animateSlider(newEvent) {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	
	    if (this.params.mousewheel.thresholdDelta && newEvent.delta < this.params.mousewheel.thresholdDelta) {
	      // Prevent if delta of wheel scroll delta is below configured threshold
	      return false;
	    }
	
	    if (this.params.mousewheel.thresholdTime && (0, _utils.now)() - swiper.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) {
	      // Prevent if time between scrolls is below configured threshold
	      return false;
	    } // If the movement is NOT big enough and
	    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
	    //   Don't go any further (avoid insignificant scroll movement).
	
	
	    if (newEvent.delta >= 6 && (0, _utils.now)() - swiper.mousewheel.lastScrollTime < 60) {
	      // Return false as a default
	      return true;
	    } // If user is scrolling towards the end:
	    //   If the slider hasn't hit the latest slide or
	    //   if the slider is a loop and
	    //   if the slider isn't moving right now:
	    //     Go to next slide and
	    //     emit a scroll event.
	    // Else (the user is scrolling towards the beginning) and
	    // if the slider hasn't hit the first slide or
	    // if the slider is a loop and
	    // if the slider isn't moving right now:
	    //   Go to prev slide and
	    //   emit a scroll event.
	
	
	    if (newEvent.direction < 0) {
	      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	        swiper.slideNext();
	        swiper.emit('scroll', newEvent.raw);
	      }
	    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	      swiper.slidePrev();
	      swiper.emit('scroll', newEvent.raw);
	    } // If you got here is because an animation has been triggered so store the current time
	
	
	    swiper.mousewheel.lastScrollTime = new window.Date().getTime(); // Return false as a default
	
	    return false;
	  },
	  releaseScroll: function releaseScroll(newEvent) {
	    var swiper = this;
	    var params = swiper.params.mousewheel;
	
	    if (newEvent.direction < 0) {
	      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
	        // Return true to animate scroll on edges
	        return true;
	      }
	    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
	      // Return true to animate scroll on edges
	      return true;
	    }
	
	    return false;
	  },
	  enable: function enable() {
	    var swiper = this;
	    var event = Mousewheel.event();
	
	    if (swiper.params.cssMode) {
	      swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
	      return true;
	    }
	
	    if (!event) return false;
	    if (swiper.mousewheel.enabled) return false;
	    var target = swiper.$el;
	
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = (0, _dom.default)(swiper.params.mousewheel.eventsTarget);
	    }
	
	    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
	    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
	    target.on(event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = true;
	    return true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    var event = Mousewheel.event();
	
	    if (swiper.params.cssMode) {
	      swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
	      return true;
	    }
	
	    if (!event) return false;
	    if (!swiper.mousewheel.enabled) return false;
	    var target = swiper.$el;
	
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = (0, _dom.default)(swiper.params.mousewheel.eventsTarget);
	    }
	
	    target.off(event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = false;
	    return true;
	  }
	};
	var _default = {
	  name: 'mousewheel',
	  params: {
	    mousewheel: {
	      enabled: false,
	      releaseOnEdges: false,
	      invert: false,
	      forceToAxis: false,
	      sensitivity: 1,
	      eventsTarget: 'container',
	      thresholdDelta: null,
	      thresholdTime: null
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      mousewheel: {
	        enabled: false,
	        lastScrollTime: (0, _utils.now)(),
	        lastEventBeforeSnap: undefined,
	        recentWheelEvents: [],
	        enable: Mousewheel.enable,
	        disable: Mousewheel.disable,
	        handle: Mousewheel.handle,
	        handleMouseEnter: Mousewheel.handleMouseEnter,
	        handleMouseLeave: Mousewheel.handleMouseLeave,
	        animateSlider: Mousewheel.animateSlider,
	        releaseScroll: Mousewheel.releaseScroll
	      }
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
	        swiper.mousewheel.disable();
	      }
	
	      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.params.cssMode) {
	        swiper.mousewheel.enable();
	      }
	
	      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Navigation = {
	  update: function update() {
	    // Update Navigation Buttons
	    var swiper = this;
	    var params = swiper.params.navigation;
	    if (swiper.params.loop) return;
	    var _swiper$navigation = swiper.navigation,
	        $nextEl = _swiper$navigation.$nextEl,
	        $prevEl = _swiper$navigation.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        $prevEl.addClass(params.disabledClass);
	      } else {
	        $prevEl.removeClass(params.disabledClass);
	      }
	
	      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        $nextEl.addClass(params.disabledClass);
	      } else {
	        $nextEl.removeClass(params.disabledClass);
	      }
	
	      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  },
	  onPrevClick: function onPrevClick(e) {
	    var swiper = this;
	    e.preventDefault();
	    if (swiper.isBeginning && !swiper.params.loop) return;
	    swiper.slidePrev();
	  },
	  onNextClick: function onNextClick(e) {
	    var swiper = this;
	    e.preventDefault();
	    if (swiper.isEnd && !swiper.params.loop) return;
	    swiper.slideNext();
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.navigation;
	    if (!(params.nextEl || params.prevEl)) return;
	    var $nextEl;
	    var $prevEl;
	
	    if (params.nextEl) {
	      $nextEl = (0, _dom.default)(params.nextEl);
	
	      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
	        $nextEl = swiper.$el.find(params.nextEl);
	      }
	    }
	
	    if (params.prevEl) {
	      $prevEl = (0, _dom.default)(params.prevEl);
	
	      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
	        $prevEl = swiper.$el.find(params.prevEl);
	      }
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', swiper.navigation.onNextClick);
	    }
	
	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', swiper.navigation.onPrevClick);
	    }
	
	    (0, _utils.extend)(swiper.navigation, {
	      $nextEl: $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl: $prevEl,
	      prevEl: $prevEl && $prevEl[0]
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var _swiper$navigation2 = swiper.navigation,
	        $nextEl = _swiper$navigation2.$nextEl,
	        $prevEl = _swiper$navigation2.$prevEl;
	
	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click', swiper.navigation.onNextClick);
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	
	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click', swiper.navigation.onPrevClick);
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  }
	};
	var _default = {
	  name: 'navigation',
	  params: {
	    navigation: {
	      nextEl: null,
	      prevEl: null,
	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      navigation: _extends({}, Navigation)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.navigation.init();
	      swiper.navigation.update();
	    },
	    toEdge: function toEdge(swiper) {
	      swiper.navigation.update();
	    },
	    fromEdge: function fromEdge(swiper) {
	      swiper.navigation.update();
	    },
	    destroy: function destroy(swiper) {
	      swiper.navigation.destroy();
	    },
	    click: function click(swiper, e) {
	      var _swiper$navigation3 = swiper.navigation,
	          $nextEl = _swiper$navigation3.$nextEl,
	          $prevEl = _swiper$navigation3.$prevEl;
	
	      if (swiper.params.navigation.hideOnClick && !(0, _dom.default)(e.target).is($prevEl) && !(0, _dom.default)(e.target).is($nextEl)) {
	        var isHidden;
	
	        if ($nextEl) {
	          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
	        } else if ($prevEl) {
	          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
	        }
	
	        if (isHidden === true) {
	          swiper.emit('navigationShow');
	        } else {
	          swiper.emit('navigationHide');
	        }
	
	        if ($nextEl) {
	          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
	        }
	
	        if ($prevEl) {
	          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
	        }
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Pagination = {
	  update: function update() {
	    // Render || Update Pagination bullets/items
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el; // Current/Total
	
	    var current;
	    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	
	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	
	      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
	        current -= slidesLength - swiper.loopedSlides * 2;
	      }
	
	      if (current > total - 1) current -= total;
	      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    } // Types
	
	
	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      var bullets = swiper.pagination.bullets;
	      var firstIndex;
	      var lastIndex;
	      var midIndex;
	
	      if (params.dynamicBullets) {
	        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
	
	        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
	
	          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
	            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (swiper.pagination.dynamicBulletIndex < 0) {
	            swiper.pagination.dynamicBulletIndex = 0;
	          }
	        }
	
	        firstIndex = current - swiper.pagination.dynamicBulletIndex;
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }
	
	      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
	
	      if ($el.length > 1) {
	        bullets.each(function (bullet) {
	          var $bullet = (0, _dom.default)(bullet);
	          var bulletIndex = $bullet.index();
	
	          if (bulletIndex === current) {
	            $bullet.addClass(params.bulletActiveClass);
	          }
	
	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              $bullet.addClass(params.bulletActiveClass + "-main");
	            }
	
	            if (bulletIndex === firstIndex) {
	              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	            }
	
	            if (bulletIndex === lastIndex) {
	              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	            }
	          }
	        });
	      } else {
	        var $bullet = bullets.eq(current);
	        var bulletIndex = $bullet.index();
	        $bullet.addClass(params.bulletActiveClass);
	
	        if (params.dynamicBullets) {
	          var $firstDisplayedBullet = bullets.eq(firstIndex);
	          var $lastDisplayedBullet = bullets.eq(lastIndex);
	
	          for (var i = firstIndex; i <= lastIndex; i += 1) {
	            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
	          }
	
	          if (swiper.params.loop) {
	            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
	              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
	                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
	              }
	
	              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
	            } else {
	              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	            }
	          } else {
	            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	          }
	        }
	      }
	
	      if (params.dynamicBullets) {
	        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
	        var offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
	      }
	    }
	
	    if (params.type === 'fraction') {
	      $el.find("." + params.currentClass).text(params.formatFractionCurrent(current + 1));
	      $el.find("." + params.totalClass).text(params.formatFractionTotal(total));
	    }
	
	    if (params.type === 'progressbar') {
	      var progressbarDirection;
	
	      if (params.progressbarOpposite) {
	        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	      } else {
	        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	      }
	
	      var scale = (current + 1) / total;
	      var scaleX = 1;
	      var scaleY = 1;
	
	      if (progressbarDirection === 'horizontal') {
	        scaleX = scale;
	      } else {
	        scaleY = scale;
	      }
	
	      $el.find("." + params.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
	    }
	
	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      swiper.emit('paginationRender', $el[0]);
	    } else {
	      swiper.emit('paginationUpdate', $el[0]);
	    }
	
	    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	  },
	  render: function render() {
	    // Render Container
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el;
	    var paginationHTML = '';
	
	    if (params.type === 'bullets') {
	      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	
	      for (var i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
	        }
	      }
	
	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find("." + params.bulletClass);
	    }
	
	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
	      }
	
	      $el.html(paginationHTML);
	    }
	
	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
	      }
	
	      $el.html(paginationHTML);
	    }
	
	    if (params.type !== 'custom') {
	      swiper.emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el) return;
	    var $el = (0, _dom.default)(params.el);
	    if ($el.length === 0) return;
	
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
	      $el = swiper.$el.find(params.el);
	    }
	
	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }
	
	    $el.addClass(params.modifierClass + params.type);
	
	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
	      swiper.pagination.dynamicBulletIndex = 0;
	
	      if (params.dynamicMainBullets < 1) {
	        params.dynamicMainBullets = 1;
	      }
	    }
	
	    if (params.type === 'progressbar' && params.progressbarOpposite) {
	      $el.addClass(params.progressbarOppositeClass);
	    }
	
	    if (params.clickable) {
	      $el.on('click', "." + params.bulletClass, function onClick(e) {
	        e.preventDefault();
	        var index = (0, _dom.default)(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) index += swiper.loopedSlides;
	        swiper.slideTo(index);
	      });
	    }
	
	    (0, _utils.extend)(swiper.pagination, {
	      $el: $el,
	      el: $el[0]
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var $el = swiper.pagination.$el;
	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
	
	    if (params.clickable) {
	      $el.off('click', "." + params.bulletClass);
	    }
	  }
	};
	var _default = {
	  name: 'pagination',
	  params: {
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      progressbarOpposite: false,
	      type: 'bullets',
	      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      formatFractionCurrent: function formatFractionCurrent(number) {
	        return number;
	      },
	      formatFractionTotal: function formatFractionTotal(number) {
	        return number;
	      },
	      bulletClass: 'swiper-pagination-bullet',
	      bulletActiveClass: 'swiper-pagination-bullet-active',
	      modifierClass: 'swiper-pagination-',
	      // NEW
	      currentClass: 'swiper-pagination-current',
	      totalClass: 'swiper-pagination-total',
	      hiddenClass: 'swiper-pagination-hidden',
	      progressbarFillClass: 'swiper-pagination-progressbar-fill',
	      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	      clickableClass: 'swiper-pagination-clickable',
	      // NEW
	      lockClass: 'swiper-pagination-lock'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      pagination: _extends({
	        dynamicBulletIndex: 0
	      }, Pagination)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.pagination.init();
	      swiper.pagination.render();
	      swiper.pagination.update();
	    },
	    activeIndexChange: function activeIndexChange(swiper) {
	      if (swiper.params.loop) {
	        swiper.pagination.update();
	      } else if (typeof swiper.snapIndex === 'undefined') {
	        swiper.pagination.update();
	      }
	    },
	    snapIndexChange: function snapIndexChange(swiper) {
	      if (!swiper.params.loop) {
	        swiper.pagination.update();
	      }
	    },
	    slidesLengthChange: function slidesLengthChange(swiper) {
	      if (swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    snapGridLengthChange: function snapGridLengthChange(swiper) {
	      if (!swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    destroy: function destroy(swiper) {
	      swiper.pagination.destroy();
	    },
	    click: function click(swiper, e) {
	      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, _dom.default)(e.target).hasClass(swiper.params.pagination.bulletClass)) {
	        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
	
	        if (isHidden === true) {
	          swiper.emit('paginationShow');
	        } else {
	          swiper.emit('paginationHide');
	        }
	
	        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Scrollbar = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
	    var scrollbar = swiper.scrollbar,
	        rtl = swiper.rtlTranslate,
	        progress = swiper.progress;
	    var dragSize = scrollbar.dragSize,
	        trackSize = scrollbar.trackSize,
	        $dragEl = scrollbar.$dragEl,
	        $el = scrollbar.$el;
	    var params = swiper.params.scrollbar;
	    var newSize = dragSize;
	    var newPos = (trackSize - dragSize) * progress;
	
	    if (rtl) {
	      newPos = -newPos;
	
	      if (newPos > 0) {
	        newSize = dragSize - newPos;
	        newPos = 0;
	      } else if (-newPos + dragSize > trackSize) {
	        newSize = trackSize + newPos;
	      }
	    } else if (newPos < 0) {
	      newSize = dragSize + newPos;
	      newPos = 0;
	    } else if (newPos + dragSize > trackSize) {
	      newSize = trackSize - newPos;
	    }
	
	    if (swiper.isHorizontal()) {
	      $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
	      $dragEl[0].style.width = newSize + "px";
	    } else {
	      $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
	      $dragEl[0].style.height = newSize + "px";
	    }
	
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.timeout);
	      $el[0].style.opacity = 1;
	      swiper.scrollbar.timeout = setTimeout(function () {
	        $el[0].style.opacity = 0;
	        $el.transition(400);
	      }, 1000);
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
	    swiper.scrollbar.$dragEl.transition(duration);
	  },
	  updateSize: function updateSize() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
	    var scrollbar = swiper.scrollbar;
	    var $dragEl = scrollbar.$dragEl,
	        $el = scrollbar.$el;
	    $dragEl[0].style.width = '';
	    $dragEl[0].style.height = '';
	    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
	    var divider = swiper.size / swiper.virtualSize;
	    var moveDivider = divider * (trackSize / swiper.size);
	    var dragSize;
	
	    if (swiper.params.scrollbar.dragSize === 'auto') {
	      dragSize = trackSize * divider;
	    } else {
	      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	    }
	
	    if (swiper.isHorizontal()) {
	      $dragEl[0].style.width = dragSize + "px";
	    } else {
	      $dragEl[0].style.height = dragSize + "px";
	    }
	
	    if (divider >= 1) {
	      $el[0].style.display = 'none';
	    } else {
	      $el[0].style.display = '';
	    }
	
	    if (swiper.params.scrollbar.hide) {
	      $el[0].style.opacity = 0;
	    }
	
	    (0, _utils.extend)(scrollbar, {
	      trackSize: trackSize,
	      divider: divider,
	      moveDivider: moveDivider,
	      dragSize: dragSize
	    });
	    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	  },
	  getPointerPosition: function getPointerPosition(e) {
	    var swiper = this;
	
	    if (swiper.isHorizontal()) {
	      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
	    }
	
	    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
	  },
	  setDragPosition: function setDragPosition(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar,
	        rtl = swiper.rtlTranslate;
	    var $el = scrollbar.$el,
	        dragSize = scrollbar.dragSize,
	        trackSize = scrollbar.trackSize,
	        dragStartPos = scrollbar.dragStartPos;
	    var positionRatio;
	    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
	    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	
	    if (rtl) {
	      positionRatio = 1 - positionRatio;
	    }
	
	    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
	    swiper.updateProgress(position);
	    swiper.setTranslate(position);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  },
	  onDragStart: function onDragStart(e) {
	    var swiper = this;
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar,
	        $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el,
	        $dragEl = scrollbar.$dragEl;
	    swiper.scrollbar.isTouched = true;
	    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
	    e.preventDefault();
	    e.stopPropagation();
	    $wrapperEl.transition(100);
	    $dragEl.transition(100);
	    scrollbar.setDragPosition(e);
	    clearTimeout(swiper.scrollbar.dragTimeout);
	    $el.transition(0);
	
	    if (params.hide) {
	      $el.css('opacity', 1);
	    }
	
	    if (swiper.params.cssMode) {
	      swiper.$wrapperEl.css('scroll-snap-type', 'none');
	    }
	
	    swiper.emit('scrollbarDragStart', e);
	  },
	  onDragMove: function onDragMove(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar,
	        $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el,
	        $dragEl = scrollbar.$dragEl;
	    if (!swiper.scrollbar.isTouched) return;
	    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	    scrollbar.setDragPosition(e);
	    $wrapperEl.transition(0);
	    $el.transition(0);
	    $dragEl.transition(0);
	    swiper.emit('scrollbarDragMove', e);
	  },
	  onDragEnd: function onDragEnd(e) {
	    var swiper = this;
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar,
	        $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    if (!swiper.scrollbar.isTouched) return;
	    swiper.scrollbar.isTouched = false;
	
	    if (swiper.params.cssMode) {
	      swiper.$wrapperEl.css('scroll-snap-type', '');
	      $wrapperEl.transition('');
	    }
	
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.dragTimeout);
	      swiper.scrollbar.dragTimeout = (0, _utils.nextTick)(function () {
	        $el.css('opacity', 0);
	        $el.transition(400);
	      }, 1000);
	    }
	
	    swiper.emit('scrollbarDragEnd', e);
	
	    if (params.snapOnRelease) {
	      swiper.slideToClosest();
	    }
	  },
	  enableDraggable: function enableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) return;
	    var document = (0, _ssrWindow.getDocument)();
	    var scrollbar = swiper.scrollbar,
	        touchEventsTouch = swiper.touchEventsTouch,
	        touchEventsDesktop = swiper.touchEventsDesktop,
	        params = swiper.params,
	        support = swiper.support;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = support.passiveListener && params.passiveListeners ? {
	      passive: false,
	      capture: false
	    } : false;
	    var passiveListener = support.passiveListener && params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	
	    if (!support.touch) {
	      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	    }
	  },
	  disableDraggable: function disableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) return;
	    var document = (0, _ssrWindow.getDocument)();
	    var scrollbar = swiper.scrollbar,
	        touchEventsTouch = swiper.touchEventsTouch,
	        touchEventsDesktop = swiper.touchEventsDesktop,
	        params = swiper.params,
	        support = swiper.support;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = support.passiveListener && params.passiveListeners ? {
	      passive: false,
	      capture: false
	    } : false;
	    var passiveListener = support.passiveListener && params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	
	    if (!support.touch) {
	      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) return;
	    var scrollbar = swiper.scrollbar,
	        $swiperEl = swiper.$el;
	    var params = swiper.params.scrollbar;
	    var $el = (0, _dom.default)(params.el);
	
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	      $el = $swiperEl.find(params.el);
	    }
	
	    var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
	
	    if ($dragEl.length === 0) {
	      $dragEl = (0, _dom.default)("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
	      $el.append($dragEl);
	    }
	
	    (0, _utils.extend)(scrollbar, {
	      $el: $el,
	      el: $el[0],
	      $dragEl: $dragEl,
	      dragEl: $dragEl[0]
	    });
	
	    if (params.draggable) {
	      scrollbar.enableDraggable();
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.scrollbar.disableDraggable();
	  }
	};
	var _default = {
	  name: 'scrollbar',
	  params: {
	    scrollbar: {
	      el: null,
	      dragSize: 'auto',
	      hide: false,
	      draggable: false,
	      snapOnRelease: true,
	      lockClass: 'swiper-scrollbar-lock',
	      dragClass: 'swiper-scrollbar-drag'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      scrollbar: _extends({
	        isTouched: false,
	        timeout: null,
	        dragTimeout: null
	      }, Scrollbar)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.scrollbar.init();
	      swiper.scrollbar.updateSize();
	      swiper.scrollbar.setTranslate();
	    },
	    update: function update(swiper) {
	      swiper.scrollbar.updateSize();
	    },
	    resize: function resize(swiper) {
	      swiper.scrollbar.updateSize();
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      swiper.scrollbar.updateSize();
	    },
	    setTranslate: function setTranslate(swiper) {
	      swiper.scrollbar.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      swiper.scrollbar.setTransition(duration);
	    },
	    destroy: function destroy(swiper) {
	      swiper.scrollbar.destroy();
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Parallax = {
	  setTransform: function setTransform(el, progress) {
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var $el = (0, _dom.default)(el);
	    var rtlFactor = rtl ? -1 : 1;
	    var p = $el.attr('data-swiper-parallax') || '0';
	    var x = $el.attr('data-swiper-parallax-x');
	    var y = $el.attr('data-swiper-parallax-y');
	    var scale = $el.attr('data-swiper-parallax-scale');
	    var opacity = $el.attr('data-swiper-parallax-opacity');
	
	    if (x || y) {
	      x = x || '0';
	      y = y || '0';
	    } else if (swiper.isHorizontal()) {
	      x = p;
	      y = '0';
	    } else {
	      y = p;
	      x = '0';
	    }
	
	    if (x.indexOf('%') >= 0) {
	      x = parseInt(x, 10) * progress * rtlFactor + "%";
	    } else {
	      x = x * progress * rtlFactor + "px";
	    }
	
	    if (y.indexOf('%') >= 0) {
	      y = parseInt(y, 10) * progress + "%";
	    } else {
	      y = y * progress + "px";
	    }
	
	    if (typeof opacity !== 'undefined' && opacity !== null) {
	      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
	      $el[0].style.opacity = currentOpacity;
	    }
	
	    if (typeof scale === 'undefined' || scale === null) {
	      $el.transform("translate3d(" + x + ", " + y + ", 0px)");
	    } else {
	      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
	      $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
	    }
	  },
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el,
	        slides = swiper.slides,
	        progress = swiper.progress,
	        snapGrid = swiper.snapGrid;
	    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
	      swiper.parallax.setTransform(el, progress);
	    });
	    slides.each(function (slideEl, slideIndex) {
	      var slideProgress = slideEl.progress;
	
	      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
	      }
	
	      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	      (0, _dom.default)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
	        swiper.parallax.setTransform(el, slideProgress);
	      });
	    });
	  },
	  setTransition: function setTransition(duration) {
	    if (duration === void 0) {
	      duration = this.params.speed;
	    }
	
	    var swiper = this;
	    var $el = swiper.$el;
	    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (parallaxEl) {
	      var $parallaxEl = (0, _dom.default)(parallaxEl);
	      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	      if (duration === 0) parallaxDuration = 0;
	      $parallaxEl.transition(parallaxDuration);
	    });
	  }
	};
	var _default = {
	  name: 'parallax',
	  params: {
	    parallax: {
	      enabled: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      parallax: _extends({}, Parallax)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.params.watchSlidesProgress = true;
	      swiper.originalParams.watchSlidesProgress = true;
	    },
	    init: function init(swiper) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.parallax.setTranslate();
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.parallax.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.parallax.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Zoom = {
	  // Calc Scale From Multi-touches
	  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	    if (e.targetTouches.length < 2) return 1;
	    var x1 = e.targetTouches[0].pageX;
	    var y1 = e.targetTouches[0].pageY;
	    var x2 = e.targetTouches[1].pageX;
	    var y2 = e.targetTouches[1].pageY;
	    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	    return distance;
	  },
	  // Events
	  onGestureStart: function onGestureStart(e) {
	    var swiper = this;
	    var support = swiper.support;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    zoom.fakeGestureTouched = false;
	    zoom.fakeGestureMoved = false;
	
	    if (!support.gestures) {
	      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
	        return;
	      }
	
	      zoom.fakeGestureTouched = true;
	      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	    }
	
	    if (!gesture.$slideEl || !gesture.$slideEl.length) {
	      gesture.$slideEl = (0, _dom.default)(e.target).closest("." + swiper.params.slideClass);
	      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
	      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	
	      if (gesture.$imageWrapEl.length === 0) {
	        gesture.$imageEl = undefined;
	        return;
	      }
	    }
	
	    if (gesture.$imageEl) {
	      gesture.$imageEl.transition(0);
	    }
	
	    swiper.zoom.isScaling = true;
	  },
	  onGestureChange: function onGestureChange(e) {
	    var swiper = this;
	    var support = swiper.support;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	
	    if (!support.gestures) {
	      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
	        return;
	      }
	
	      zoom.fakeGestureMoved = true;
	      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
	      if (e.type === 'gesturechange') zoom.onGestureStart(e);
	      return;
	    }
	
	    if (support.gestures) {
	      zoom.scale = e.scale * zoom.currentScale;
	    } else {
	      zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
	    }
	
	    if (zoom.scale > gesture.maxRatio) {
	      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
	    }
	
	    if (zoom.scale < params.minRatio) {
	      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
	    }
	
	    gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
	  },
	  onGestureEnd: function onGestureEnd(e) {
	    var swiper = this;
	    var device = swiper.device;
	    var support = swiper.support;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	
	    if (!support.gestures) {
	      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	        return;
	      }
	
	      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
	        return;
	      }
	
	      zoom.fakeGestureTouched = false;
	      zoom.fakeGestureMoved = false;
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	    gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
	    zoom.currentScale = zoom.scale;
	    zoom.isScaling = false;
	    if (zoom.scale === 1) gesture.$slideEl = undefined;
	  },
	  onTouchStart: function onTouchStart(e) {
	    var swiper = this;
	    var device = swiper.device;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    if (image.isTouched) return;
	    if (device.android && e.cancelable) e.preventDefault();
	    image.isTouched = true;
	    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  },
	  onTouchMove: function onTouchMove(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image,
	        velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    swiper.allowClick = false;
	    if (!image.isTouched || !gesture.$slideEl) return;
	
	    if (!image.isMoved) {
	      image.width = gesture.$imageEl[0].offsetWidth;
	      image.height = gesture.$imageEl[0].offsetHeight;
	      image.startX = (0, _utils.getTranslate)(gesture.$imageWrapEl[0], 'x') || 0;
	      image.startY = (0, _utils.getTranslate)(gesture.$imageWrapEl[0], 'y') || 0;
	      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	      gesture.$imageWrapEl.transition(0);
	
	      if (swiper.rtl) {
	        image.startX = -image.startX;
	        image.startY = -image.startY;
	      }
	    } // Define if we need image drag
	
	
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
	    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
	    image.maxY = -image.minY;
	    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	
	    if (!image.isMoved && !zoom.isScaling) {
	      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
	        image.isTouched = false;
	        return;
	      }
	
	      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
	        image.isTouched = false;
	        return;
	      }
	    }
	
	    if (e.cancelable) {
	      e.preventDefault();
	    }
	
	    e.stopPropagation();
	    image.isMoved = true;
	    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
	    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
	
	    if (image.currentX < image.minX) {
	      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
	    }
	
	    if (image.currentX > image.maxX) {
	      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
	    }
	
	    if (image.currentY < image.minY) {
	      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
	    }
	
	    if (image.currentY > image.maxY) {
	      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
	    } // Velocity
	
	
	    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
	    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
	    if (!velocity.prevTime) velocity.prevTime = Date.now();
	    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
	    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
	    velocity.prevPositionX = image.touchesCurrent.x;
	    velocity.prevPositionY = image.touchesCurrent.y;
	    velocity.prevTime = Date.now();
	    gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
	  },
	  onTouchEnd: function onTouchEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image,
	        velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	
	    if (!image.isTouched || !image.isMoved) {
	      image.isTouched = false;
	      image.isMoved = false;
	      return;
	    }
	
	    image.isTouched = false;
	    image.isMoved = false;
	    var momentumDurationX = 300;
	    var momentumDurationY = 300;
	    var momentumDistanceX = velocity.x * momentumDurationX;
	    var newPositionX = image.currentX + momentumDistanceX;
	    var momentumDistanceY = velocity.y * momentumDurationY;
	    var newPositionY = image.currentY + momentumDistanceY; // Fix duration
	
	    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
	    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
	    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	    image.currentX = newPositionX;
	    image.currentY = newPositionY; // Define if we need image drag
	
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
	    image.maxY = -image.minY;
	    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
	    gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
	  },
	  onTransitionEnd: function onTransitionEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	
	    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	      if (gesture.$imageEl) {
	        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	      }
	
	      if (gesture.$imageWrapEl) {
	        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	      }
	
	      zoom.scale = 1;
	      zoom.currentScale = 1;
	      gesture.$slideEl = undefined;
	      gesture.$imageEl = undefined;
	      gesture.$imageWrapEl = undefined;
	    }
	  },
	  // Toggle Zoom
	  toggle: function toggle(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	
	    if (zoom.scale && zoom.scale !== 1) {
	      // Zoom Out
	      zoom.out();
	    } else {
	      // Zoom In
	      zoom.in(e);
	    }
	  },
	  in: function _in(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image;
	
	    if (!gesture.$slideEl) {
	      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
	        gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
	      } else {
	        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	      }
	
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    gesture.$slideEl.addClass("" + params.zoomedSlideClass);
	    var touchX;
	    var touchY;
	    var offsetX;
	    var offsetY;
	    var diffX;
	    var diffY;
	    var translateX;
	    var translateY;
	    var imageWidth;
	    var imageHeight;
	    var scaledWidth;
	    var scaledHeight;
	    var translateMinX;
	    var translateMinY;
	    var translateMaxX;
	    var translateMaxY;
	    var slideWidth;
	    var slideHeight;
	
	    if (typeof image.touchesStart.x === 'undefined' && e) {
	      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	    } else {
	      touchX = image.touchesStart.x;
	      touchY = image.touchesStart.y;
	    }
	
	    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	
	    if (e) {
	      slideWidth = gesture.$slideEl[0].offsetWidth;
	      slideHeight = gesture.$slideEl[0].offsetHeight;
	      offsetX = gesture.$slideEl.offset().left;
	      offsetY = gesture.$slideEl.offset().top;
	      diffX = offsetX + slideWidth / 2 - touchX;
	      diffY = offsetY + slideHeight / 2 - touchY;
	      imageWidth = gesture.$imageEl[0].offsetWidth;
	      imageHeight = gesture.$imageEl[0].offsetHeight;
	      scaledWidth = imageWidth * zoom.scale;
	      scaledHeight = imageHeight * zoom.scale;
	      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
	      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
	      translateMaxX = -translateMinX;
	      translateMaxY = -translateMinY;
	      translateX = diffX * zoom.scale;
	      translateY = diffY * zoom.scale;
	
	      if (translateX < translateMinX) {
	        translateX = translateMinX;
	      }
	
	      if (translateX > translateMaxX) {
	        translateX = translateMaxX;
	      }
	
	      if (translateY < translateMinY) {
	        translateY = translateMinY;
	      }
	
	      if (translateY > translateMaxY) {
	        translateY = translateMaxY;
	      }
	    } else {
	      translateX = 0;
	      translateY = 0;
	    }
	
	    gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
	    gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
	  },
	  out: function out() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;
	
	    if (!gesture.$slideEl) {
	      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
	        gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
	      } else {
	        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	      }
	
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    zoom.scale = 1;
	    zoom.currentScale = 1;
	    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	    gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
	    gesture.$slideEl = undefined;
	  },
	  toggleGestures: function toggleGestures(method) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var selector = zoom.slideSelector,
	        passive = zoom.passiveListener;
	    swiper.$wrapperEl[method]('gesturestart', selector, zoom.onGestureStart, passive);
	    swiper.$wrapperEl[method]('gesturechange', selector, zoom.onGestureChange, passive);
	    swiper.$wrapperEl[method]('gestureend', selector, zoom.onGestureEnd, passive);
	  },
	  enableGestures: function enableGestures() {
	    if (this.zoom.gesturesEnabled) return;
	    this.zoom.gesturesEnabled = true;
	    this.zoom.toggleGestures('on');
	  },
	  disableGestures: function disableGestures() {
	    if (!this.zoom.gesturesEnabled) return;
	    this.zoom.gesturesEnabled = false;
	    this.zoom.toggleGestures('off');
	  },
	  // Attach/Detach Events
	  enable: function enable() {
	    var swiper = this;
	    var support = swiper.support;
	    var zoom = swiper.zoom;
	    if (zoom.enabled) return;
	    zoom.enabled = true;
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    var activeListenerWithCapture = support.passiveListener ? {
	      passive: false,
	      capture: true
	    } : true;
	    var slideSelector = "." + swiper.params.slideClass;
	    swiper.zoom.passiveListener = passiveListener;
	    swiper.zoom.slideSelector = slideSelector; // Scale image
	
	    if (support.gestures) {
	      swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
	      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
	
	      if (swiper.touchEvents.cancel) {
	        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
	      }
	    } // Move image
	
	
	    swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
	  },
	  disable: function disable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (!zoom.enabled) return;
	    var support = swiper.support;
	    swiper.zoom.enabled = false;
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    var activeListenerWithCapture = support.passiveListener ? {
	      passive: false,
	      capture: true
	    } : true;
	    var slideSelector = "." + swiper.params.slideClass; // Scale image
	
	    if (support.gestures) {
	      swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
	      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
	
	      if (swiper.touchEvents.cancel) {
	        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
	      }
	    } // Move image
	
	
	    swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
	  }
	};
	var _default = {
	  name: 'zoom',
	  params: {
	    zoom: {
	      enabled: false,
	      maxRatio: 3,
	      minRatio: 1,
	      toggle: true,
	      containerClass: 'swiper-zoom-container',
	      zoomedSlideClass: 'swiper-slide-zoomed'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      zoom: _extends({
	        enabled: false,
	        scale: 1,
	        currentScale: 1,
	        isScaling: false,
	        gesture: {
	          $slideEl: undefined,
	          slideWidth: undefined,
	          slideHeight: undefined,
	          $imageEl: undefined,
	          $imageWrapEl: undefined,
	          maxRatio: 3
	        },
	        image: {
	          isTouched: undefined,
	          isMoved: undefined,
	          currentX: undefined,
	          currentY: undefined,
	          minX: undefined,
	          minY: undefined,
	          maxX: undefined,
	          maxY: undefined,
	          width: undefined,
	          height: undefined,
	          startX: undefined,
	          startY: undefined,
	          touchesStart: {},
	          touchesCurrent: {}
	        },
	        velocity: {
	          x: undefined,
	          y: undefined,
	          prevPositionX: undefined,
	          prevPositionY: undefined,
	          prevTime: undefined
	        }
	      }, Zoom)
	    });
	    var scale = 1;
	    Object.defineProperty(swiper.zoom, 'scale', {
	      get: function get() {
	        return scale;
	      },
	      set: function set(value) {
	        if (scale !== value) {
	          var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
	          var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
	          swiper.emit('zoomChange', value, imageEl, slideEl);
	        }
	
	        scale = value;
	      }
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.zoom.enabled) {
	        swiper.zoom.enable();
	      }
	    },
	    destroy: function destroy(swiper) {
	      swiper.zoom.disable();
	    },
	    touchStart: function touchStart(swiper, e) {
	      if (!swiper.zoom.enabled) return;
	      swiper.zoom.onTouchStart(e);
	    },
	    touchEnd: function touchEnd(swiper, e) {
	      if (!swiper.zoom.enabled) return;
	      swiper.zoom.onTouchEnd(e);
	    },
	    doubleTap: function doubleTap(swiper, e) {
	      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	        swiper.zoom.toggle(e);
	      }
	    },
	    transitionEnd: function transitionEnd(swiper) {
	      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	        swiper.zoom.onTransitionEnd();
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
	        swiper.zoom.onTransitionEnd();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Lazy = {
	  loadInSlide: function loadInSlide(index, loadInDuplicate) {
	    if (loadInDuplicate === void 0) {
	      loadInDuplicate = true;
	    }
	
	    var swiper = this;
	    var params = swiper.params.lazy;
	    if (typeof index === 'undefined') return;
	    if (swiper.slides.length === 0) return;
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	    var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
	    var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
	
	    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	      $images.push($slideEl[0]);
	    }
	
	    if ($images.length === 0) return;
	    $images.each(function (imageEl) {
	      var $imageEl = (0, _dom.default)(imageEl);
	      $imageEl.addClass(params.loadingClass);
	      var background = $imageEl.attr('data-background');
	      var src = $imageEl.attr('data-src');
	      var srcset = $imageEl.attr('data-srcset');
	      var sizes = $imageEl.attr('data-sizes');
	      var $pictureEl = $imageEl.parent('picture');
	      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
	        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
	
	        if (background) {
	          $imageEl.css('background-image', "url(\"" + background + "\")");
	          $imageEl.removeAttr('data-background');
	        } else {
	          if (srcset) {
	            $imageEl.attr('srcset', srcset);
	            $imageEl.removeAttr('data-srcset');
	          }
	
	          if (sizes) {
	            $imageEl.attr('sizes', sizes);
	            $imageEl.removeAttr('data-sizes');
	          }
	
	          if ($pictureEl.length) {
	            $pictureEl.children('source').each(function (sourceEl) {
	              var $source = (0, _dom.default)(sourceEl);
	
	              if ($source.attr('data-srcset')) {
	                $source.attr('srcset', $source.attr('data-srcset'));
	                $source.removeAttr('data-srcset');
	              }
	            });
	          }
	
	          if (src) {
	            $imageEl.attr('src', src);
	            $imageEl.removeAttr('data-src');
	          }
	        }
	
	        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	        $slideEl.find("." + params.preloaderClass).remove();
	
	        if (swiper.params.loop && loadInDuplicate) {
	          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	
	          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	            var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
	            swiper.lazy.loadInSlide(originalSlide.index(), false);
	          } else {
	            var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
	            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	          }
	        }
	
	        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	
	        if (swiper.params.autoHeight) {
	          swiper.updateAutoHeight();
	        }
	      });
	      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	    });
	  },
	  load: function load() {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl,
	        swiperParams = swiper.params,
	        slides = swiper.slides,
	        activeIndex = swiper.activeIndex;
	    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	    var params = swiperParams.lazy;
	    var slidesPerView = swiperParams.slidesPerView;
	
	    if (slidesPerView === 'auto') {
	      slidesPerView = 0;
	    }
	
	    function slideExist(index) {
	      if (isVirtual) {
	        if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
	          return true;
	        }
	      } else if (slides[index]) return true;
	
	      return false;
	    }
	
	    function slideIndex(slideEl) {
	      if (isVirtual) {
	        return (0, _dom.default)(slideEl).attr('data-swiper-slide-index');
	      }
	
	      return (0, _dom.default)(slideEl).index();
	    }
	
	    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
	
	    if (swiper.params.watchSlidesVisibility) {
	      $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (slideEl) {
	        var index = isVirtual ? (0, _dom.default)(slideEl).attr('data-swiper-slide-index') : (0, _dom.default)(slideEl).index();
	        swiper.lazy.loadInSlide(index);
	      });
	    } else if (slidesPerView > 1) {
	      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	        if (slideExist(i)) swiper.lazy.loadInSlide(i);
	      }
	    } else {
	      swiper.lazy.loadInSlide(activeIndex);
	    }
	
	    if (params.loadPrevNext) {
	      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
	        var amount = params.loadPrevNextAmount;
	        var spv = slidesPerView;
	        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
	
	        for (var _i = activeIndex + slidesPerView; _i < maxIndex; _i += 1) {
	          if (slideExist(_i)) swiper.lazy.loadInSlide(_i);
	        } // Prev Slides
	
	
	        for (var _i2 = minIndex; _i2 < activeIndex; _i2 += 1) {
	          if (slideExist(_i2)) swiper.lazy.loadInSlide(_i2);
	        }
	      } else {
	        var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
	        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
	        var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
	        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
	      }
	    }
	  }
	};
	var _default = {
	  name: 'lazy',
	  params: {
	    lazy: {
	      enabled: false,
	      loadPrevNext: false,
	      loadPrevNextAmount: 1,
	      loadOnTransitionStart: false,
	      elementClass: 'swiper-lazy',
	      loadingClass: 'swiper-lazy-loading',
	      loadedClass: 'swiper-lazy-loaded',
	      preloaderClass: 'swiper-lazy-preloader'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      lazy: _extends({
	        initialImageLoaded: false
	      }, Lazy)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	        swiper.params.preloadImages = false;
	      }
	    },
	    init: function init(swiper) {
	      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	        swiper.lazy.load();
	      }
	    },
	    scroll: function scroll(swiper) {
	      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	        swiper.lazy.load();
	      }
	    },
	    resize: function resize(swiper) {
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    scrollbarDragMove: function scrollbarDragMove(swiper) {
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    transitionStart: function transitionStart(swiper) {
	      if (swiper.params.lazy.enabled) {
	        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
	          swiper.lazy.load();
	        }
	      }
	    },
	    transitionEnd: function transitionEnd(swiper) {
	      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	        swiper.lazy.load();
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      if (swiper.params.lazy.enabled && swiper.params.cssMode) {
	        swiper.lazy.load();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(40);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Controller = {
	  LinearSpline: function LinearSpline(x, y) {
	    var binarySearch = function search() {
	      var maxIndex;
	      var minIndex;
	      var guess;
	      return function (array, val) {
	        minIndex = -1;
	        maxIndex = array.length;
	
	        while (maxIndex - minIndex > 1) {
	          guess = maxIndex + minIndex >> 1;
	
	          if (array[guess] <= val) {
	            minIndex = guess;
	          } else {
	            maxIndex = guess;
	          }
	        }
	
	        return maxIndex;
	      };
	    }();
	
	    this.x = x;
	    this.y = y;
	    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
	    // (x1,y1) is the known point before given value,
	    // (x3,y3) is the known point after given value.
	
	    var i1;
	    var i3;
	
	    this.interpolate = function interpolate(x2) {
	      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	
	      i3 = binarySearch(this.x, x2);
	      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
	      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	
	      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
	    };
	
	    return this;
	  },
	  // xxx: for now i will just save one spline function to to
	  getInterpolateFunction: function getInterpolateFunction(c) {
	    var swiper = this;
	
	    if (!swiper.controller.spline) {
	      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	    }
	  },
	  setTranslate: function setTranslate(_setTranslate, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var multiplier;
	    var controlledTranslate;
	    var Swiper = swiper.constructor;
	
	    function setControlledTranslate(c) {
	      // this will create an Interpolate function based on the snapGrids
	      // x is the Grid of the scrolled scroller and y will be the controlled scroller
	      // it makes sense to create this only once and recall it for the interpolation
	      // the function does a lot of value caching for performance
	      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
	
	      if (swiper.params.controller.by === 'slide') {
	        swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	        // but it did not work out
	
	        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	      }
	
	      if (!controlledTranslate || swiper.params.controller.by === 'container') {
	        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
	      }
	
	      if (swiper.params.controller.inverse) {
	        controlledTranslate = c.maxTranslate() - controlledTranslate;
	      }
	
	      c.updateProgress(controlledTranslate);
	      c.setTranslate(controlledTranslate, swiper);
	      c.updateActiveIndex();
	      c.updateSlidesClasses();
	    }
	
	    if (Array.isArray(controlled)) {
	      for (var i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTranslate(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTranslate(controlled);
	    }
	  },
	  setTransition: function setTransition(duration, byController) {
	    var swiper = this;
	    var Swiper = swiper.constructor;
	    var controlled = swiper.controller.control;
	    var i;
	
	    function setControlledTransition(c) {
	      c.setTransition(duration, swiper);
	
	      if (duration !== 0) {
	        c.transitionStart();
	
	        if (c.params.autoHeight) {
	          (0, _utils.nextTick)(function () {
	            c.updateAutoHeight();
	          });
	        }
	
	        c.$wrapperEl.transitionEnd(function () {
	          if (!controlled) return;
	
	          if (c.params.loop && swiper.params.controller.by === 'slide') {
	            c.loopFix();
	          }
	
	          c.transitionEnd();
	        });
	      }
	    }
	
	    if (Array.isArray(controlled)) {
	      for (i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTransition(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTransition(controlled);
	    }
	  }
	};
	var _default = {
	  name: 'controller',
	  params: {
	    controller: {
	      control: undefined,
	      inverse: false,
	      by: 'slide' // or 'container'
	
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      controller: _extends({
	        control: swiper.params.controller.control
	      }, Controller)
	    });
	  },
	  on: {
	    update: function update(swiper) {
	      if (!swiper.controller.control) return;
	
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    resize: function resize(swiper) {
	      if (!swiper.controller.control) return;
	
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      if (!swiper.controller.control) return;
	
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    setTranslate: function setTranslate(swiper, translate, byController) {
	      if (!swiper.controller.control) return;
	      swiper.controller.setTranslate(translate, byController);
	    },
	    setTransition: function setTransition(swiper, duration, byController) {
	      if (!swiper.controller.control) return;
	      swiper.controller.setTransition(duration, byController);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var A11y = {
	  getRandomNumber: function getRandomNumber(size) {
	    if (size === void 0) {
	      size = 16;
	    }
	
	    var randomChar = function randomChar() {
	      return Math.round(16 * Math.random()).toString(16);
	    };
	
	    return 'x'.repeat(size).replace(/x/g, randomChar);
	  },
	  makeElFocusable: function makeElFocusable($el) {
	    $el.attr('tabIndex', '0');
	    return $el;
	  },
	  makeElNotFocusable: function makeElNotFocusable($el) {
	    $el.attr('tabIndex', '-1');
	    return $el;
	  },
	  addElRole: function addElRole($el, role) {
	    $el.attr('role', role);
	    return $el;
	  },
	  addElRoleDescription: function addElRoleDescription($el, description) {
	    $el.attr('aria-role-description', description);
	    return $el;
	  },
	  addElControls: function addElControls($el, controls) {
	    $el.attr('aria-controls', controls);
	    return $el;
	  },
	  addElLabel: function addElLabel($el, label) {
	    $el.attr('aria-label', label);
	    return $el;
	  },
	  addElId: function addElId($el, id) {
	    $el.attr('id', id);
	    return $el;
	  },
	  addElLive: function addElLive($el, live) {
	    $el.attr('aria-live', live);
	    return $el;
	  },
	  disableEl: function disableEl($el) {
	    $el.attr('aria-disabled', true);
	    return $el;
	  },
	  enableEl: function enableEl($el) {
	    $el.attr('aria-disabled', false);
	    return $el;
	  },
	  onEnterKey: function onEnterKey(e) {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (e.keyCode !== 13) return;
	    var $targetEl = (0, _dom.default)(e.target);
	
	    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	      if (!(swiper.isEnd && !swiper.params.loop)) {
	        swiper.slideNext();
	      }
	
	      if (swiper.isEnd) {
	        swiper.a11y.notify(params.lastSlideMessage);
	      } else {
	        swiper.a11y.notify(params.nextSlideMessage);
	      }
	    }
	
	    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	      if (!(swiper.isBeginning && !swiper.params.loop)) {
	        swiper.slidePrev();
	      }
	
	      if (swiper.isBeginning) {
	        swiper.a11y.notify(params.firstSlideMessage);
	      } else {
	        swiper.a11y.notify(params.prevSlideMessage);
	      }
	    }
	
	    if (swiper.pagination && $targetEl.is("." + swiper.params.pagination.bulletClass)) {
	      $targetEl[0].click();
	    }
	  },
	  notify: function notify(message) {
	    var swiper = this;
	    var notification = swiper.a11y.liveRegion;
	    if (notification.length === 0) return;
	    notification.html('');
	    notification.html(message);
	  },
	  updateNavigation: function updateNavigation() {
	    var swiper = this;
	    if (swiper.params.loop || !swiper.navigation) return;
	    var _swiper$navigation = swiper.navigation,
	        $nextEl = _swiper$navigation.$nextEl,
	        $prevEl = _swiper$navigation.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        swiper.a11y.disableEl($prevEl);
	        swiper.a11y.makeElNotFocusable($prevEl);
	      } else {
	        swiper.a11y.enableEl($prevEl);
	        swiper.a11y.makeElFocusable($prevEl);
	      }
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        swiper.a11y.disableEl($nextEl);
	        swiper.a11y.makeElNotFocusable($nextEl);
	      } else {
	        swiper.a11y.enableEl($nextEl);
	        swiper.a11y.makeElFocusable($nextEl);
	      }
	    }
	  },
	  updatePagination: function updatePagination() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.bullets.each(function (bulletEl) {
	        var $bulletEl = (0, _dom.default)(bulletEl);
	        swiper.a11y.makeElFocusable($bulletEl);
	
	        if (!swiper.params.pagination.renderBullet) {
	          swiper.a11y.addElRole($bulletEl, 'button');
	          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
	        }
	      });
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    swiper.$el.append(swiper.a11y.liveRegion); // Container
	
	    var $containerEl = swiper.$el;
	
	    if (params.containerRoleDescriptionMessage) {
	      swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
	    }
	
	    if (params.containerMessage) {
	      swiper.a11y.addElLabel($containerEl, params.containerMessage);
	    } // Wrapper
	
	
	    var $wrapperEl = swiper.$wrapperEl;
	    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
	    var live;
	    swiper.a11y.addElId($wrapperEl, wrapperId);
	
	    if (swiper.params.autoplay && swiper.params.autoplay.enabled) {
	      live = 'off';
	    } else {
	      live = 'polite';
	    }
	
	    swiper.a11y.addElLive($wrapperEl, live); // Slide
	
	    if (params.itemRoleDescriptionMessage) {
	      swiper.a11y.addElRoleDescription((0, _dom.default)(swiper.slides), params.itemRoleDescriptionMessage);
	    }
	
	    swiper.a11y.addElRole((0, _dom.default)(swiper.slides), 'group');
	    swiper.slides.each(function (slideEl) {
	      var $slideEl = (0, _dom.default)(slideEl);
	      swiper.a11y.addElLabel($slideEl, $slideEl.index() + 1 + " / " + swiper.slides.length);
	    }); // Navigation
	
	    var $nextEl;
	    var $prevEl;
	
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	
	    if ($nextEl && $nextEl.length) {
	      swiper.a11y.makeElFocusable($nextEl);
	
	      if ($nextEl[0].tagName !== 'BUTTON') {
	        swiper.a11y.addElRole($nextEl, 'button');
	        $nextEl.on('keydown', swiper.a11y.onEnterKey);
	      }
	
	      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	      swiper.a11y.addElControls($nextEl, wrapperId);
	    }
	
	    if ($prevEl && $prevEl.length) {
	      swiper.a11y.makeElFocusable($prevEl);
	
	      if ($prevEl[0].tagName !== 'BUTTON') {
	        swiper.a11y.addElRole($prevEl, 'button');
	        $prevEl.on('keydown', swiper.a11y.onEnterKey);
	      }
	
	      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	      swiper.a11y.addElControls($prevEl, wrapperId);
	    } // Pagination
	
	
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.on('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
	    var $nextEl;
	    var $prevEl;
	
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	
	    if ($nextEl) {
	      $nextEl.off('keydown', swiper.a11y.onEnterKey);
	    }
	
	    if ($prevEl) {
	      $prevEl.off('keydown', swiper.a11y.onEnterKey);
	    } // Pagination
	
	
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.off('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
	    }
	  }
	};
	var _default = {
	  name: 'a11y',
	  params: {
	    a11y: {
	      enabled: true,
	      notificationClass: 'swiper-notification',
	      prevSlideMessage: 'Previous slide',
	      nextSlideMessage: 'Next slide',
	      firstSlideMessage: 'This is the first slide',
	      lastSlideMessage: 'This is the last slide',
	      paginationBulletMessage: 'Go to slide {{index}}',
	      containerMessage: null,
	      containerRoleDescriptionMessage: null,
	      itemRoleDescriptionMessage: null
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      a11y: _extends(_extends({}, A11y), {}, {
	        liveRegion: (0, _dom.default)("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
	      })
	    });
	  },
	  on: {
	    afterInit: function afterInit(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.init();
	      swiper.a11y.updateNavigation();
	    },
	    toEdge: function toEdge(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updateNavigation();
	    },
	    fromEdge: function fromEdge(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updateNavigation();
	    },
	    paginationUpdate: function paginationUpdate(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updatePagination();
	    },
	    destroy: function destroy(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.destroy();
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _utils = __webpack_require__(40);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var History = {
	  init: function init() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    if (!swiper.params.history) return;
	
	    if (!window.history || !window.history.pushState) {
	      swiper.params.history.enabled = false;
	      swiper.params.hashNavigation.enabled = true;
	      return;
	    }
	
	    var history = swiper.history;
	    history.initialized = true;
	    history.paths = History.getPathValues(swiper.params.url);
	    if (!history.paths.key && !history.paths.value) return;
	    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
	
	    if (!swiper.params.history.replaceState) {
	      window.addEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	
	    if (!swiper.params.history.replaceState) {
	      window.removeEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  setHistoryPopState: function setHistoryPopState() {
	    var swiper = this;
	    swiper.history.paths = History.getPathValues(swiper.params.url);
	    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	  },
	  getPathValues: function getPathValues(urlOverride) {
	    var window = (0, _ssrWindow.getWindow)();
	    var location;
	
	    if (urlOverride) {
	      location = new URL(urlOverride);
	    } else {
	      location = window.location;
	    }
	
	    var pathArray = location.pathname.slice(1).split('/').filter(function (part) {
	      return part !== '';
	    });
	    var total = pathArray.length;
	    var key = pathArray[total - 2];
	    var value = pathArray[total - 1];
	    return {
	      key: key,
	      value: value
	    };
	  },
	  setHistory: function setHistory(key, index) {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
	    var location;
	
	    if (swiper.params.url) {
	      location = new URL(swiper.params.url);
	    } else {
	      location = window.location;
	    }
	
	    var slide = swiper.slides.eq(index);
	    var value = History.slugify(slide.attr('data-history'));
	
	    if (!location.pathname.includes(key)) {
	      value = key + "/" + value;
	    }
	
	    var currentState = window.history.state;
	
	    if (currentState && currentState.value === value) {
	      return;
	    }
	
	    if (swiper.params.history.replaceState) {
	      window.history.replaceState({
	        value: value
	      }, null, value);
	    } else {
	      window.history.pushState({
	        value: value
	      }, null, value);
	    }
	  },
	  slugify: function slugify(text) {
	    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	  },
	  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
	    var swiper = this;
	
	    if (value) {
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHistory = History.slugify(slide.attr('data-history'));
	
	        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, runCallbacks);
	        }
	      }
	    } else {
	      swiper.slideTo(0, speed, runCallbacks);
	    }
	  }
	};
	var _default = {
	  name: 'history',
	  params: {
	    history: {
	      enabled: false,
	      replaceState: false,
	      key: 'slides'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      history: _extends({}, History)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.history.enabled) {
	        swiper.history.init();
	      }
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.params.history.enabled) {
	        swiper.history.destroy();
	      }
	    },
	    transitionEnd: function transitionEnd(swiper) {
	      if (swiper.history.initialized) {
	        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      if (swiper.history.initialized && swiper.params.cssMode) {
	        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var HashNavigation = {
	  onHashCange: function onHashCange() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    swiper.emit('hashChange');
	    var newHash = document.location.hash.replace('#', '');
	    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
	
	    if (newHash !== activeSlideHash) {
	      var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
	      if (typeof newIndex === 'undefined') return;
	      swiper.slideTo(newIndex);
	    }
	  },
	  setHash: function setHash() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    var document = (0, _ssrWindow.getDocument)();
	    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
	
	    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
	      window.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
	      swiper.emit('hashSet');
	    } else {
	      var slide = swiper.slides.eq(swiper.activeIndex);
	      var hash = slide.attr('data-hash') || slide.attr('data-history');
	      document.location.hash = hash || '';
	      swiper.emit('hashSet');
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    var window = (0, _ssrWindow.getWindow)();
	    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
	    swiper.hashNavigation.initialized = true;
	    var hash = document.location.hash.replace('#', '');
	
	    if (hash) {
	      var speed = 0;
	
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	
	        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
	        }
	      }
	    }
	
	    if (swiper.params.hashNavigation.watchState) {
	      (0, _dom.default)(window).on('hashchange', swiper.hashNavigation.onHashCange);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	
	    if (swiper.params.hashNavigation.watchState) {
	      (0, _dom.default)(window).off('hashchange', swiper.hashNavigation.onHashCange);
	    }
	  }
	};
	var _default = {
	  name: 'hash-navigation',
	  params: {
	    hashNavigation: {
	      enabled: false,
	      replaceState: false,
	      watchState: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      hashNavigation: _extends({
	        initialized: false
	      }, HashNavigation)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.init();
	      }
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.destroy();
	      }
	    },
	    transitionEnd: function transitionEnd(swiper) {
	      if (swiper.hashNavigation.initialized) {
	        swiper.hashNavigation.setHash();
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
	        swiper.hashNavigation.setHash();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(39);
	
	var _utils = __webpack_require__(40);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Autoplay = {
	  run: function run() {
	    var swiper = this;
	    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	    var delay = swiper.params.autoplay.delay;
	
	    if ($activeSlideEl.attr('data-swiper-autoplay')) {
	      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	    }
	
	    clearTimeout(swiper.autoplay.timeout);
	    swiper.autoplay.timeout = (0, _utils.nextTick)(function () {
	      var autoplayResult;
	
	      if (swiper.params.autoplay.reverseDirection) {
	        if (swiper.params.loop) {
	          swiper.loopFix();
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.isBeginning) {
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else {
	          swiper.autoplay.stop();
	        }
	      } else if (swiper.params.loop) {
	        swiper.loopFix();
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.isEnd) {
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.params.autoplay.stopOnLastSlide) {
	        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else {
	        swiper.autoplay.stop();
	      }
	
	      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
	        swiper.autoplay.run();
	      }
	    }, delay);
	  },
	  start: function start() {
	    var swiper = this;
	    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
	    if (swiper.autoplay.running) return false;
	    swiper.autoplay.running = true;
	    swiper.emit('autoplayStart');
	    swiper.autoplay.run();
	    return true;
	  },
	  stop: function stop() {
	    var swiper = this;
	    if (!swiper.autoplay.running) return false;
	    if (typeof swiper.autoplay.timeout === 'undefined') return false;
	
	    if (swiper.autoplay.timeout) {
	      clearTimeout(swiper.autoplay.timeout);
	      swiper.autoplay.timeout = undefined;
	    }
	
	    swiper.autoplay.running = false;
	    swiper.emit('autoplayStop');
	    return true;
	  },
	  pause: function pause(speed) {
	    var swiper = this;
	    if (!swiper.autoplay.running) return;
	    if (swiper.autoplay.paused) return;
	    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
	    swiper.autoplay.paused = true;
	
	    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	      swiper.autoplay.paused = false;
	      swiper.autoplay.run();
	    } else {
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	    }
	  },
	  onVisibilityChange: function onVisibilityChange() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	
	    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
	      swiper.autoplay.pause();
	    }
	
	    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
	      swiper.autoplay.run();
	      swiper.autoplay.paused = false;
	    }
	  },
	  onTransitionEnd: function onTransitionEnd(e) {
	    var swiper = this;
	    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
	    if (e.target !== swiper.$wrapperEl[0]) return;
	    swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	    swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	    swiper.autoplay.paused = false;
	
	    if (!swiper.autoplay.running) {
	      swiper.autoplay.stop();
	    } else {
	      swiper.autoplay.run();
	    }
	  }
	};
	var _default = {
	  name: 'autoplay',
	  params: {
	    autoplay: {
	      enabled: false,
	      delay: 3000,
	      waitForTransition: true,
	      disableOnInteraction: true,
	      stopOnLastSlide: false,
	      reverseDirection: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      autoplay: _extends(_extends({}, Autoplay), {}, {
	        running: false,
	        paused: false
	      })
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.autoplay.enabled) {
	        swiper.autoplay.start();
	        var document = (0, _ssrWindow.getDocument)();
	        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
	      }
	    },
	    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
	      if (swiper.autoplay.running) {
	        if (internal || !swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.pause(speed);
	        } else {
	          swiper.autoplay.stop();
	        }
	      }
	    },
	    sliderFirstMove: function sliderFirstMove(swiper) {
	      if (swiper.autoplay.running) {
	        if (swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.stop();
	        } else {
	          swiper.autoplay.pause();
	        }
	      }
	    },
	    touchEnd: function touchEnd(swiper) {
	      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
	        swiper.autoplay.run();
	      }
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.autoplay.running) {
	        swiper.autoplay.stop();
	      }
	
	      var document = (0, _ssrWindow.getDocument)();
	      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(40);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Fade = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = swiper.slides.eq(i);
	      var offset = $slideEl[0].swiperSlideOffset;
	      var tx = -offset;
	      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
	      var ty = 0;
	
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	      }
	
	      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	      $slideEl.css({
	        opacity: slideOpacity
	      }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides,
	        $wrapperEl = swiper.$wrapperEl;
	    slides.transition(duration);
	
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      slides.transitionEnd(function () {
	        if (eventTriggered) return;
	        if (!swiper || swiper.destroyed) return;
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  }
	};
	var _default = {
	  name: 'effect-fade',
	  params: {
	    fadeEffect: {
	      crossFade: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      fadeEffect: _extends({}, Fade)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'fade') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "fade");
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'fade') return;
	      swiper.fadeEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'fade') return;
	      swiper.fadeEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Cube = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el,
	        $wrapperEl = swiper.$wrapperEl,
	        slides = swiper.slides,
	        swiperWidth = swiper.width,
	        swiperHeight = swiper.height,
	        rtl = swiper.rtlTranslate,
	        swiperSize = swiper.size,
	        browser = swiper.browser;
	    var params = swiper.params.cubeEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	    var wrapperRotate = 0;
	    var $cubeShadowEl;
	
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = (0, _dom.default)('<div class="swiper-cube-shadow"></div>');
	          $wrapperEl.append($cubeShadowEl);
	        }
	
	        $cubeShadowEl.css({
	          height: swiperWidth + "px"
	        });
	      } else {
	        $cubeShadowEl = $el.find('.swiper-cube-shadow');
	
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = (0, _dom.default)('<div class="swiper-cube-shadow"></div>');
	          $el.append($cubeShadowEl);
	        }
	      }
	    }
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideIndex = i;
	
	      if (isVirtual) {
	        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	      }
	
	      var slideAngle = slideIndex * 90;
	      var round = Math.floor(slideAngle / 360);
	
	      if (rtl) {
	        slideAngle = -slideAngle;
	        round = Math.floor(-slideAngle / 360);
	      }
	
	      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      var tx = 0;
	      var ty = 0;
	      var tz = 0;
	
	      if (slideIndex % 4 === 0) {
	        tx = -round * 4 * swiperSize;
	        tz = 0;
	      } else if ((slideIndex - 1) % 4 === 0) {
	        tx = 0;
	        tz = -round * 4 * swiperSize;
	      } else if ((slideIndex - 2) % 4 === 0) {
	        tx = swiperSize + round * 4 * swiperSize;
	        tz = swiperSize;
	      } else if ((slideIndex - 3) % 4 === 0) {
	        tx = -swiperSize;
	        tz = 3 * swiperSize + swiperSize * 4 * round;
	      }
	
	      if (rtl) {
	        tx = -tx;
	      }
	
	      if (!isHorizontal) {
	        ty = tx;
	        tx = 0;
	      }
	
	      var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	
	      if (progress <= 1 && progress > -1) {
	        wrapperRotate = slideIndex * 90 + progress * 90;
	        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
	      }
	
	      $slideEl.transform(transform);
	
	      if (params.slideShadows) {
	        // Set shadows
	        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	
	        if (shadowBefore.length === 0) {
	          shadowBefore = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
	          $slideEl.append(shadowBefore);
	        }
	
	        if (shadowAfter.length === 0) {
	          shadowAfter = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
	          $slideEl.append(shadowAfter);
	        }
	
	        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	      }
	    }
	
	    $wrapperEl.css({
	      '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
	      '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
	      '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
	      'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
	    });
	
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
	      } else {
	        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
	        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
	        var scale1 = params.shadowScale;
	        var scale2 = params.shadowScale / multiplier;
	        var offset = params.shadowOffset;
	        $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
	      }
	    }
	
	    var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
	    $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var $el = swiper.$el,
	        slides = swiper.slides;
	    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	
	    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	      $el.find('.swiper-cube-shadow').transition(duration);
	    }
	  }
	};
	var _default = {
	  name: 'effect-cube',
	  params: {
	    cubeEffect: {
	      slideShadows: true,
	      shadow: true,
	      shadowOffset: 20,
	      shadowScale: 0.94
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      cubeEffect: _extends({}, Cube)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'cube') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "cube");
	      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        resistanceRatio: 0,
	        spaceBetween: 0,
	        centeredSlides: false,
	        virtualTranslate: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'cube') return;
	      swiper.cubeEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'cube') return;
	      swiper.cubeEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Flip = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides,
	        rtl = swiper.rtlTranslate;
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var progress = $slideEl[0].progress;
	
	      if (swiper.params.flipEffect.limitRotation) {
	        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      }
	
	      var offset = $slideEl[0].swiperSlideOffset;
	      var rotate = -180 * progress;
	      var rotateY = rotate;
	      var rotateX = 0;
	      var tx = -offset;
	      var ty = 0;
	
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	        rotateX = -rotateY;
	        rotateY = 0;
	      } else if (rtl) {
	        rotateY = -rotateY;
	      }
	
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
	
	      if (swiper.params.flipEffect.slideShadows) {
	        // Set shadows
	        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	
	        if (shadowBefore.length === 0) {
	          shadowBefore = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
	          $slideEl.append(shadowBefore);
	        }
	
	        if (shadowAfter.length === 0) {
	          shadowAfter = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
	          $slideEl.append(shadowAfter);
	        }
	
	        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	      }
	
	      $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides,
	        activeIndex = swiper.activeIndex,
	        $wrapperEl = swiper.$wrapperEl;
	    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false; // eslint-disable-next-line
	
	      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	        if (eventTriggered) return;
	        if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  }
	};
	var _default = {
	  name: 'effect-flip',
	  params: {
	    flipEffect: {
	      slideShadows: true,
	      limitRotation: true
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      flipEffect: _extends({}, Flip)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'flip') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "flip");
	      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'flip') return;
	      swiper.flipEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'flip') return;
	      swiper.flipEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Coverflow = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var swiperWidth = swiper.width,
	        swiperHeight = swiper.height,
	        slides = swiper.slides,
	        slidesSizesGrid = swiper.slidesSizesGrid;
	    var params = swiper.params.coverflowEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var transform = swiper.translate;
	    var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
	    var rotate = isHorizontal ? params.rotate : -params.rotate;
	    var translate = params.depth; // Each slide offset from center
	
	    for (var i = 0, length = slides.length; i < length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideSize = slidesSizesGrid[i];
	      var slideOffset = $slideEl[0].swiperSlideOffset;
	      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
	      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
	
	      var translateZ = -translate * Math.abs(offsetMultiplier);
	      var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
	
	      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
	        stretch = parseFloat(params.stretch) / 100 * slideSize;
	      }
	
	      var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
	      var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
	      var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
	
	      if (Math.abs(translateX) < 0.001) translateX = 0;
	      if (Math.abs(translateY) < 0.001) translateY = 0;
	      if (Math.abs(translateZ) < 0.001) translateZ = 0;
	      if (Math.abs(rotateY) < 0.001) rotateY = 0;
	      if (Math.abs(rotateX) < 0.001) rotateX = 0;
	      if (Math.abs(scale) < 0.001) scale = 0;
	      var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
	      $slideEl.transform(slideTransform);
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	
	      if (params.slideShadows) {
	        // Set shadows
	        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	
	        if ($shadowBeforeEl.length === 0) {
	          $shadowBeforeEl = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
	          $slideEl.append($shadowBeforeEl);
	        }
	
	        if ($shadowAfterEl.length === 0) {
	          $shadowAfterEl = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
	          $slideEl.append($shadowAfterEl);
	        }
	
	        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
	        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
	      }
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	  }
	};
	var _default = {
	  name: 'effect-coverflow',
	  params: {
	    coverflowEffect: {
	      rotate: 50,
	      stretch: 0,
	      depth: 100,
	      scale: 1,
	      modifier: 1,
	      slideShadows: true
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      coverflowEffect: _extends({}, Coverflow)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'coverflow') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
	      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
	      swiper.params.watchSlidesProgress = true;
	      swiper.originalParams.watchSlidesProgress = true;
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'coverflow') return;
	      swiper.coverflowEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'coverflow') return;
	      swiper.coverflowEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(40);
	
	var _dom = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Thumbs = {
	  init: function init() {
	    var swiper = this;
	    var thumbsParams = swiper.params.thumbs;
	    if (swiper.thumbs.initialized) return false;
	    swiper.thumbs.initialized = true;
	    var SwiperClass = swiper.constructor;
	
	    if (thumbsParams.swiper instanceof SwiperClass) {
	      swiper.thumbs.swiper = thumbsParams.swiper;
	      (0, _utils.extend)(swiper.thumbs.swiper.originalParams, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	      (0, _utils.extend)(swiper.thumbs.swiper.params, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	    } else if ((0, _utils.isObject)(thumbsParams.swiper)) {
	      swiper.thumbs.swiper = new SwiperClass((0, _utils.extend)({}, thumbsParams.swiper, {
	        watchSlidesVisibility: true,
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      }));
	      swiper.thumbs.swiperCreated = true;
	    }
	
	    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
	    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
	    return true;
	  },
	  onThumbClick: function onThumbClick() {
	    var swiper = this;
	    var thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper) return;
	    var clickedIndex = thumbsSwiper.clickedIndex;
	    var clickedSlide = thumbsSwiper.clickedSlide;
	    if (clickedSlide && (0, _dom.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
	    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
	    var slideToIndex;
	
	    if (thumbsSwiper.params.loop) {
	      slideToIndex = parseInt((0, _dom.default)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    } else {
	      slideToIndex = clickedIndex;
	    }
	
	    if (swiper.params.loop) {
	      var currentIndex = swiper.activeIndex;
	
	      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
	        swiper.loopFix(); // eslint-disable-next-line
	
	        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	        currentIndex = swiper.activeIndex;
	      }
	
	      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
	      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
	      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
	    }
	
	    swiper.slideTo(slideToIndex);
	  },
	  update: function update(initial) {
	    var swiper = this;
	    var thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper) return;
	    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
	    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
	    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
	
	    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
	      var currentThumbsIndex = thumbsSwiper.activeIndex;
	      var newThumbsIndex;
	      var direction;
	
	      if (thumbsSwiper.params.loop) {
	        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
	          thumbsSwiper.loopFix(); // eslint-disable-next-line
	
	          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
	          currentThumbsIndex = thumbsSwiper.activeIndex;
	        } // Find actual thumbs index to slide to
	
	
	        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
	        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
	        if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
	        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
	      } else {
	        newThumbsIndex = swiper.realIndex;
	        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
	      }
	
	      if (useOffset) {
	        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
	      }
	
	      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
	        if (thumbsSwiper.params.centeredSlides) {
	          if (newThumbsIndex > currentThumbsIndex) {
	            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
	          } else {
	            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
	          }
	        } else if (newThumbsIndex > currentThumbsIndex) {
	          newThumbsIndex = newThumbsIndex - slidesPerView + 1;
	        }
	
	        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
	      }
	    } // Activate thumbs
	
	
	    var thumbsToActivate = 1;
	    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
	
	    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
	      thumbsToActivate = swiper.params.slidesPerView;
	    }
	
	    if (!swiper.params.thumbs.multipleActiveThumbs) {
	      thumbsToActivate = 1;
	    }
	
	    thumbsToActivate = Math.floor(thumbsToActivate);
	    thumbsSwiper.slides.removeClass(thumbActiveClass);
	
	    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
	      for (var i = 0; i < thumbsToActivate; i += 1) {
	        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
	      }
	    } else {
	      for (var _i = 0; _i < thumbsToActivate; _i += 1) {
	        thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
	      }
	    }
	  }
	};
	var _default = {
	  name: 'thumbs',
	  params: {
	    thumbs: {
	      swiper: null,
	      multipleActiveThumbs: true,
	      autoScrollOffset: 0,
	      slideThumbActiveClass: 'swiper-slide-thumb-active',
	      thumbsContainerClass: 'swiper-container-thumbs'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      thumbs: _extends({
	        swiper: null,
	        initialized: false
	      }, Thumbs)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      var thumbs = swiper.params.thumbs;
	      if (!thumbs || !thumbs.swiper) return;
	      swiper.thumbs.init();
	      swiper.thumbs.update(true);
	    },
	    slideChange: function slideChange(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    update: function update(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    resize: function resize(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) return;
	      thumbsSwiper.setTransition(duration);
	    },
	    beforeDestroy: function beforeDestroy(swiper) {
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) return;
	
	      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
	        thumbsSwiper.destroy();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _noframeworkWaypoints = __webpack_require__(127);
	
	var _noframeworkWaypoints2 = _interopRequireDefault(_noframeworkWaypoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A fade in component.
	 * @author Dayne Coulson-Hoffacker
	 */
	var InView =
	/**
	 * Constructs a new section.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 * @param {Hurdler} options.hurdler - Hurdler instance.
	 */
	function InView(options) {
	  (0, _classCallCheck3.default)(this, InView);
	
	  this.element = options.element;
	  this.globalHeader = document.querySelector('[data-component="global-header"]');
	  var self = this;
	  // new Waypoint({
	  //   element: self.element,
	  //   handler: () => {
	  //     if (self.element.classList.contains('green-bg')) {
	  //       self.globalHeader.classList.toggle('dark')
	  //     }
	  //     if (self.element.classList.contains('cream')) {
	  //       self.globalHeader.classList.toggle('dark')
	  //     }
	  //   },
	  //   offset: '10%'
	  // })
	  new _noframeworkWaypoints2.default({
	    element: self.element,
	    handler: function handler() {
	      self.element.classList.toggle('visible');
	      // if (self.element.classList.contains('main')) {
	      //   self.globalHeader.classList.toggle('dark')
	      // }
	    },
	    offset: '10%'
	  });
	};
	
	exports.default = InView;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	/*!
	Waypoints - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	(function() {
	  'use strict'
	
	  var keyCounter = 0
	  var allWaypoints = {}
	
	  /* http://imakewebthings.com/waypoints/api/waypoint */
	  function Waypoint(options) {
	    if (!options) {
	      throw new Error('No options passed to Waypoint constructor')
	    }
	    if (!options.element) {
	      throw new Error('No element option passed to Waypoint constructor')
	    }
	    if (!options.handler) {
	      throw new Error('No handler option passed to Waypoint constructor')
	    }
	
	    this.key = 'waypoint-' + keyCounter
	    this.options = Waypoint.Adapter.extend({}, Waypoint.defaults, options)
	    this.element = this.options.element
	    this.adapter = new Waypoint.Adapter(this.element)
	    this.callback = options.handler
	    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
	    this.enabled = this.options.enabled
	    this.triggerPoint = null
	    this.group = Waypoint.Group.findOrCreate({
	      name: this.options.group,
	      axis: this.axis
	    })
	    this.context = Waypoint.Context.findOrCreateByElement(this.options.context)
	
	    if (Waypoint.offsetAliases[this.options.offset]) {
	      this.options.offset = Waypoint.offsetAliases[this.options.offset]
	    }
	    this.group.add(this)
	    this.context.add(this)
	    allWaypoints[this.key] = this
	    keyCounter += 1
	  }
	
	  /* Private */
	  Waypoint.prototype.queueTrigger = function(direction) {
	    this.group.queueTrigger(this, direction)
	  }
	
	  /* Private */
	  Waypoint.prototype.trigger = function(args) {
	    if (!this.enabled) {
	      return
	    }
	    if (this.callback) {
	      this.callback.apply(this, args)
	    }
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/destroy */
	  Waypoint.prototype.destroy = function() {
	    this.context.remove(this)
	    this.group.remove(this)
	    delete allWaypoints[this.key]
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/disable */
	  Waypoint.prototype.disable = function() {
	    this.enabled = false
	    return this
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/enable */
	  Waypoint.prototype.enable = function() {
	    this.context.refresh()
	    this.enabled = true
	    return this
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/next */
	  Waypoint.prototype.next = function() {
	    return this.group.next(this)
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/previous */
	  Waypoint.prototype.previous = function() {
	    return this.group.previous(this)
	  }
	
	  /* Private */
	  Waypoint.invokeAll = function(method) {
	    var allWaypointsArray = []
	    for (var waypointKey in allWaypoints) {
	      allWaypointsArray.push(allWaypoints[waypointKey])
	    }
	    for (var i = 0, end = allWaypointsArray.length; i < end; i++) {
	      allWaypointsArray[i][method]()
	    }
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/destroy-all */
	  Waypoint.destroyAll = function() {
	    Waypoint.invokeAll('destroy')
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/disable-all */
	  Waypoint.disableAll = function() {
	    Waypoint.invokeAll('disable')
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/enable-all */
	  Waypoint.enableAll = function() {
	    Waypoint.Context.refreshAll()
	    for (var waypointKey in allWaypoints) {
	      allWaypoints[waypointKey].enabled = true
	    }
	    return this
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/refresh-all */
	  Waypoint.refreshAll = function() {
	    Waypoint.Context.refreshAll()
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/viewport-height */
	  Waypoint.viewportHeight = function() {
	    return window.innerHeight || document.documentElement.clientHeight
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/viewport-width */
	  Waypoint.viewportWidth = function() {
	    return document.documentElement.clientWidth
	  }
	
	  Waypoint.adapters = []
	
	  Waypoint.defaults = {
	    context: window,
	    continuous: true,
	    enabled: true,
	    group: 'default',
	    horizontal: false,
	    offset: 0
	  }
	
	  Waypoint.offsetAliases = {
	    'bottom-in-view': function() {
	      return this.context.innerHeight() - this.adapter.outerHeight()
	    },
	    'right-in-view': function() {
	      return this.context.innerWidth() - this.adapter.outerWidth()
	    }
	  }
	
	  window.Waypoint = Waypoint
	}())
	;(function() {
	  'use strict'
	
	  function requestAnimationFrameShim(callback) {
	    window.setTimeout(callback, 1000 / 60)
	  }
	
	  var keyCounter = 0
	  var contexts = {}
	  var Waypoint = window.Waypoint
	  var oldWindowLoad = window.onload
	
	  /* http://imakewebthings.com/waypoints/api/context */
	  function Context(element) {
	    this.element = element
	    this.Adapter = Waypoint.Adapter
	    this.adapter = new this.Adapter(element)
	    this.key = 'waypoint-context-' + keyCounter
	    this.didScroll = false
	    this.didResize = false
	    this.oldScroll = {
	      x: this.adapter.scrollLeft(),
	      y: this.adapter.scrollTop()
	    }
	    this.waypoints = {
	      vertical: {},
	      horizontal: {}
	    }
	
	    element.waypointContextKey = this.key
	    contexts[element.waypointContextKey] = this
	    keyCounter += 1
	    if (!Waypoint.windowContext) {
	      Waypoint.windowContext = true
	      Waypoint.windowContext = new Context(window)
	    }
	
	    this.createThrottledScrollHandler()
	    this.createThrottledResizeHandler()
	  }
	
	  /* Private */
	  Context.prototype.add = function(waypoint) {
	    var axis = waypoint.options.horizontal ? 'horizontal' : 'vertical'
	    this.waypoints[axis][waypoint.key] = waypoint
	    this.refresh()
	  }
	
	  /* Private */
	  Context.prototype.checkEmpty = function() {
	    var horizontalEmpty = this.Adapter.isEmptyObject(this.waypoints.horizontal)
	    var verticalEmpty = this.Adapter.isEmptyObject(this.waypoints.vertical)
	    var isWindow = this.element == this.element.window
	    if (horizontalEmpty && verticalEmpty && !isWindow) {
	      this.adapter.off('.waypoints')
	      delete contexts[this.key]
	    }
	  }
	
	  /* Private */
	  Context.prototype.createThrottledResizeHandler = function() {
	    var self = this
	
	    function resizeHandler() {
	      self.handleResize()
	      self.didResize = false
	    }
	
	    this.adapter.on('resize.waypoints', function() {
	      if (!self.didResize) {
	        self.didResize = true
	        Waypoint.requestAnimationFrame(resizeHandler)
	      }
	    })
	  }
	
	  /* Private */
	  Context.prototype.createThrottledScrollHandler = function() {
	    var self = this
	    function scrollHandler() {
	      self.handleScroll()
	      self.didScroll = false
	    }
	
	    this.adapter.on('scroll.waypoints', function() {
	      if (!self.didScroll || Waypoint.isTouch) {
	        self.didScroll = true
	        Waypoint.requestAnimationFrame(scrollHandler)
	      }
	    })
	  }
	
	  /* Private */
	  Context.prototype.handleResize = function() {
	    Waypoint.Context.refreshAll()
	  }
	
	  /* Private */
	  Context.prototype.handleScroll = function() {
	    var triggeredGroups = {}
	    var axes = {
	      horizontal: {
	        newScroll: this.adapter.scrollLeft(),
	        oldScroll: this.oldScroll.x,
	        forward: 'right',
	        backward: 'left'
	      },
	      vertical: {
	        newScroll: this.adapter.scrollTop(),
	        oldScroll: this.oldScroll.y,
	        forward: 'down',
	        backward: 'up'
	      }
	    }
	
	    for (var axisKey in axes) {
	      var axis = axes[axisKey]
	      var isForward = axis.newScroll > axis.oldScroll
	      var direction = isForward ? axis.forward : axis.backward
	
	      for (var waypointKey in this.waypoints[axisKey]) {
	        var waypoint = this.waypoints[axisKey][waypointKey]
	        if (waypoint.triggerPoint === null) {
	          continue
	        }
	        var wasBeforeTriggerPoint = axis.oldScroll < waypoint.triggerPoint
	        var nowAfterTriggerPoint = axis.newScroll >= waypoint.triggerPoint
	        var crossedForward = wasBeforeTriggerPoint && nowAfterTriggerPoint
	        var crossedBackward = !wasBeforeTriggerPoint && !nowAfterTriggerPoint
	        if (crossedForward || crossedBackward) {
	          waypoint.queueTrigger(direction)
	          triggeredGroups[waypoint.group.id] = waypoint.group
	        }
	      }
	    }
	
	    for (var groupKey in triggeredGroups) {
	      triggeredGroups[groupKey].flushTriggers()
	    }
	
	    this.oldScroll = {
	      x: axes.horizontal.newScroll,
	      y: axes.vertical.newScroll
	    }
	  }
	
	  /* Private */
	  Context.prototype.innerHeight = function() {
	    /*eslint-disable eqeqeq */
	    if (this.element == this.element.window) {
	      return Waypoint.viewportHeight()
	    }
	    /*eslint-enable eqeqeq */
	    return this.adapter.innerHeight()
	  }
	
	  /* Private */
	  Context.prototype.remove = function(waypoint) {
	    delete this.waypoints[waypoint.axis][waypoint.key]
	    this.checkEmpty()
	  }
	
	  /* Private */
	  Context.prototype.innerWidth = function() {
	    /*eslint-disable eqeqeq */
	    if (this.element == this.element.window) {
	      return Waypoint.viewportWidth()
	    }
	    /*eslint-enable eqeqeq */
	    return this.adapter.innerWidth()
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/context-destroy */
	  Context.prototype.destroy = function() {
	    var allWaypoints = []
	    for (var axis in this.waypoints) {
	      for (var waypointKey in this.waypoints[axis]) {
	        allWaypoints.push(this.waypoints[axis][waypointKey])
	      }
	    }
	    for (var i = 0, end = allWaypoints.length; i < end; i++) {
	      allWaypoints[i].destroy()
	    }
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/context-refresh */
	  Context.prototype.refresh = function() {
	    /*eslint-disable eqeqeq */
	    var isWindow = this.element == this.element.window
	    /*eslint-enable eqeqeq */
	    var contextOffset = isWindow ? undefined : this.adapter.offset()
	    var triggeredGroups = {}
	    var axes
	
	    this.handleScroll()
	    axes = {
	      horizontal: {
	        contextOffset: isWindow ? 0 : contextOffset.left,
	        contextScroll: isWindow ? 0 : this.oldScroll.x,
	        contextDimension: this.innerWidth(),
	        oldScroll: this.oldScroll.x,
	        forward: 'right',
	        backward: 'left',
	        offsetProp: 'left'
	      },
	      vertical: {
	        contextOffset: isWindow ? 0 : contextOffset.top,
	        contextScroll: isWindow ? 0 : this.oldScroll.y,
	        contextDimension: this.innerHeight(),
	        oldScroll: this.oldScroll.y,
	        forward: 'down',
	        backward: 'up',
	        offsetProp: 'top'
	      }
	    }
	
	    for (var axisKey in axes) {
	      var axis = axes[axisKey]
	      for (var waypointKey in this.waypoints[axisKey]) {
	        var waypoint = this.waypoints[axisKey][waypointKey]
	        var adjustment = waypoint.options.offset
	        var oldTriggerPoint = waypoint.triggerPoint
	        var elementOffset = 0
	        var freshWaypoint = oldTriggerPoint == null
	        var contextModifier, wasBeforeScroll, nowAfterScroll
	        var triggeredBackward, triggeredForward
	
	        if (waypoint.element !== waypoint.element.window) {
	          elementOffset = waypoint.adapter.offset()[axis.offsetProp]
	        }
	
	        if (typeof adjustment === 'function') {
	          adjustment = adjustment.apply(waypoint)
	        }
	        else if (typeof adjustment === 'string') {
	          adjustment = parseFloat(adjustment)
	          if (waypoint.options.offset.indexOf('%') > - 1) {
	            adjustment = Math.ceil(axis.contextDimension * adjustment / 100)
	          }
	        }
	
	        contextModifier = axis.contextScroll - axis.contextOffset
	        waypoint.triggerPoint = Math.floor(elementOffset + contextModifier - adjustment)
	        wasBeforeScroll = oldTriggerPoint < axis.oldScroll
	        nowAfterScroll = waypoint.triggerPoint >= axis.oldScroll
	        triggeredBackward = wasBeforeScroll && nowAfterScroll
	        triggeredForward = !wasBeforeScroll && !nowAfterScroll
	
	        if (!freshWaypoint && triggeredBackward) {
	          waypoint.queueTrigger(axis.backward)
	          triggeredGroups[waypoint.group.id] = waypoint.group
	        }
	        else if (!freshWaypoint && triggeredForward) {
	          waypoint.queueTrigger(axis.forward)
	          triggeredGroups[waypoint.group.id] = waypoint.group
	        }
	        else if (freshWaypoint && axis.oldScroll >= waypoint.triggerPoint) {
	          waypoint.queueTrigger(axis.forward)
	          triggeredGroups[waypoint.group.id] = waypoint.group
	        }
	      }
	    }
	
	    Waypoint.requestAnimationFrame(function() {
	      for (var groupKey in triggeredGroups) {
	        triggeredGroups[groupKey].flushTriggers()
	      }
	    })
	
	    return this
	  }
	
	  /* Private */
	  Context.findOrCreateByElement = function(element) {
	    return Context.findByElement(element) || new Context(element)
	  }
	
	  /* Private */
	  Context.refreshAll = function() {
	    for (var contextId in contexts) {
	      contexts[contextId].refresh()
	    }
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/context-find-by-element */
	  Context.findByElement = function(element) {
	    return contexts[element.waypointContextKey]
	  }
	
	  window.onload = function() {
	    if (oldWindowLoad) {
	      oldWindowLoad()
	    }
	    Context.refreshAll()
	  }
	
	
	  Waypoint.requestAnimationFrame = function(callback) {
	    var requestFn = window.requestAnimationFrame ||
	      window.mozRequestAnimationFrame ||
	      window.webkitRequestAnimationFrame ||
	      requestAnimationFrameShim
	    requestFn.call(window, callback)
	  }
	  Waypoint.Context = Context
	}())
	;(function() {
	  'use strict'
	
	  function byTriggerPoint(a, b) {
	    return a.triggerPoint - b.triggerPoint
	  }
	
	  function byReverseTriggerPoint(a, b) {
	    return b.triggerPoint - a.triggerPoint
	  }
	
	  var groups = {
	    vertical: {},
	    horizontal: {}
	  }
	  var Waypoint = window.Waypoint
	
	  /* http://imakewebthings.com/waypoints/api/group */
	  function Group(options) {
	    this.name = options.name
	    this.axis = options.axis
	    this.id = this.name + '-' + this.axis
	    this.waypoints = []
	    this.clearTriggerQueues()
	    groups[this.axis][this.name] = this
	  }
	
	  /* Private */
	  Group.prototype.add = function(waypoint) {
	    this.waypoints.push(waypoint)
	  }
	
	  /* Private */
	  Group.prototype.clearTriggerQueues = function() {
	    this.triggerQueues = {
	      up: [],
	      down: [],
	      left: [],
	      right: []
	    }
	  }
	
	  /* Private */
	  Group.prototype.flushTriggers = function() {
	    for (var direction in this.triggerQueues) {
	      var waypoints = this.triggerQueues[direction]
	      var reverse = direction === 'up' || direction === 'left'
	      waypoints.sort(reverse ? byReverseTriggerPoint : byTriggerPoint)
	      for (var i = 0, end = waypoints.length; i < end; i += 1) {
	        var waypoint = waypoints[i]
	        if (waypoint.options.continuous || i === waypoints.length - 1) {
	          waypoint.trigger([direction])
	        }
	      }
	    }
	    this.clearTriggerQueues()
	  }
	
	  /* Private */
	  Group.prototype.next = function(waypoint) {
	    this.waypoints.sort(byTriggerPoint)
	    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
	    var isLast = index === this.waypoints.length - 1
	    return isLast ? null : this.waypoints[index + 1]
	  }
	
	  /* Private */
	  Group.prototype.previous = function(waypoint) {
	    this.waypoints.sort(byTriggerPoint)
	    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
	    return index ? this.waypoints[index - 1] : null
	  }
	
	  /* Private */
	  Group.prototype.queueTrigger = function(waypoint, direction) {
	    this.triggerQueues[direction].push(waypoint)
	  }
	
	  /* Private */
	  Group.prototype.remove = function(waypoint) {
	    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
	    if (index > -1) {
	      this.waypoints.splice(index, 1)
	    }
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/first */
	  Group.prototype.first = function() {
	    return this.waypoints[0]
	  }
	
	  /* Public */
	  /* http://imakewebthings.com/waypoints/api/last */
	  Group.prototype.last = function() {
	    return this.waypoints[this.waypoints.length - 1]
	  }
	
	  /* Private */
	  Group.findOrCreate = function(options) {
	    return groups[options.axis][options.name] || new Group(options)
	  }
	
	  Waypoint.Group = Group
	}())
	;(function() {
	  'use strict'
	
	  var Waypoint = window.Waypoint
	
	  function isWindow(element) {
	    return element === element.window
	  }
	
	  function getWindow(element) {
	    if (isWindow(element)) {
	      return element
	    }
	    return element.defaultView
	  }
	
	  function NoFrameworkAdapter(element) {
	    this.element = element
	    this.handlers = {}
	  }
	
	  NoFrameworkAdapter.prototype.innerHeight = function() {
	    var isWin = isWindow(this.element)
	    return isWin ? this.element.innerHeight : this.element.clientHeight
	  }
	
	  NoFrameworkAdapter.prototype.innerWidth = function() {
	    var isWin = isWindow(this.element)
	    return isWin ? this.element.innerWidth : this.element.clientWidth
	  }
	
	  NoFrameworkAdapter.prototype.off = function(event, handler) {
	    function removeListeners(element, listeners, handler) {
	      for (var i = 0, end = listeners.length - 1; i < end; i++) {
	        var listener = listeners[i]
	        if (!handler || handler === listener) {
	          element.removeEventListener(listener)
	        }
	      }
	    }
	
	    var eventParts = event.split('.')
	    var eventType = eventParts[0]
	    var namespace = eventParts[1]
	    var element = this.element
	
	    if (namespace && this.handlers[namespace] && eventType) {
	      removeListeners(element, this.handlers[namespace][eventType], handler)
	      this.handlers[namespace][eventType] = []
	    }
	    else if (eventType) {
	      for (var ns in this.handlers) {
	        removeListeners(element, this.handlers[ns][eventType] || [], handler)
	        this.handlers[ns][eventType] = []
	      }
	    }
	    else if (namespace && this.handlers[namespace]) {
	      for (var type in this.handlers[namespace]) {
	        removeListeners(element, this.handlers[namespace][type], handler)
	      }
	      this.handlers[namespace] = {}
	    }
	  }
	
	  /* Adapted from jQuery 1.x offset() */
	  NoFrameworkAdapter.prototype.offset = function() {
	    if (!this.element.ownerDocument) {
	      return null
	    }
	
	    var documentElement = this.element.ownerDocument.documentElement
	    var win = getWindow(this.element.ownerDocument)
	    var rect = {
	      top: 0,
	      left: 0
	    }
	
	    if (this.element.getBoundingClientRect) {
	      rect = this.element.getBoundingClientRect()
	    }
	
	    return {
	      top: rect.top + win.pageYOffset - documentElement.clientTop,
	      left: rect.left + win.pageXOffset - documentElement.clientLeft
	    }
	  }
	
	  NoFrameworkAdapter.prototype.on = function(event, handler) {
	    var eventParts = event.split('.')
	    var eventType = eventParts[0]
	    var namespace = eventParts[1] || '__default'
	    var nsHandlers = this.handlers[namespace] = this.handlers[namespace] || {}
	    var nsTypeList = nsHandlers[eventType] = nsHandlers[eventType] || []
	
	    nsTypeList.push(handler)
	    this.element.addEventListener(eventType, handler)
	  }
	
	  NoFrameworkAdapter.prototype.outerHeight = function(includeMargin) {
	    var height = this.innerHeight()
	    var computedStyle
	
	    if (includeMargin && !isWindow(this.element)) {
	      computedStyle = window.getComputedStyle(this.element)
	      height += parseInt(computedStyle.marginTop, 10)
	      height += parseInt(computedStyle.marginBottom, 10)
	    }
	
	    return height
	  }
	
	  NoFrameworkAdapter.prototype.outerWidth = function(includeMargin) {
	    var width = this.innerWidth()
	    var computedStyle
	
	    if (includeMargin && !isWindow(this.element)) {
	      computedStyle = window.getComputedStyle(this.element)
	      width += parseInt(computedStyle.marginLeft, 10)
	      width += parseInt(computedStyle.marginRight, 10)
	    }
	
	    return width
	  }
	
	  NoFrameworkAdapter.prototype.scrollLeft = function() {
	    var win = getWindow(this.element)
	    return win ? win.pageXOffset : this.element.scrollLeft
	  }
	
	  NoFrameworkAdapter.prototype.scrollTop = function() {
	    var win = getWindow(this.element)
	    return win ? win.pageYOffset : this.element.scrollTop
	  }
	
	  NoFrameworkAdapter.extend = function() {
	    var args = Array.prototype.slice.call(arguments)
	
	    function merge(target, obj) {
	      if (typeof target === 'object' && typeof obj === 'object') {
	        for (var key in obj) {
	          if (obj.hasOwnProperty(key)) {
	            target[key] = obj[key]
	          }
	        }
	      }
	
	      return target
	    }
	
	    for (var i = 1, end = args.length; i < end; i++) {
	      merge(args[0], args[i])
	    }
	    return args[0]
	  }
	
	  NoFrameworkAdapter.inArray = function(element, array, i) {
	    return array == null ? -1 : array.indexOf(element, i)
	  }
	
	  NoFrameworkAdapter.isEmptyObject = function(obj) {
	    /* eslint no-unused-vars: 0 */
	    for (var name in obj) {
	      return false
	    }
	    return true
	  }
	
	  Waypoint.adapters.push({
	    name: 'noframework',
	    Adapter: NoFrameworkAdapter
	  })
	  Waypoint.Adapter = NoFrameworkAdapter
	}())
	;
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = Waypoint;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _smoothScroll = __webpack_require__(31);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Terren Select component.
	 * @author Dayne Coulson-Hoffacker
	 */
	var TerrenSelect =
	/**
	 * Constructs a new scroll TerrenSelect instance.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function TerrenSelect(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, TerrenSelect);
	
	  this.element = options.element;
	  this.scrollTarget = document.body.querySelector('.frm_forms');
	  this.scrollBtns = this.element.queryAll('.frm_submit button');
	  this.scroll = new _smoothScroll2.default();
	  this.scrollOptions = {
	    speed: 750,
	    updateURL: false,
	    offset: 32,
	    header: '[data-component="global-header"]'
	  };
	
	  this.scrollBtns.forEach(function (element) {
	    element.addEventListener('click', function () {
	      _this.scroll.animateScroll(_this.scrollTarget, element, _this.scrollOptions);
	    });
	  });
	};
	
	exports.default = TerrenSelect;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js